exports["flintapp-positiverelating"] = function(Flint,opts){(function(Flint){var _Symbol$iterator=require('babel-runtime/core-js/symbol/iterator').default;

var _Object$assign=require('babel-runtime/core-js/object/assign').default;

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('mframework/decoratorFramework.js',function(require){
'use strict';

var _immutable=require('immutable');

var _immutable2=_interopRequireDefault(_immutable);

var _derivable=require('derivable');

window.immutable = _immutable2.default;
window.Record = _immutable2.default.Record;
window.List = _immutable2.default.List;
window.IMap = _immutable2.default.Map;
window.atom = _derivable.atom;
window.isDerivable = _derivable.isDerivable;
window.derivation = _derivable.derivation;
window.transact = _derivable.transact;
window.lens = _derivable.lens;

window.initPro = function(view,pro){
view.pro = pro;
if(!view.pro.style){
view.pro.style = M.mergeAtom({});}

if(!view.pro.children){
view.pro.children = (0,_derivable.atom)();}

for(var propName in view.pro) {
// Tag the pro atom/lens with its propName for debugging
view.pro[propName].name = view.name + '.' + propName;}


view._derivableProps = {};
view._derivablePropReactors = {};

var _loop=function(propName){
if(view.pro[propName]){
if((0,_derivable.isDerivable)(view.props[propName])){
view._derivableProps[propName] = view.props[propName];
view._derivablePropReactors[propName] = view.props[propName].reactor(function(propValue){
return view.pro[propName].set(propValue);});

view._derivablePropReactors[propName].start().force();}else 
{
view.pro[propName].set(view.props[propName]);}}};




for(var propName in view.props) {
_loop(propName);}


return view.pro;};


window.initContext = function(view,context){
view.mContext = context;
for(var contextName in M.context) {
view.mContext[contextName] = view.mContext[contextName] || (0,_derivable.atom)();
view.mContext[contextName].name = view.name + '.mContext.' + contextName;}

view.props.mContext.forEach(function(contextValue,contextName){
view.mContext[contextName].set(contextValue);});

return view.mContext;};


window.initData = function(view,data){
view._data = data;
view.data = {};

var _loop2=function(dataKey){
// Shorthand for quickly mapping a Firebase ref into an atom
if(typeof view._data[dataKey] == 'function' || view._data[dataKey] instanceof Array){
view._data[dataKey] = {
ref:view._data[dataKey],
value:true};}



view.data[dataKey] = (0,_derivable.atom)();

view._data[dataKey].derPathParts = (0,_derivable.derivation)(function(){
if(typeof view._data[dataKey].ref == 'function'){
var pathParts=view._data[dataKey].ref();
if(!pathParts || pathParts.findIndex(function(pp){
return pp === undefined;}) >= 
0){
return undefined;}else 
if(pathParts.findIndex(function(pp){
return !pp;}) >= 
0){
throw new Error('Invalid path part for ' + view.name + '.data.' + dataKey + ':' + (' ' + JSON.stringify(pathParts)));}else 
{
return List(pathParts);}}else 

{
return List(view._data[dataKey].ref);}});



view._data[dataKey].handlers = {}; // eventType: handler

view._data[dataKey].refReactor = view._data[dataKey].derPathParts.reactor(function(pathParts){
var oldRef=view._data[dataKey].oldRef;

var _loop4=function(eventType){
var handler=view._data[dataKey].handlers[eventType];
oldRef.off(eventType,handler);
delete view._data[dataKey].handlers[eventType];

// Bookkeeping for debugging
var refKey=oldRef.toString().replace(/^.*firebaseio.com\//,'');
var i=M._refs[refKey].findIndex(function(log){
return log.eventType == eventType && log.handler == handler;});

M._refs[refKey].splice(i,1);
if(M._refs[refKey].length == 0){
delete M._refs[refKey];}

// console.debug(`*off ${view.name} ${refKey} ${eventType}`)
};

for(var eventType in view._data[dataKey].handlers) {
_loop4(eventType);}


view.data[dataKey].set(undefined);

var refOptions=view._data[dataKey].refOptions || function(ref){
return ref;};


var ref=pathParts?refOptions(M.ref.child(pathParts.join('/'))):null;

view._data[dataKey].oldRef = ref;

if(!ref)return;

var _loop5=function(eventType){
if(['value','child_added','child_changed','child_moved','child_removed'].indexOf(eventType) >= 0){
var handler=ref.on(eventType,function(snapshot,prevChildKey){
if(eventType == 'value' && view._data[dataKey][eventType] === true){
view.data[dataKey].set(snapshot.val());}else 
{
var returnValue=view._data[dataKey][eventType](snapshot,prevChildKey);

if(eventType == 'value'){
view.data[dataKey].set(returnValue);}}});




// Bookkeeping for debugging
var refKey=ref.toString().replace(/^.*firebaseio.com\//,'');
M._refs[refKey] = M._refs[refKey] || [];
M._refs[refKey].push({viewName:view.name,view:view,eventType:eventType,handler:handler});
// console.debug(`on ${view.name}#${view.id} ${refKey} ${eventType}`)

view._data[dataKey].handlers[eventType] = handler;}};



for(var eventType in view._data[dataKey]) {
_loop5(eventType);}}).

start().force();};


for(var dataKey in view._data) {
_loop2(dataKey);}


view.on.unmount(function(){
if(view.debug){
console.log(view.name + '#' + view.id + ' on.unmount');}


for(var dataKey in view._data) {
view._data[dataKey].refReactor.stop();

var oldRef=view._data[dataKey].oldRef;

var _loop3=function(eventType){
var handler=view._data[dataKey].handlers[eventType];
oldRef.off(eventType,handler);
delete view._data[dataKey].handlers[eventType];

// Bookkeeping for debugging
var refKey=oldRef.toString().replace(/^.*firebaseio.com\//,'');
var i=M._refs[refKey].findIndex(function(log){
return log.eventType == eventType && log.handler == handler;});

M._refs[refKey].splice(i,1);
if(M._refs[refKey].length == 0){
delete M._refs[refKey];}

// console.debug(`off ${view.name}#${view.id} ${refKey} ${eventType}`)
};

for(var eventType in view._data[dataKey].handlers) {
_loop3(eventType);}}});




return view.data;};


var nextId=0;
window.views = {};

var decorator=function decorator(view){
if(['Installer','Modal','Menu','Errors'].indexOf(view.name) >= 0){
// Ignore special Flint components
return;}


nextId += 1;
view.id = nextId;

view._syncUpdate = view.update;
view._asyncUpdate = function(){
if(view._willUpdate)return;
view._willUpdate = true;

setTimeout(function(){
view._syncUpdate();
view._willUpdate = false;},
1);};

view.update = function(){
// The only place that calls this is Flint's rerendering pathway, which
// we want to turn into a no-op because we have our own rerendering
// pathway
if(view.debug){
console.info('Flint tried to call view.update on',view.name);}};



if(!view.pro){
initPro(view,{});}


if(view.name != 'Main' && !view.mContext){
initContext(view,{});}


var addContextToTree=function addContextToTree(tree){
var contextValues=undefined;
if(view.name == 'Main'){
contextValues = {};
for(var contextName in M.context) {
contextValues[contextName] = M.context[contextName].get();}

contextValues = IMap(contextValues);}else 
{
contextValues = view.props.mContext;}


if(tree instanceof Array || tree && typeof tree == 'object' && (tree instanceof List || window.Symbol && tree[_Symbol$iterator])){
return tree.map(addContextToTree);}else 
if(tree && typeof tree == 'object'){
var newTree=_Object$assign({},tree);
newTree.props = _Object$assign({mContext:contextValues},newTree.props);
if(newTree.props.children){
newTree.props.children = addContextToTree(newTree.props.children);}

return newTree;}else 
{
return tree;}};



var contentMakers=view.renders.length?view.renders:[
// We need at least one fake render to do the auto-style-dependency-tracking
// below. Flint's RadiumEnhancer code gets weird about one render function
// returning null so we'll make two.
function(){
return null;},
function(){
return null;}];

var NOT_RENDERING_YET={};

var renderDerivations=contentMakers.map(function(contentMaker,i){
var renderDerivationI=(0,_derivable.derivation)(function(){
if(view.isRendering){
if(view.debug){
console.log('Render ' + view.name + '#' + view.id + '[' + i + ']');}


var tree=contentMaker.call(view);

// In case contentMaker never calls pro.style.get(), call it here to
// register the dependency that the view's container needs to rerender
// when the parent changes its style.
view.pro.style.get();

if(view.debug){
console.log('Add context to ' + view.name + '#' + view.id + '[' + i + ']',tree);}


// Call these getters to set up a dependency between every component's
// render function and its view of the context.
for(var contextName in M.context) {
if(view.name == 'Main'){
M.context[contextName].get();}else 
{
view.mContext[contextName].get();}}



return addContextToTree(tree);}else 
{
if(view.debug){
console.log('Premature ' + view.name + '#' + view.id + '[' + i + ']');}

renderDerivationI.fakeEntropy.get();
view._asyncUpdate();
return NOT_RENDERING_YET;}});



renderDerivationI.fakeEntropy = (0,_derivable.atom)(0);

return renderDerivationI;});


view.renders = renderDerivations.map(function(d,i){
return function(){
var dValue=d.get();
var tree=undefined;
if(dValue === NOT_RENDERING_YET){
d.fakeEntropy.set(d.fakeEntropy.get() + 1);
tree = d.get();}else 
{
tree = dValue;}

if(view.debug){
console.log('Tree for ' + view.name + '#' + view.id + '[' + i + ']',tree);}

return tree;};});



var renderReactors=renderDerivations.map(function(d,i){
return d.reactor(function(){
view._asyncUpdate();});});



view.on.mount(function(){
window.views[view.id] = view;
renderReactors.forEach(function(reactor){
return reactor.start();});});



view.on.unmount(function(){
renderReactors.forEach(function(reactor){
return reactor.stop();});

delete window.views[view.id];});


view.on.props(function(){
if(view.debug){
console.info(view.name,view.id,'on props',view.props,view.isRendering,view.mounted);}


// Update view.pro atoms
if(!view.mounted){
if(!view.firstRender && view.debug){
console.log('Ignoring ' + view.name + '#' + view.id + '.on.props');}

return;}


(0,_derivable.transact)(function(){
if(view.pro){
var _loop6=function(propName){
if(view.pro[propName]){
var oldDerivable=view._derivableProps[propName];

if(oldDerivable && view.props[propName] === oldDerivable){
// No-op
}else 
{
if(oldDerivable){
view._derivablePropReactors[propName].stop();
delete view._derivablePropReactors[propName];
delete view._derivableProps[propName];}


if((0,_derivable.isDerivable)(view.props[propName])){
view._derivableProps[propName] = view.props[propName];
view._derivablePropReactors[propName] = view.props[propName].reactor(function(propValue){
return view.pro[propName].set(propValue);});

view._derivablePropReactors[propName].start().force();}else 
{
view.pro[propName].set(view.props[propName]);}}}};





for(var propName in view.props) {
_loop6(propName);}}


if(view.mContext){
view.props.mContext.forEach(function(contextValue,contextName){
if(contextName in view.mContext){
if(view.debug){
console.log('Set context on ' + view.name + '#' + view.id + ': ' + (contextName + '=' + JSON.stringify(contextValue)));}

view.mContext[contextName].set(contextValue);}});}});});






view.shouldUpdate(function(){
return false;});


view.findId = function(elemId){
var domNode=ReactDOM.findDOMNode(view);
return domNode.getElementsByTagName(elemId)[0] || domNode.getElementsByClassName(elemId)[0];};};



Flint._onViewInstance(decorator);});})();


//# sourceMappingURL=decoratorFramework.js.map

var _Object$keys=require('babel-runtime/core-js/object/keys').default;

var _Object$create=require('babel-runtime/core-js/object/create').default;

(function(){
Flint.file('mframework/lib/hammer.js',function(require){
/*! Hammer.JS - v2.0.4 - 2014-09-28
         * http://hammerjs.github.io/
         *
         * Copyright (c) 2014 Jorik Tangelder;
         * Licensed under the MIT license */
(function(window,document,exportName,undefined){
'use strict';

var VENDOR_PREFIXES=['','webkit','moz','MS','ms','o'];
var TEST_ELEMENT=document.createElement('div');

var TYPE_FUNCTION='function';

var round=Math.round;
var abs=Math.abs;
var now=Date.now;

/**
             * set a timeout with a given scope
             * @param {Function} fn
             * @param {Number} timeout
             * @param {Object} context
             * @returns {number}
             */
function setTimeoutContext(fn,timeout,context){
return setTimeout(bindFn(fn,context),timeout);}


/**
             * if the argument is an array, we want to execute the fn on each entry
             * if it aint an array we don't want to do a thing.
             * this is used by all the methods that accept a single and array argument.
             * @param {*|Array} arg
             * @param {String} fn
             * @param {Object} [context]
             * @returns {Boolean}
             */
function invokeArrayArg(arg,fn,context){
if(Array.isArray(arg)){
each(arg,context[fn],context);
return true;}

return false;}


/**
             * walk objects and arrays
             * @param {Object} obj
             * @param {Function} iterator
             * @param {Object} context
             */
function each(obj,iterator,context){
var i;

if(!obj){
return;}


if(obj.forEach){
obj.forEach(iterator,context);}else 
if(obj.length !== undefined){
i = 0;
while(i < obj.length) {
iterator.call(context,obj[i],i,obj);
i++;}}else 

{
for(i in obj) {
obj.hasOwnProperty(i) && iterator.call(context,obj[i],i,obj);}}}




/**
             * extend object.
             * means that properties in dest will be overwritten by the ones in src.
             * @param {Object} dest
             * @param {Object} src
             * @param {Boolean} [merge]
             * @returns {Object} dest
             */
function extend(dest,src,merge){
var keys=_Object$keys(src);
var i=0;
while(i < keys.length) {
if(!merge || merge && dest[keys[i]] === undefined){
dest[keys[i]] = src[keys[i]];}

i++;}

return dest;}


/**
             * merge the values from src in the dest.
             * means that properties that exist in dest will not be overwritten by src
             * @param {Object} dest
             * @param {Object} src
             * @returns {Object} dest
             */
function merge(dest,src){
return extend(dest,src,true);}


/**
             * simple class inheritance
             * @param {Function} child
             * @param {Function} base
             * @param {Object} [properties]
             */
function inherit(child,base,properties){
var baseP=base.prototype,
childP;

childP = child.prototype = _Object$create(baseP);
childP.constructor = child;
childP._super = baseP;

if(properties){
extend(childP,properties);}}



/**
             * simple function bind
             * @param {Function} fn
             * @param {Object} context
             * @returns {Function}
             */
function bindFn(fn,context){
return function boundFn(){
return fn.apply(context,arguments);};}



/**
             * let a boolean value also be a function that must return a boolean
             * this first item in args will be used as the context
             * @param {Boolean|Function} val
             * @param {Array} [args]
             * @returns {Boolean}
             */
function boolOrFn(val,args){
if(typeof val == TYPE_FUNCTION){
return val.apply(args?args[0] || undefined:undefined,args);}

return val;}


/**
             * use the val2 when val1 is undefined
             * @param {*} val1
             * @param {*} val2
             * @returns {*}
             */
function ifUndefined(val1,val2){
return val1 === undefined?val2:val1;}


/**
             * addEventListener with multiple events at once
             * @param {EventTarget} target
             * @param {String} types
             * @param {Function} handler
             */
function addEventListeners(target,types,handler){
each(splitStr(types),function(type){
target.addEventListener(type,handler,false);});}



/**
             * removeEventListener with multiple events at once
             * @param {EventTarget} target
             * @param {String} types
             * @param {Function} handler
             */
function removeEventListeners(target,types,handler){
each(splitStr(types),function(type){
target.removeEventListener(type,handler,false);});}



/**
             * find if a node is in the given parent
             * @method hasParent
             * @param {HTMLElement} node
             * @param {HTMLElement} parent
             * @return {Boolean} found
             */
function hasParent(node,parent){
while(node) {
if(node == parent){
return true;}

node = node.parentNode;}

return false;}


/**
             * small indexOf wrapper
             * @param {String} str
             * @param {String} find
             * @returns {Boolean} found
             */
function inStr(str,find){
return str.indexOf(find) > -1;}


/**
             * split string on whitespace
             * @param {String} str
             * @returns {Array} words
             */
function splitStr(str){
return str.trim().split(/\s+/g);}


/**
             * find if a array contains the object using indexOf or a simple polyFill
             * @param {Array} src
             * @param {String} find
             * @param {String} [findByKey]
             * @return {Boolean|Number} false when not found, or the index
             */
function inArray(src,find,findByKey){
if(src.indexOf && !findByKey){
return src.indexOf(find);}else 
{
var i=0;
while(i < src.length) {
if(findByKey && src[i][findByKey] == find || !findByKey && src[i] === find){
return i;}

i++;}

return -1;}}



/**
             * convert array-like objects to real arrays
             * @param {Object} obj
             * @returns {Array}
             */
function toArray(obj){
return Array.prototype.slice.call(obj,0);}


/**
             * unique array with objects based on a key (like 'id') or just by the array's value
             * @param {Array} src [{id:1},{id:2},{id:1}]
             * @param {String} [key]
             * @param {Boolean} [sort=False]
             * @returns {Array} [{id:1},{id:2}]
             */
function uniqueArray(src,key,sort){
var results=[];
var values=[];
var i=0;

while(i < src.length) {
var val=key?src[i][key]:src[i];
if(inArray(values,val) < 0){
results.push(src[i]);}

values[i] = val;
i++;}


if(sort){
if(!key){
results = results.sort();}else 
{
results = results.sort(function sortUniqueArray(a,b){
return a[key] > b[key];});}}




return results;}


/**
             * get the prefixed property
             * @param {Object} obj
             * @param {String} property
             * @returns {String|Undefined} prefixed
             */
function prefixed(obj,property){
var prefix,pro;
var camelProp=property[0].toUpperCase() + property.slice(1);

var i=0;
while(i < VENDOR_PREFIXES.length) {
prefix = VENDOR_PREFIXES[i];
pro = prefix?prefix + camelProp:property;

if(pro in obj){
return pro;}

i++;}

return undefined;}


/**
             * get a unique id
             * @returns {number} uniqueId
             */
var _uniqueId=1;
function uniqueId(){
return _uniqueId++;}


/**
             * get the window object of an element
             * @param {HTMLElement} element
             * @returns {DocumentView|Window}
             */
function getWindowForElement(element){
var doc=element.ownerDocument;
return doc.defaultView || doc.parentWindow;}


var MOBILE_REGEX=/mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH=('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS=prefixed(window,'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH=SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH='touch';
var INPUT_TYPE_PEN='pen';
var INPUT_TYPE_MOUSE='mouse';
var INPUT_TYPE_KINECT='kinect';

var COMPUTE_INTERVAL=25;

var INPUT_START=1;
var INPUT_MOVE=2;
var INPUT_END=4;
var INPUT_CANCEL=8;

var DIRECTION_NONE=1;
var DIRECTION_LEFT=2;
var DIRECTION_RIGHT=4;
var DIRECTION_UP=8;
var DIRECTION_DOWN=16;

var DIRECTION_HORIZONTAL=DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL=DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL=DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY=['x','y'];
var PROPS_CLIENT_XY=['clientX','clientY'];

/**
             * create new input type manager
             * @param {Manager} manager
             * @param {Function} callback
             * @returns {Input}
             * @constructor
             */
function Input(manager,callback){
var self=this;
this.manager = manager;
this.callback = callback;
this.element = manager.element;
this.target = manager.options.inputTarget;

// smaller wrapper around the handler, for the scope and the enabled state of the manager,
// so when disabled the input events are completely bypassed.
this.domHandler = function(ev){
if(boolOrFn(manager.options.enable,[manager])){
self.handler(ev);}};



this.init();}


Input.prototype = {
/**
                 * should handle the inputEvent data and trigger the callback
                 * @virtual
                 */
handler:function handler(){},

/**
                 * bind the events
                 */
init:function init(){
this.evEl && addEventListeners(this.element,this.evEl,this.domHandler);
this.evTarget && addEventListeners(this.target,this.evTarget,this.domHandler);
this.evWin && addEventListeners(getWindowForElement(this.element),this.evWin,this.domHandler);},


/**
                 * unbind the events
                 */
destroy:function destroy(){
this.evEl && removeEventListeners(this.element,this.evEl,this.domHandler);
this.evTarget && removeEventListeners(this.target,this.evTarget,this.domHandler);
this.evWin && removeEventListeners(getWindowForElement(this.element),this.evWin,this.domHandler);}};



/**
             * create new input type manager
             * called by the Manager constructor
             * @param {Hammer} manager
             * @returns {Input}
             */
function createInputInstance(manager){
var Type;
var inputClass=manager.options.inputClass;

if(inputClass){
Type = inputClass;}else 
if(SUPPORT_POINTER_EVENTS){
Type = PointerEventInput;}else 
if(SUPPORT_ONLY_TOUCH){
Type = TouchInput;}else 
if(!SUPPORT_TOUCH){
Type = MouseInput;}else 
{
Type = TouchMouseInput;}

return new Type(manager,inputHandler);}


/**
             * handle input events
             * @param {Manager} manager
             * @param {String} eventType
             * @param {Object} input
             */
function inputHandler(manager,eventType,input){
var pointersLen=input.pointers.length;
var changedPointersLen=input.changedPointers.length;
var isFirst=eventType & INPUT_START && pointersLen - changedPointersLen === 0;
var isFinal=eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;

input.isFirst = !!isFirst;
input.isFinal = !!isFinal;

if(isFirst){
manager.session = {};}


// source event is the normalized value of the domEvents
// like 'touchstart, mouseup, pointerdown'
input.eventType = eventType;

// compute scale, rotation etc
computeInputData(manager,input);

// emit secret event
manager.emit('hammer.input',input);

manager.recognize(input);
manager.session.prevInput = input;}


/**
             * extend the data with some usable properties like scale, rotate, velocity etc
             * @param {Object} manager
             * @param {Object} input
             */
function computeInputData(manager,input){
var session=manager.session;
var pointers=input.pointers;
var pointersLength=pointers.length;

// store the first input to calculate the distance and direction
if(!session.firstInput){
session.firstInput = simpleCloneInputData(input);}


// to compute scale and rotation we need to store the multiple touches
if(pointersLength > 1 && !session.firstMultiple){
session.firstMultiple = simpleCloneInputData(input);}else 
if(pointersLength === 1){
session.firstMultiple = false;}


var firstInput=session.firstInput;
var firstMultiple=session.firstMultiple;
var offsetCenter=firstMultiple?firstMultiple.center:firstInput.center;

var center=input.center = getCenter(pointers);
input.timeStamp = now();
input.deltaTime = input.timeStamp - firstInput.timeStamp;

input.angle = getAngle(offsetCenter,center);
input.distance = getDistance(offsetCenter,center);

computeDeltaXY(session,input);
input.offsetDirection = getDirection(input.deltaX,input.deltaY);

input.scale = firstMultiple?getScale(firstMultiple.pointers,pointers):1;
input.rotation = firstMultiple?getRotation(firstMultiple.pointers,pointers):0;

computeIntervalInputData(session,input);

// find the correct target
var target=manager.element;
if(hasParent(input.srcEvent.target,target)){
target = input.srcEvent.target;}

input.target = target;}


function computeDeltaXY(session,input){
var center=input.center;
var offset=session.offsetDelta || {};
var prevDelta=session.prevDelta || {};
var prevInput=session.prevInput || {};

if(input.eventType === INPUT_START || prevInput.eventType === INPUT_END){
prevDelta = session.prevDelta = {
x:prevInput.deltaX || 0,
y:prevInput.deltaY || 0};


offset = session.offsetDelta = {
x:center.x,
y:center.y};}



input.deltaX = prevDelta.x + (center.x - offset.x);
input.deltaY = prevDelta.y + (center.y - offset.y);}


/**
             * velocity is calculated every x ms
             * @param {Object} session
             * @param {Object} input
             */
function computeIntervalInputData(session,input){
var last=session.lastInterval || input,
deltaTime=input.timeStamp - last.timeStamp,
velocity,
velocityX,
velocityY,
direction;

if(input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)){
var deltaX=last.deltaX - input.deltaX;
var deltaY=last.deltaY - input.deltaY;

var v=getVelocity(deltaTime,deltaX,deltaY);
velocityX = v.x;
velocityY = v.y;
velocity = abs(v.x) > abs(v.y)?v.x:v.y;
direction = getDirection(deltaX,deltaY);

session.lastInterval = input;}else 
{
// use latest velocity info if it doesn't overtake a minimum period
velocity = last.velocity;
velocityX = last.velocityX;
velocityY = last.velocityY;
direction = last.direction;}


input.velocity = velocity;
input.velocityX = velocityX;
input.velocityY = velocityY;
input.direction = direction;}


/**
             * create a simple clone from the input used for storage of firstInput and firstMultiple
             * @param {Object} input
             * @returns {Object} clonedInputData
             */
function simpleCloneInputData(input){
// make a simple copy of the pointers because we will get a reference if we don't
// we only need clientXY for the calculations
var pointers=[];
var i=0;
while(i < input.pointers.length) {
pointers[i] = {
clientX:round(input.pointers[i].clientX),
clientY:round(input.pointers[i].clientY)};

i++;}


return {
timeStamp:now(),
pointers:pointers,
center:getCenter(pointers),
deltaX:input.deltaX,
deltaY:input.deltaY};}



/**
             * get the center of all the pointers
             * @param {Array} pointers
             * @return {Object} center contains `x` and `y` properties
             */
function getCenter(pointers){
var pointersLength=pointers.length;

// no need to loop when only one touch
if(pointersLength === 1){
return {
x:round(pointers[0].clientX),
y:round(pointers[0].clientY)};}



var x=0,
y=0,
i=0;
while(i < pointersLength) {
x += pointers[i].clientX;
y += pointers[i].clientY;
i++;}


return {
x:round(x / pointersLength),
y:round(y / pointersLength)};}



/**
             * calculate the velocity between two points. unit is in px per ms.
             * @param {Number} deltaTime
             * @param {Number} x
             * @param {Number} y
             * @return {Object} velocity `x` and `y`
             */
function getVelocity(deltaTime,x,y){
return {
x:x / deltaTime || 0,
y:y / deltaTime || 0};}



/**
             * get the direction between two points
             * @param {Number} x
             * @param {Number} y
             * @return {Number} direction
             */
function getDirection(x,y){
if(x === y){
return DIRECTION_NONE;}


if(abs(x) >= abs(y)){
return x > 0?DIRECTION_LEFT:DIRECTION_RIGHT;}

return y > 0?DIRECTION_UP:DIRECTION_DOWN;}


/**
             * calculate the absolute distance between two points
             * @param {Object} p1 {x, y}
             * @param {Object} p2 {x, y}
             * @param {Array} [props] containing x and y keys
             * @return {Number} distance
             */
function getDistance(p1,p2,props){
if(!props){
props = PROPS_XY;}

var x=p2[props[0]] - p1[props[0]],
y=p2[props[1]] - p1[props[1]];

return Math.sqrt(x * x + y * y);}


/**
             * calculate the angle between two coordinates
             * @param {Object} p1
             * @param {Object} p2
             * @param {Array} [props] containing x and y keys
             * @return {Number} angle
             */
function getAngle(p1,p2,props){
if(!props){
props = PROPS_XY;}

var x=p2[props[0]] - p1[props[0]],
y=p2[props[1]] - p1[props[1]];
return Math.atan2(y,x) * 180 / Math.PI;}


/**
             * calculate the rotation degrees between two pointersets
             * @param {Array} start array of pointers
             * @param {Array} end array of pointers
             * @return {Number} rotation
             */
function getRotation(start,end){
return getAngle(end[1],end[0],PROPS_CLIENT_XY) - getAngle(start[1],start[0],PROPS_CLIENT_XY);}


/**
             * calculate the scale factor between two pointersets
             * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
             * @param {Array} start array of pointers
             * @param {Array} end array of pointers
             * @return {Number} scale
             */
function getScale(start,end){
return getDistance(end[0],end[1],PROPS_CLIENT_XY) / getDistance(start[0],start[1],PROPS_CLIENT_XY);}


var MOUSE_INPUT_MAP={
mousedown:INPUT_START,
mousemove:INPUT_MOVE,
mouseup:INPUT_END};


var MOUSE_ELEMENT_EVENTS='mousedown';
var MOUSE_WINDOW_EVENTS='mousemove mouseup';

/**
             * Mouse events input
             * @constructor
             * @extends Input
             */
function MouseInput(){
this.evEl = MOUSE_ELEMENT_EVENTS;
this.evWin = MOUSE_WINDOW_EVENTS;

this.allow = true; // used by Input.TouchMouse to disable mouse events
this.pressed = false; // mousedown state

Input.apply(this,arguments);}


inherit(MouseInput,Input,{
/**
                 * handle mouse events
                 * @param {Object} ev
                 */
handler:function MEhandler(ev){
var eventType=MOUSE_INPUT_MAP[ev.type];

// on start we want to have the left mouse button down
if(eventType & INPUT_START && ev.button === 0){
this.pressed = true;}


if(eventType & INPUT_MOVE && ev.which !== 1){
eventType = INPUT_END;}


// mouse must be down, and mouse events are allowed (see the TouchMouse input)
if(!this.pressed || !this.allow){
return;}


if(eventType & INPUT_END){
this.pressed = false;}


this.callback(this.manager,eventType,{
pointers:[ev],
changedPointers:[ev],
pointerType:INPUT_TYPE_MOUSE,
srcEvent:ev});}});




var POINTER_INPUT_MAP={
pointerdown:INPUT_START,
pointermove:INPUT_MOVE,
pointerup:INPUT_END,
pointercancel:INPUT_CANCEL,
pointerout:INPUT_CANCEL};


// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM={
2:INPUT_TYPE_TOUCH,
3:INPUT_TYPE_PEN,
4:INPUT_TYPE_MOUSE,
5:INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS='pointerdown';
var POINTER_WINDOW_EVENTS='pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if(window.MSPointerEvent){
POINTER_ELEMENT_EVENTS = 'MSPointerDown';
POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';}


/**
             * Pointer events input
             * @constructor
             * @extends Input
             */
function PointerEventInput(){
this.evEl = POINTER_ELEMENT_EVENTS;
this.evWin = POINTER_WINDOW_EVENTS;

Input.apply(this,arguments);

this.store = this.manager.session.pointerEvents = [];}


inherit(PointerEventInput,Input,{
/**
                 * handle mouse events
                 * @param {Object} ev
                 */
handler:function PEhandler(ev){
var store=this.store;
var removePointer=false;

var eventTypeNormalized=ev.type.toLowerCase().replace('ms','');
var eventType=POINTER_INPUT_MAP[eventTypeNormalized];
var pointerType=IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

var isTouch=pointerType == INPUT_TYPE_TOUCH;

// get index of the event in the store
var storeIndex=inArray(store,ev.pointerId,'pointerId');

// start and mouse must be down
if(eventType & INPUT_START && (ev.button === 0 || isTouch)){
if(storeIndex < 0){
store.push(ev);
storeIndex = store.length - 1;}}else 

if(eventType & (INPUT_END | INPUT_CANCEL)){
removePointer = true;}


// it not found, so the pointer hasn't been down (so it's probably a hover)
if(storeIndex < 0){
return;}


// update the event in the store
store[storeIndex] = ev;

this.callback(this.manager,eventType,{
pointers:store,
changedPointers:[ev],
pointerType:pointerType,
srcEvent:ev});


if(removePointer){
// remove from the store
store.splice(storeIndex,1);}}});




var SINGLE_TOUCH_INPUT_MAP={
touchstart:INPUT_START,
touchmove:INPUT_MOVE,
touchend:INPUT_END,
touchcancel:INPUT_CANCEL};


var SINGLE_TOUCH_TARGET_EVENTS='touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS='touchstart touchmove touchend touchcancel';

/**
             * Touch events input
             * @constructor
             * @extends Input
             */
function SingleTouchInput(){
this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
this.started = false;

Input.apply(this,arguments);}


inherit(SingleTouchInput,Input,{
handler:function TEhandler(ev){
var type=SINGLE_TOUCH_INPUT_MAP[ev.type];

// should we handle the touch events?
if(type === INPUT_START){
this.started = true;}


if(!this.started){
return;}


var touches=normalizeSingleTouches.call(this,ev,type);

// when done, reset the started state
if(type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0){
this.started = false;}


this.callback(this.manager,type,{
pointers:touches[0],
changedPointers:touches[1],
pointerType:INPUT_TYPE_TOUCH,
srcEvent:ev});}});




/**
             * @this {TouchInput}
             * @param {Object} ev
             * @param {Number} type flag
             * @returns {undefined|Array} [all, changed]
             */
function normalizeSingleTouches(ev,type){
var all=toArray(ev.touches);
var changed=toArray(ev.changedTouches);

if(type & (INPUT_END | INPUT_CANCEL)){
all = uniqueArray(all.concat(changed),'identifier',true);}


return [all,changed];}


var TOUCH_INPUT_MAP={
touchstart:INPUT_START,
touchmove:INPUT_MOVE,
touchend:INPUT_END,
touchcancel:INPUT_CANCEL};


var TOUCH_TARGET_EVENTS='touchstart touchmove touchend touchcancel';

/**
             * Multi-user touch events input
             * @constructor
             * @extends Input
             */
function TouchInput(){
this.evTarget = TOUCH_TARGET_EVENTS;
this.targetIds = {};

Input.apply(this,arguments);}


inherit(TouchInput,Input,{
handler:function MTEhandler(ev){
var type=TOUCH_INPUT_MAP[ev.type];
var touches=getTouches.call(this,ev,type);
if(!touches){
return;}


this.callback(this.manager,type,{
pointers:touches[0],
changedPointers:touches[1],
pointerType:INPUT_TYPE_TOUCH,
srcEvent:ev});}});




/**
             * @this {TouchInput}
             * @param {Object} ev
             * @param {Number} type flag
             * @returns {undefined|Array} [all, changed]
             */
function getTouches(ev,type){
var allTouches=toArray(ev.touches);
var targetIds=this.targetIds;

// when there is only one touch, the process can be simplified
if(type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1){
targetIds[allTouches[0].identifier] = true;
return [allTouches,allTouches];}


var i,
targetTouches,
changedTouches=toArray(ev.changedTouches),
changedTargetTouches=[],
target=this.target;

// get target touches from touches
targetTouches = allTouches.filter(function(touch){
return hasParent(touch.target,target);});


// collect touches
if(type === INPUT_START){
i = 0;
while(i < targetTouches.length) {
targetIds[targetTouches[i].identifier] = true;
i++;}}



// filter changed touches to only contain touches that exist in the collected target ids
i = 0;
while(i < changedTouches.length) {
if(targetIds[changedTouches[i].identifier]){
changedTargetTouches.push(changedTouches[i]);}


// cleanup removed touches
if(type & (INPUT_END | INPUT_CANCEL)){
delete targetIds[changedTouches[i].identifier];}

i++;}


if(!changedTargetTouches.length){
return;}


return [
// merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
uniqueArray(targetTouches.concat(changedTargetTouches),'identifier',true),changedTargetTouches];}


/**
             * Combined touch and mouse input
             *
             * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
             * This because touch devices also emit mouse events while doing a touch.
             *
             * @constructor
             * @extends Input
             */
function TouchMouseInput(){
Input.apply(this,arguments);

var handler=bindFn(this.handler,this);
this.touch = new TouchInput(this.manager,handler);
this.mouse = new MouseInput(this.manager,handler);}


inherit(TouchMouseInput,Input,{
/**
                 * handle mouse and touch events
                 * @param {Hammer} manager
                 * @param {String} inputEvent
                 * @param {Object} inputData
                 */
handler:function TMEhandler(manager,inputEvent,inputData){
var isTouch=inputData.pointerType == INPUT_TYPE_TOUCH,
isMouse=inputData.pointerType == INPUT_TYPE_MOUSE;

// when we're in a touch event, so  block all upcoming mouse events
// most mobile browser also emit mouseevents, right after touchstart
if(isTouch){
this.mouse.allow = false;}else 
if(isMouse && !this.mouse.allow){
return;}


// reset the allowMouse when we're done
if(inputEvent & (INPUT_END | INPUT_CANCEL)){
this.mouse.allow = true;}


this.callback(manager,inputEvent,inputData);},


/**
                 * remove the event listeners
                 */
destroy:function destroy(){
this.touch.destroy();
this.mouse.destroy();}});



var PREFIXED_TOUCH_ACTION=prefixed(TEST_ELEMENT.style,'touchAction');
var NATIVE_TOUCH_ACTION=PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE='compute';
var TOUCH_ACTION_AUTO='auto';
var TOUCH_ACTION_MANIPULATION='manipulation'; // not implemented
var TOUCH_ACTION_NONE='none';
var TOUCH_ACTION_PAN_X='pan-x';
var TOUCH_ACTION_PAN_Y='pan-y';

/**
             * Touch Action
             * sets the touchAction property or uses the js alternative
             * @param {Manager} manager
             * @param {String} value
             * @constructor
             */
function TouchAction(manager,value){
this.manager = manager;
this.set(value);}


TouchAction.prototype = {
/**
                 * set the touchAction value on the element or enable the polyfill
                 * @param {String} value
                 */
set:function set(value){
// find out the touch-action by the event handlers
if(value == TOUCH_ACTION_COMPUTE){
value = this.compute();}


if(NATIVE_TOUCH_ACTION){
this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;}

this.actions = value.toLowerCase().trim();},


/**
                 * just re-set the touchAction value
                 */
update:function update(){
this.set(this.manager.options.touchAction);},


/**
                 * compute the value for the touchAction property based on the recognizer's settings
                 * @returns {String} value
                 */
compute:function compute(){
var actions=[];
each(this.manager.recognizers,function(recognizer){
if(boolOrFn(recognizer.options.enable,[recognizer])){
actions = actions.concat(recognizer.getTouchAction());}});


return cleanTouchActions(actions.join(' '));},


/**
                 * this method is called on each input cycle and provides the preventing of the browser behavior
                 * @param {Object} input
                 */
preventDefaults:function preventDefaults(input){
// not needed with native support for the touchAction property
if(NATIVE_TOUCH_ACTION){
return;}


var srcEvent=input.srcEvent;
var direction=input.offsetDirection;

// if the touch action did prevented once this session
if(this.manager.session.prevented){
srcEvent.preventDefault();
return;}


var actions=this.actions;
var hasNone=inStr(actions,TOUCH_ACTION_NONE);
var hasPanY=inStr(actions,TOUCH_ACTION_PAN_Y);
var hasPanX=inStr(actions,TOUCH_ACTION_PAN_X);

if(hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL){
return this.preventSrc(srcEvent);}},



/**
                 * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
                 * @param {Object} srcEvent
                 */
preventSrc:function preventSrc(srcEvent){
this.manager.session.prevented = true;
srcEvent.preventDefault();}};



/**
             * when the touchActions are collected they are not a valid value, so we need to clean things up. *
             * @param {String} actions
             * @returns {*}
             */
function cleanTouchActions(actions){
// none
if(inStr(actions,TOUCH_ACTION_NONE)){
return TOUCH_ACTION_NONE;}


var hasPanX=inStr(actions,TOUCH_ACTION_PAN_X);
var hasPanY=inStr(actions,TOUCH_ACTION_PAN_Y);

// pan-x and pan-y can be combined
if(hasPanX && hasPanY){
return TOUCH_ACTION_PAN_X + ' ' + TOUCH_ACTION_PAN_Y;}


// pan-x OR pan-y
if(hasPanX || hasPanY){
return hasPanX?TOUCH_ACTION_PAN_X:TOUCH_ACTION_PAN_Y;}


// manipulation
if(inStr(actions,TOUCH_ACTION_MANIPULATION)){
return TOUCH_ACTION_MANIPULATION;}


return TOUCH_ACTION_AUTO;}


/**
             * Recognizer flow explained; *
             * All recognizers have the initial state of POSSIBLE when a input session starts.
             * The definition of a input session is from the first input until the last input, with all it's movement in it. *
             * Example session for mouse-input: mousedown -> mousemove -> mouseup
             *
             * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
             * which determines with state it should be.
             *
             * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
             * POSSIBLE to give it another change on the next cycle.
             *
             *               Possible
             *                  |
             *            +-----+---------------+
             *            |                     |
             *      +-----+-----+               |
             *      |           |               |
             *   Failed      Cancelled          |
             *                          +-------+------+
             *                          |              |
             *                      Recognized       Began
             *                                         |
             *                                      Changed
             *                                         |
             *                                  Ended/Recognized
             */
var STATE_POSSIBLE=1;
var STATE_BEGAN=2;
var STATE_CHANGED=4;
var STATE_ENDED=8;
var STATE_RECOGNIZED=STATE_ENDED;
var STATE_CANCELLED=16;
var STATE_FAILED=32;

/**
             * Recognizer
             * Every recognizer needs to extend from this class.
             * @constructor
             * @param {Object} options
             */
function Recognizer(options){
this.id = uniqueId();

this.manager = null;
this.options = merge(options || {},this.defaults);

// default is enable true
this.options.enable = ifUndefined(this.options.enable,true);

this.state = STATE_POSSIBLE;

this.simultaneous = {};
this.requireFail = [];}


Recognizer.prototype = {
/**
                 * @virtual
                 * @type {Object}
                 */
defaults:{},

/**
                 * set options
                 * @param {Object} options
                 * @return {Recognizer}
                 */
set:function set(options){
extend(this.options,options);

// also update the touchAction, in case something changed about the directions/enabled state
this.manager && this.manager.touchAction.update();
return this;},


/**
                 * recognize simultaneous with an other recognizer.
                 * @param {Recognizer} otherRecognizer
                 * @returns {Recognizer} this
                 */
recognizeWith:function recognizeWith(otherRecognizer){
if(invokeArrayArg(otherRecognizer,'recognizeWith',this)){
return this;}


var simultaneous=this.simultaneous;
otherRecognizer = getRecognizerByNameIfManager(otherRecognizer,this);
if(!simultaneous[otherRecognizer.id]){
simultaneous[otherRecognizer.id] = otherRecognizer;
otherRecognizer.recognizeWith(this);}

return this;},


/**
                 * drop the simultaneous link. it doesnt remove the link on the other recognizer.
                 * @param {Recognizer} otherRecognizer
                 * @returns {Recognizer} this
                 */
dropRecognizeWith:function dropRecognizeWith(otherRecognizer){
if(invokeArrayArg(otherRecognizer,'dropRecognizeWith',this)){
return this;}


otherRecognizer = getRecognizerByNameIfManager(otherRecognizer,this);
delete this.simultaneous[otherRecognizer.id];
return this;},


/**
                 * recognizer can only run when an other is failing
                 * @param {Recognizer} otherRecognizer
                 * @returns {Recognizer} this
                 */
requireFailure:function requireFailure(otherRecognizer){
if(invokeArrayArg(otherRecognizer,'requireFailure',this)){
return this;}


var requireFail=this.requireFail;
otherRecognizer = getRecognizerByNameIfManager(otherRecognizer,this);
if(inArray(requireFail,otherRecognizer) === -1){
requireFail.push(otherRecognizer);
otherRecognizer.requireFailure(this);}

return this;},


/**
                 * drop the requireFailure link. it does not remove the link on the other recognizer.
                 * @param {Recognizer} otherRecognizer
                 * @returns {Recognizer} this
                 */
dropRequireFailure:function dropRequireFailure(otherRecognizer){
if(invokeArrayArg(otherRecognizer,'dropRequireFailure',this)){
return this;}


otherRecognizer = getRecognizerByNameIfManager(otherRecognizer,this);
var index=inArray(this.requireFail,otherRecognizer);
if(index > -1){
this.requireFail.splice(index,1);}

return this;},


/**
                 * has require failures boolean
                 * @returns {boolean}
                 */
hasRequireFailures:function hasRequireFailures(){
return this.requireFail.length > 0;},


/**
                 * if the recognizer can recognize simultaneous with an other recognizer
                 * @param {Recognizer} otherRecognizer
                 * @returns {Boolean}
                 */
canRecognizeWith:function canRecognizeWith(otherRecognizer){
return !!this.simultaneous[otherRecognizer.id];},


/**
                 * You should use `tryEmit` instead of `emit` directly to check
                 * that all the needed recognizers has failed before emitting.
                 * @param {Object} input
                 */
emit:function emit(input){
var self=this;
var state=this.state;

function emit(withState){
self.manager.emit(self.options.event + (withState?stateStr(state):''),input);}


// 'panstart' and 'panmove'
if(state < STATE_ENDED){
emit(true);}


emit(); // simple 'eventName' events

// panend and pancancel
if(state >= STATE_ENDED){
emit(true);}},



/**
                 * Check that all the require failure recognizers has failed,
                 * if true, it emits a gesture event,
                 * otherwise, setup the state to FAILED.
                 * @param {Object} input
                 */
tryEmit:function tryEmit(input){
if(this.canEmit()){
return this.emit(input);}

// it's failing anyway
this.state = STATE_FAILED;},


/**
                 * can we emit?
                 * @returns {boolean}
                 */
canEmit:function canEmit(){
var i=0;
while(i < this.requireFail.length) {
if(!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))){
return false;}

i++;}

return true;},


/**
                 * update the recognizer
                 * @param {Object} inputData
                 */
recognize:function recognize(inputData){
// make a new copy of the inputData
// so we can change the inputData without messing up the other recognizers
var inputDataClone=extend({},inputData);

// is is enabled and allow recognizing?
if(!boolOrFn(this.options.enable,[this,inputDataClone])){
this.reset();
this.state = STATE_FAILED;
return;}


// reset when we've reached the end
if(this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)){
this.state = STATE_POSSIBLE;}


this.state = this.process(inputDataClone);

// the recognizer has recognized a gesture
// so trigger an event
if(this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)){
this.tryEmit(inputDataClone);}},



/**
                 * return the state of the recognizer
                 * the actual recognizing happens in this method
                 * @virtual
                 * @param {Object} inputData
                 * @returns {Const} STATE
                 */
process:function process(inputData){}, // jshint ignore:line

/**
                 * return the preferred touch-action
                 * @virtual
                 * @returns {Array}
                 */
getTouchAction:function getTouchAction(){},

/**
                 * called when the gesture isn't allowed to recognize
                 * like when another is being recognized or it is disabled
                 * @virtual
                 */
reset:function reset(){}};


/**
             * get a usable string, used as event postfix
             * @param {Const} state
             * @returns {String} state
             */
function stateStr(state){
if(state & STATE_CANCELLED){
return 'cancel';}else 
if(state & STATE_ENDED){
return 'end';}else 
if(state & STATE_CHANGED){
return 'move';}else 
if(state & STATE_BEGAN){
return 'start';}

return '';}


/**
             * direction cons to string
             * @param {Const} direction
             * @returns {String}
             */
function directionStr(direction){
if(direction == DIRECTION_DOWN){
return 'down';}else 
if(direction == DIRECTION_UP){
return 'up';}else 
if(direction == DIRECTION_LEFT){
return 'left';}else 
if(direction == DIRECTION_RIGHT){
return 'right';}

return '';}


/**
             * get a recognizer by name if it is bound to a manager
             * @param {Recognizer|String} otherRecognizer
             * @param {Recognizer} recognizer
             * @returns {Recognizer}
             */
function getRecognizerByNameIfManager(otherRecognizer,recognizer){
var manager=recognizer.manager;
if(manager){
return manager.get(otherRecognizer);}

return otherRecognizer;}


/**
             * This recognizer is just used as a base for the simple attribute recognizers.
             * @constructor
             * @extends Recognizer
             */
function AttrRecognizer(){
Recognizer.apply(this,arguments);}


inherit(AttrRecognizer,Recognizer,{
/**
                 * @namespace
                 * @memberof AttrRecognizer
                 */
defaults:{
/**
                     * @type {Number}
                     * @default 1
                     */
pointers:1},


/**
                 * Used to check if it the recognizer receives valid input, like input.distance > 10.
                 * @memberof AttrRecognizer
                 * @param {Object} input
                 * @returns {Boolean} recognized
                 */
attrTest:function attrTest(input){
var optionPointers=this.options.pointers;
return optionPointers === 0 || input.pointers.length === optionPointers;},


/**
                 * Process the input and return the state for the recognizer
                 * @memberof AttrRecognizer
                 * @param {Object} input
                 * @returns {*} State
                 */
process:function process(input){
var state=this.state;
var eventType=input.eventType;

var isRecognized=state & (STATE_BEGAN | STATE_CHANGED);
var isValid=this.attrTest(input);

// on cancel input and we've recognized before, return STATE_CANCELLED
if(isRecognized && (eventType & INPUT_CANCEL || !isValid)){
return state | STATE_CANCELLED;}else 
if(isRecognized || isValid){
if(eventType & INPUT_END){
return state | STATE_ENDED;}else 
if(!(state & STATE_BEGAN)){
return STATE_BEGAN;}

return state | STATE_CHANGED;}

return STATE_FAILED;}});



/**
             * Pan
             * Recognized when the pointer is down and moved in the allowed direction.
             * @constructor
             * @extends AttrRecognizer
             */
function PanRecognizer(){
AttrRecognizer.apply(this,arguments);

this.pX = null;
this.pY = null;}


inherit(PanRecognizer,AttrRecognizer,{
/**
                 * @namespace
                 * @memberof PanRecognizer
                 */
defaults:{
event:'pan',
threshold:10,
pointers:1,
direction:DIRECTION_ALL},


getTouchAction:function getTouchAction(){
var direction=this.options.direction;
var actions=[];
if(direction & DIRECTION_HORIZONTAL){
actions.push(TOUCH_ACTION_PAN_Y);}

if(direction & DIRECTION_VERTICAL){
actions.push(TOUCH_ACTION_PAN_X);}

return actions;},


directionTest:function directionTest(input){
var options=this.options;
var hasMoved=true;
var distance=input.distance;
var direction=input.direction;
var x=input.deltaX;
var y=input.deltaY;

// lock to axis?
if(!(direction & options.direction)){
if(options.direction & DIRECTION_HORIZONTAL){
direction = x === 0?DIRECTION_NONE:x < 0?DIRECTION_LEFT:DIRECTION_RIGHT;
hasMoved = x != this.pX;
distance = Math.abs(input.deltaX);}else 
{
direction = y === 0?DIRECTION_NONE:y < 0?DIRECTION_UP:DIRECTION_DOWN;
hasMoved = y != this.pY;
distance = Math.abs(input.deltaY);}}


input.direction = direction;
return hasMoved && distance > options.threshold && direction & options.direction;},


attrTest:function attrTest(input){
return AttrRecognizer.prototype.attrTest.call(this,input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));},


emit:function emit(input){
this.pX = input.deltaX;
this.pY = input.deltaY;

var direction=directionStr(input.direction);
if(direction){
this.manager.emit(this.options.event + direction,input);}


this._super.emit.call(this,input);}});



/**
             * Pinch
             * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
             * @constructor
             * @extends AttrRecognizer
             */
function PinchRecognizer(){
AttrRecognizer.apply(this,arguments);}


inherit(PinchRecognizer,AttrRecognizer,{
/**
                 * @namespace
                 * @memberof PinchRecognizer
                 */
defaults:{
event:'pinch',
threshold:0,
pointers:2},


getTouchAction:function getTouchAction(){
return [TOUCH_ACTION_NONE];},


attrTest:function attrTest(input){
return this._super.attrTest.call(this,input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);},


emit:function emit(input){
this._super.emit.call(this,input);
if(input.scale !== 1){
var inOut=input.scale < 1?'in':'out';
this.manager.emit(this.options.event + inOut,input);}}});




/**
             * Press
             * Recognized when the pointer is down for x ms without any movement.
             * @constructor
             * @extends Recognizer
             */
function PressRecognizer(){
Recognizer.apply(this,arguments);

this._timer = null;
this._input = null;}


inherit(PressRecognizer,Recognizer,{
/**
                 * @namespace
                 * @memberof PressRecognizer
                 */
defaults:{
event:'press',
pointers:1,
time:500, // minimal time of the pointer to be pressed
threshold:5 // a minimal movement is ok, but keep it low
},

getTouchAction:function getTouchAction(){
return [TOUCH_ACTION_AUTO];},


process:function process(input){
var options=this.options;
var validPointers=input.pointers.length === options.pointers;
var validMovement=input.distance < options.threshold;
var validTime=input.deltaTime > options.time;

this._input = input;

// we only allow little movement
// and we've reached an end event, so a tap is possible
if(!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime){
this.reset();}else 
if(input.eventType & INPUT_START){
this.reset();
this._timer = setTimeoutContext(function(){
this.state = STATE_RECOGNIZED;
this.tryEmit();},
options.time,this);}else 
if(input.eventType & INPUT_END){
return STATE_RECOGNIZED;}

return STATE_FAILED;},


reset:function reset(){
clearTimeout(this._timer);},


emit:function emit(input){
if(this.state !== STATE_RECOGNIZED){
return;}


if(input && input.eventType & INPUT_END){
this.manager.emit(this.options.event + 'up',input);}else 
{
this._input.timeStamp = now();
this.manager.emit(this.options.event,this._input);}}});




/**
             * Rotate
             * Recognized when two or more pointer are moving in a circular motion.
             * @constructor
             * @extends AttrRecognizer
             */
function RotateRecognizer(){
AttrRecognizer.apply(this,arguments);}


inherit(RotateRecognizer,AttrRecognizer,{
/**
                 * @namespace
                 * @memberof RotateRecognizer
                 */
defaults:{
event:'rotate',
threshold:0,
pointers:2},


getTouchAction:function getTouchAction(){
return [TOUCH_ACTION_NONE];},


attrTest:function attrTest(input){
return this._super.attrTest.call(this,input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);}});



/**
             * Swipe
             * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
             * @constructor
             * @extends AttrRecognizer
             */
function SwipeRecognizer(){
AttrRecognizer.apply(this,arguments);}


inherit(SwipeRecognizer,AttrRecognizer,{
/**
                 * @namespace
                 * @memberof SwipeRecognizer
                 */
defaults:{
event:'swipe',
threshold:10,
velocity:0.65,
direction:DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
pointers:1},


getTouchAction:function getTouchAction(){
return PanRecognizer.prototype.getTouchAction.call(this);},


attrTest:function attrTest(input){
var direction=this.options.direction;
var velocity;

if(direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)){
velocity = input.velocity;}else 
if(direction & DIRECTION_HORIZONTAL){
velocity = input.velocityX;}else 
if(direction & DIRECTION_VERTICAL){
velocity = input.velocityY;}


return this._super.attrTest.call(this,input) && direction & input.direction && input.distance > this.options.threshold && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;},


emit:function emit(input){
var direction=directionStr(input.direction);
if(direction){
this.manager.emit(this.options.event + direction,input);}


this.manager.emit(this.options.event,input);}});



/**
             * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
             * between the given interval and position. The delay option can be used to recognize multi-taps without firing
             * a single tap.
             *
             * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
             * multi-taps being recognized.
             * @constructor
             * @extends Recognizer
             */
function TapRecognizer(){
Recognizer.apply(this,arguments);

// previous time and center,
// used for tap counting
this.pTime = false;
this.pCenter = false;

this._timer = null;
this._input = null;
this.count = 0;}


inherit(TapRecognizer,Recognizer,{
/**
                 * @namespace
                 * @memberof PinchRecognizer
                 */
defaults:{
event:'tap',
pointers:1,
taps:1,
interval:300, // max time between the multi-tap taps
time:250, // max time of the pointer to be down (like finger on the screen)
threshold:2, // a minimal movement is ok, but keep it low
posThreshold:10 // a multi-tap can be a bit off the initial position
},

getTouchAction:function getTouchAction(){
return [TOUCH_ACTION_MANIPULATION];},


process:function process(input){
var options=this.options;

var validPointers=input.pointers.length === options.pointers;
var validMovement=input.distance < options.threshold;
var validTouchTime=input.deltaTime < options.time;

this.reset();

if(input.eventType & INPUT_START && this.count === 0){
return this.failTimeout();}


// we only allow little movement
// and we've reached an end event, so a tap is possible
if(validMovement && validTouchTime && validPointers){
if(input.eventType != INPUT_END){
return this.failTimeout();}


var validInterval=this.pTime?input.timeStamp - this.pTime < options.interval:true;
var validMultiTap=!this.pCenter || getDistance(this.pCenter,input.center) < options.posThreshold;

this.pTime = input.timeStamp;
this.pCenter = input.center;

if(!validMultiTap || !validInterval){
this.count = 1;}else 
{
this.count += 1;}


this._input = input;

// if tap count matches we have recognized it,
// else it has began recognizing...
var tapCount=this.count % options.taps;
if(tapCount === 0){
// no failing requirements, immediately trigger the tap event
// or wait as long as the multitap interval to trigger
if(!this.hasRequireFailures()){
return STATE_RECOGNIZED;}else 
{
this._timer = setTimeoutContext(function(){
this.state = STATE_RECOGNIZED;
this.tryEmit();},
options.interval,this);
return STATE_BEGAN;}}}



return STATE_FAILED;},


failTimeout:function failTimeout(){
this._timer = setTimeoutContext(function(){
this.state = STATE_FAILED;},
this.options.interval,this);
return STATE_FAILED;},


reset:function reset(){
clearTimeout(this._timer);},


emit:function emit(){
if(this.state == STATE_RECOGNIZED){
this._input.tapCount = this.count;
this.manager.emit(this.options.event,this._input);}}});




/**
             * Simple way to create an manager with a default set of recognizers.
             * @param {HTMLElement} element
             * @param {Object} [options]
             * @constructor
             */
function Hammer(element,options){
options = options || {};
options.recognizers = ifUndefined(options.recognizers,Hammer.defaults.preset);
return new Manager(element,options);}


/**
             * @const {string}
             */
Hammer.VERSION = '2.0.4';

/**
             * default settings
             * @namespace
             */
Hammer.defaults = {
/**
                 * set if DOM events are being triggered.
                 * But this is slower and unused by simple implementations, so disabled by default.
                 * @type {Boolean}
                 * @default false
                 */
domEvents:false,

/**
                 * The value for the touchAction property/fallback.
                 * When set to `compute` it will magically set the correct value based on the added recognizers.
                 * @type {String}
                 * @default compute
                 */
touchAction:TOUCH_ACTION_COMPUTE,

/**
                 * @type {Boolean}
                 * @default true
                 */
enable:true,

/**
                 * EXPERIMENTAL FEATURE -- can be removed/changed
                 * Change the parent input target element.
                 * If Null, then it is being set the to main element.
                 * @type {Null|EventTarget}
                 * @default null
                 */
inputTarget:null,

/**
                 * force an input class
                 * @type {Null|Function}
                 * @default null
                 */
inputClass:null,

/**
                 * Default recognizer setup when calling `Hammer()`
                 * When creating a new Manager these will be skipped.
                 * @type {Array}
                 */
preset:[
// RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
[RotateRecognizer,{enable:false}],[PinchRecognizer,{enable:false},['rotate']],[SwipeRecognizer,{direction:DIRECTION_HORIZONTAL}],[PanRecognizer,{direction:DIRECTION_HORIZONTAL},['swipe']],[TapRecognizer],[TapRecognizer,{event:'doubletap',taps:2},['tap']],[PressRecognizer]],

/**
                 * Some CSS properties can be used to improve the working of Hammer.
                 * Add them to this method and they will be set when creating a new Manager.
                 * @namespace
                 */
cssProps:{
/**
                     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
                     * @type {String}
                     * @default 'none'
                     */
userSelect:'none',

/**
                     * Disable the Windows Phone grippers when pressing an element.
                     * @type {String}
                     * @default 'none'
                     */
touchSelect:'none',

/**
                     * Disables the default callout shown when you touch and hold a touch target.
                     * On iOS, when you touch and hold a touch target such as a link, Safari displays
                     * a callout containing information about the link. This property allows you to disable that callout.
                     * @type {String}
                     * @default 'none'
                     */
touchCallout:'none',

/**
                     * Specifies whether zooming is enabled. Used by IE10>
                     * @type {String}
                     * @default 'none'
                     */
contentZooming:'none',

/**
                     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
                     * @type {String}
                     * @default 'none'
                     */
userDrag:'none',

/**
                     * Overrides the highlight color shown when the user taps a link or a JavaScript
                     * clickable element in iOS. This property obeys the alpha value, if specified.
                     * @type {String}
                     * @default 'rgba(0,0,0,0)'
                     */
tapHighlightColor:'rgba(0,0,0,0)'}};



var STOP=1;
var FORCED_STOP=2;

/**
             * Manager
             * @param {HTMLElement} element
             * @param {Object} [options]
             * @constructor
             */
function Manager(element,options){
options = options || {};

this.options = merge(options,Hammer.defaults);
this.options.inputTarget = this.options.inputTarget || element;

this.handlers = {};
this.session = {};
this.recognizers = [];

this.element = element;
this.input = createInputInstance(this);
this.touchAction = new TouchAction(this,this.options.touchAction);

toggleCssProps(this,true);

each(options.recognizers,function(item){
var recognizer=this.add(new item[0](item[1]));
item[2] && recognizer.recognizeWith(item[2]);
item[3] && recognizer.requireFailure(item[3]);},
this);}


Manager.prototype = {
/**
                 * set options
                 * @param {Object} options
                 * @returns {Manager}
                 */
set:function set(options){
extend(this.options,options);

// Options that need a little more setup
if(options.touchAction){
this.touchAction.update();}

if(options.inputTarget){
// Clean up existing event listeners and reinitialize
this.input.destroy();
this.input.target = options.inputTarget;
this.input.init();}

return this;},


/**
                 * stop recognizing for this session.
                 * This session will be discarded, when a new [input]start event is fired.
                 * When forced, the recognizer cycle is stopped immediately.
                 * @param {Boolean} [force]
                 */
stop:function stop(force){
this.session.stopped = force?FORCED_STOP:STOP;},


/**
                 * run the recognizers!
                 * called by the inputHandler function on every movement of the pointers (touches)
                 * it walks through all the recognizers and tries to detect the gesture that is being made
                 * @param {Object} inputData
                 */
recognize:function recognize(inputData){
var session=this.session;
if(session.stopped){
return;}


// run the touch-action polyfill
this.touchAction.preventDefaults(inputData);

var recognizer;
var recognizers=this.recognizers;

// this holds the recognizer that is being recognized.
// so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
// if no recognizer is detecting a thing, it is set to `null`
var curRecognizer=session.curRecognizer;

// reset when the last recognizer is recognized
// or when we're in a new session
if(!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED){
curRecognizer = session.curRecognizer = null;}


var i=0;
while(i < recognizers.length) {
recognizer = recognizers[i];

// find out if we are allowed try to recognize the input for this one.
// 1.   allow if the session is NOT forced stopped (see the .stop() method)
// 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
//      that is being recognized.
// 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
//      this can be setup with the `recognizeWith()` method on the recognizer.
if(session.stopped !== FORCED_STOP && ( // 1
!curRecognizer || recognizer == curRecognizer ||  // 2
recognizer.canRecognizeWith(curRecognizer))){
// 3
recognizer.recognize(inputData);}else 
{
recognizer.reset();}


// if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
// current active recognizer. but only if we don't already have an active recognizer
if(!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)){
curRecognizer = session.curRecognizer = recognizer;}

i++;}},



/**
                 * get a recognizer by its event name.
                 * @param {Recognizer|String} recognizer
                 * @returns {Recognizer|Null}
                 */
get:function get(recognizer){
if(recognizer instanceof Recognizer){
return recognizer;}


var recognizers=this.recognizers;
for(var i=0;i < recognizers.length;i++) {
if(recognizers[i].options.event == recognizer){
return recognizers[i];}}


return null;},


/**
                 * add a recognizer to the manager
                 * existing recognizers with the same event name will be removed
                 * @param {Recognizer} recognizer
                 * @returns {Recognizer|Manager}
                 */
add:function add(recognizer){
if(invokeArrayArg(recognizer,'add',this)){
return this;}


// remove existing
var existing=this.get(recognizer.options.event);
if(existing){
this.remove(existing);}


this.recognizers.push(recognizer);
recognizer.manager = this;

this.touchAction.update();
return recognizer;},


/**
                 * remove a recognizer by name or instance
                 * @param {Recognizer|String} recognizer
                 * @returns {Manager}
                 */
remove:function remove(recognizer){
if(invokeArrayArg(recognizer,'remove',this)){
return this;}


var recognizers=this.recognizers;
recognizer = this.get(recognizer);
recognizers.splice(inArray(recognizers,recognizer),1);

this.touchAction.update();
return this;},


/**
                 * bind event
                 * @param {String} events
                 * @param {Function} handler
                 * @returns {EventEmitter} this
                 */
on:function on(events,handler){
var handlers=this.handlers;
each(splitStr(events),function(event){
handlers[event] = handlers[event] || [];
handlers[event].push(handler);});

return this;},


/**
                 * unbind event, leave emit blank to remove all handlers
                 * @param {String} events
                 * @param {Function} [handler]
                 * @returns {EventEmitter} this
                 */
off:function off(events,handler){
var handlers=this.handlers;
each(splitStr(events),function(event){
if(!handler){
delete handlers[event];}else 
{
handlers[event].splice(inArray(handlers[event],handler),1);}});


return this;},


/**
                 * emit event to the listeners
                 * @param {String} event
                 * @param {Object} data
                 */
emit:function emit(event,data){
// we also want to trigger dom events
if(this.options.domEvents){
triggerDomEvent(event,data);}


// no handlers, so skip it all
var handlers=this.handlers[event] && this.handlers[event].slice();
if(!handlers || !handlers.length){
return;}


data.type = event;
data.preventDefault = function(){
data.srcEvent.preventDefault();};


var i=0;
while(i < handlers.length) {
handlers[i](data);
i++;}},



/**
                 * destroy the manager and unbinds all events
                 * it doesn't unbind dom events, that is the user own responsibility
                 */
destroy:function destroy(){
this.element && toggleCssProps(this,false);

this.handlers = {};
this.session = {};
this.input.destroy();
this.element = null;}};



/**
             * add/remove the css properties as defined in manager.options.cssProps
             * @param {Manager} manager
             * @param {Boolean} add
             */
function toggleCssProps(manager,add){
var element=manager.element;
each(manager.options.cssProps,function(value,name){
element.style[prefixed(element.style,name)] = add?value:'';});}



/**
             * trigger dom event
             * @param {String} event
             * @param {Object} data
             */
function triggerDomEvent(event,data){
var gestureEvent=document.createEvent('Event');
gestureEvent.initEvent(event,true,true);
gestureEvent.gesture = data;
data.target.dispatchEvent(gestureEvent);}


extend(Hammer,{
INPUT_START:INPUT_START,
INPUT_MOVE:INPUT_MOVE,
INPUT_END:INPUT_END,
INPUT_CANCEL:INPUT_CANCEL,

STATE_POSSIBLE:STATE_POSSIBLE,
STATE_BEGAN:STATE_BEGAN,
STATE_CHANGED:STATE_CHANGED,
STATE_ENDED:STATE_ENDED,
STATE_RECOGNIZED:STATE_RECOGNIZED,
STATE_CANCELLED:STATE_CANCELLED,
STATE_FAILED:STATE_FAILED,

DIRECTION_NONE:DIRECTION_NONE,
DIRECTION_LEFT:DIRECTION_LEFT,
DIRECTION_RIGHT:DIRECTION_RIGHT,
DIRECTION_UP:DIRECTION_UP,
DIRECTION_DOWN:DIRECTION_DOWN,
DIRECTION_HORIZONTAL:DIRECTION_HORIZONTAL,
DIRECTION_VERTICAL:DIRECTION_VERTICAL,
DIRECTION_ALL:DIRECTION_ALL,

Manager:Manager,
Input:Input,
TouchAction:TouchAction,

TouchInput:TouchInput,
MouseInput:MouseInput,
PointerEventInput:PointerEventInput,
TouchMouseInput:TouchMouseInput,
SingleTouchInput:SingleTouchInput,

Recognizer:Recognizer,
AttrRecognizer:AttrRecognizer,
Tap:TapRecognizer,
Pan:PanRecognizer,
Swipe:SwipeRecognizer,
Pinch:PinchRecognizer,
Rotate:RotateRecognizer,
Press:PressRecognizer,

on:addEventListeners,
off:removeEventListeners,
each:each,
merge:merge,
extend:extend,
inherit:inherit,
bindFn:bindFn,
prefixed:prefixed});


if(typeof define == TYPE_FUNCTION && define.amd){
define(function(){
return Hammer;});}else 

if(typeof module != 'undefined' && module.exports){
module.exports = Hammer;}else 
{
window[exportName] = Hammer;}})(

window,document,'Hammer');});})();


//# sourceMappingURL=hammer.js.map

var _Object$assign=require('babel-runtime/core-js/object/assign').default;

var _Promise=require('babel-runtime/core-js/promise').default;

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('mframework/m.js',function(require){
var _queryString=require('query-string');

var _queryString2=_interopRequireDefault(_queryString);

var _immutable=require('immutable');

var _immutable2=_interopRequireDefault(_immutable);

var _firebase=require('firebase');

var _firebase2=_interopRequireDefault(_firebase);

var Fireproof=require('fireproof');

var _mixpanelBrowser=require('mixpanel-browser');

var _mixpanelBrowser2=_interopRequireDefault(_mixpanelBrowser);

var _nodeUuid=require('node-uuid');

var _nodeUuid2=_interopRequireDefault(_nodeUuid);

var _config=require('../config');

var _config2=_interopRequireDefault(_config);

var _splitTests=require('../splitTests');

var _splitTests2=_interopRequireDefault(_splitTests);

var _records=require('../records');

var _records2=_interopRequireDefault(_records);

var _util=require('./util');

var _util2=_interopRequireDefault(_util);

var M={};
window.M = M;

var firebase=_config2.default.firebaseAppName?new _firebase2.default('https://' + _config2.default.firebaseAppName + '.firebaseio.com'):null;
var ref=firebase && new Fireproof(firebase);
if(_config2.default.mixpanelToken){
_mixpanelBrowser2.default.init(_config2.default.mixpanelToken);}else 
{
_mixpanelBrowser2.default.track = function(){
// Monkey patch Mixpanel tracking to be a no-op
// since some MFramework components use it
};}


// Facebook SDK
window.fbAsyncInit = function(){
FB.init({
appId:_config2.default.facebookAppId,
xfbml:true,
version:'v2.5'});

M._onFacebookInit();};


_Object$assign(M,{
config:_config2.default,
mixpanel:_mixpanelBrowser2.default,
ref:ref,
records:_records2.default,
util:_util2.default});


_Object$assign(M,{
_refs:{},

_splitTestUuid4:undefined,
splitTests:_splitTests2.default,
getUserSplit:function getUserSplit(testId){
if(!(testId in _splitTests2.default)){
throw new Error('Unknown split test ID: ' + testId);}

if(!M._splitTestUuid4){
M._splitTestUuid4 = M.context.uid.get() || M.context.sessionId.get() || 
// Either we're not tracking sessions, or a new browser session just got
// pointed to the page and the ensureSession round trip didn't finish
// before a component called getUserSplit. So just use a random
// uuid4 until the next refresh.
_nodeUuid2.default.v4();}

var splitIndex=parseInt(M._splitTestUuid4.substring(0,8),16) % _splitTests2.default[testId].length;
return _splitTests2.default[testId][splitIndex];},


defaultAtom:function defaultAtom(defaultValue){
return atom().lens({
get:function get(value){
return value === undefined?defaultValue:value;},

set:function set(oldValue,value){
return value;}});},




listAtom:function listAtom(defaultValue){
var defaultList=defaultValue?List(defaultValue):defaultValue;

return atom().lens({
get:function get(value){
return value === undefined?defaultList:value;},

set:function set(oldValue,value){
return value?List(value):value;}});},




mapAtom:function mapAtom(defaultValue){
var defaultMap=defaultValue?IMap(defaultValue):defaultValue;

return atom().lens({
get:function get(value){
return value === undefined?defaultMap:value;},

set:function set(oldValue,value){
return value?IMap(value):value;}});},




mergeAtom:function mergeAtom(defaultValue){
var deep=arguments.length <= 1 || arguments[1] === undefined?true:arguments[1];

defaultValue = _immutable2.default.fromJS(defaultValue);
if(defaultValue === undefined){
defaultValue = IMap({});}else 
if(!(defaultValue instanceof IMap)){
throw new Error('mergeAtom defaultValue must be IMap, object or undefined');}

return atom(defaultValue).lens({
get:function get(value){
return value;},

set:function set(oldValue,value){
if(value == null){
return oldValue;}else 
if(value){
if(deep){
return defaultValue.mergeDeep(value);}else 
{
return defaultValue.merge(value);}}}});},






requiredAtom:function requiredAtom(){
return atom().lens({
get:function get(value){
return value;},

set:function set(oldValue,value){
if(value == null){
throw new Error("requiredAtom got value " + value);}

return value;}});},




frozenAtom:function frozenAtom(defaultValue){
// Returns an atom that can be set once and then gets frozen
var hasBeenSet=false;
var firstValue=undefined;
var a=defaultValue === undefined?atom():M.defaultAtom(defaultValue);
var frozenA=a.lens({
get:function get(value){
return value;},

set:function set(oldValue,value){
if(hasBeenSet){
if(_immutable2.default.is(firstValue,value)){
return value;}else 
{
throw new Error('Can\'t double-set frozenAtom' + ('' + (frozenA.name?' ' + JSON.stringify(frozenA.name):'')) + (' from ' + JSON.stringify(firstValue) + ' to ' + JSON.stringify(value) + '.') + ' If you\'re passing in a component pro, try passing a \'key\'' + ' attribute in order to re-create a component instance rather' + ' than modifying pro values on the existing instance.');}}else 

{
hasBeenSet = true;
firstValue = value;
return value;}}});



return frozenA;},


context:{
sessionId:atom(localStorage.getItem('sessionId') || undefined),
isAdmin:derivation(function(){
if(M.context.uid.get() === undefined || M.context.user.get() === undefined){
return undefined;}else 
{
return !!(M.context.user.get() && M.context.user.get().isAdmin);}}),


queryParams:atom(IMap(_queryString2.default.parse(window.location.search))),
uid:atom(localStorage.getItem('uid') || undefined),
user:atom(),
route:atom(document.location.pathname)},


_facebookInitCallbacks:[],
_onFacebookInit:function _onFacebookInit(){
M._facebookInitCallbacks.forEach(function(callback){
callback(FB);});},


getFB:function getFB(){
if(window.FB){
return _Promise.resolve(FB);}else 
{
var resolveFunc=undefined;
var promise=new _Promise(function(resolve,reject){
resolveFunc = resolve;});

M._facebookInitCallbacks.push(resolveFunc);
return promise;}},



apiCall:function apiCall(endpoint,options){
options = _Object$assign({},options);

options.params = _Object$assign({},options.params);
if(M.context.sessionId.get()){
options.params.sessionId = M.context.sessionId.get();}


var url=M.config.apiBaseUrl + endpoint;
if(options.params){
if(options.method == 'post'){
options.body = JSON.stringify(options.params);}else 
{
url += '?' + M.util.objToParamString(options.params);}

delete options.params;}


return fetch(url,options).then(function(apiResponse){
if(apiResponse.ok){
return apiResponse.json();}else 
{
throw new Error(apiResponse.status + ': ' + apiResponse.statusText);}}).

then(function(apiResponseJson){
if(apiResponseJson && apiResponseJson.err){
throw new Error(apiResponseJson.err);}else 
{
return apiResponseJson;}});},




apiGet:function apiGet(endpoint,options){
return M.apiCall(endpoint,options);},


apiPost:function apiPost(endpoint,options){
options = _Object$assign({
method:'post',
headers:{
'Content-Type':"application/json"}},

options);
return M.apiCall(endpoint,options);},


ensureSession:function ensureSession(){
if(M.context.sessionId.get()){
M.apiGet('session').then(function(session){
if(session){
if(session.uid){
if(M.ref.getAuth()){
M.context.uid.set(session.uid);}else 
{
// Apparently we're logged into the API but not into
// Firebase. Just log out to restore a consistent state.
M.logout();}}else 

{
M.context.uid.set(null);}}else 

{
// The client's cached session isn't valid on the server anymore
M.startNewSession();}});}else 


{
M.startNewSession();}},



login:function login(){
var options=arguments.length <= 0 || arguments[0] === undefined?{}:arguments[0];

var fbPermissions=options.fbPermissions || M.config.facebookLoginPermissions || ['public_profile'];

transact(function(){
M.context.uid.set(undefined);
M.context.user.set(undefined);});


return new _Promise(function(resolve,reject){
if(!window.FB){
M.context.uid.set(null);
console.warn("Tried to log in before FB library loaded.");
resolve();
return;}


FB.login(function(response){
if(!response.authResponse){
// User cancelled login.
// Don't throw an error but hope the caller
// checks M.context.uid to see that login was cancelled
M.context.uid.set(null);
resolve();
return;}


M.apiPost('login',{
params:{
fbAccessToken:response.authResponse.accessToken}}).

then(function(apiResponse){
if(apiResponse.isNew){
M.mixpanel.alias(apiResponse.uid);}else 
{
M.mixpanel.identify(apiResponse.uid);}

M.mixpanel.track("Login");

M._setFirebaseToken(apiResponse.firebaseToken);
return ref.authWithCustomToken(apiResponse.firebaseToken);}).
then(function(authData){
M.context.uid.set(authData.uid);
resolve();})[
'catch'](function(err){
M.context.uid.set(null);
reject(err);});},

{
scope:fbPermissions.join(',')});});},




loginAs:function loginAs(uid){
var wasUid=M.context.uid.get();
M.mixpanel.track("LoginAs",{uid:uid});

return M.apiPost('loginAs',{
params:{
uid:uid}}).

then(function(apiResponse){
M.mixpanel.identify(uid);
M.mixpanel.track("Login",{wasUid:wasUid});

M._setFirebaseToken(apiResponse.firebaseToken);
return ref.authWithCustomToken(apiResponse.firebaseToken);}).
then(function(authData){
M.context.uid.set(authData.uid);})[
'catch'](function(err){
alert('Problem: ' + err);});},



logout:function logout(){
M.mixpanel.track("Logout");
M.mixpanel.cookie.clear();

var logoutPromise=M.apiPost('logout').then(function(apiResponse){
M.context.sessionId.set(apiResponse.newSessionId);},
function(err){
console.error("Error during logout",err);});

transact(function(){
M.context.uid.set(null);
M.context.sessionId.set(undefined);
M.context.user.set(null);});

M._setFirebaseToken(null);
ref.unauth();
return logoutPromise;},


startNewSession:function startNewSession(){
M.apiPost('newSession').then(function(session){
transact(function(){
M.context.sessionId.set(session.id);
M.context.uid.set(session.uid);});});},




_setFirebaseToken:function _setFirebaseToken(firebaseToken){
if(firebaseToken){
M.localStorageSet('firebaseToken',firebaseToken);}else 
{
M.localStorageRemove('firebaseToken');}},



routeIsActive:function routeIsActive(path){
if(path.match(/^https?:\/\//))return false;
if(path[0] != '/'){
path = '/' + path;}

return M.context.route.get() == path;}});



M._LOCALSTORAGE_WORKS = false;
try{
localStorage.setItem('mframework_test_key','test_value');
localStorage.removeItem('mframework_test_key');
M._LOCALSTORAGE_WORKS = true;}
catch(ex) {
console.info("LocalStorage doesn't work.");}


M._fakeLocalStorage = M._LOCALSTORAGE_WORKS?null:{};
M.localStorageGet = function(key){
return M._LOCALSTORAGE_WORKS?localStorage.getItem(key):M._fakeLocalStorage[key];};

M.localStorageSet = function(key,value){
if(M._LOCALSTORAGE_WORKS){
localStorage.setItem(key,value);}else 
{
M._fakeLocalStorage[key] = value;}};


M.localStorageRemove = function(key){
if(M._LOCALSTORAGE_WORKS){
localStorage.removeItem(key);}else 
{
delete M._fakeLocalStorage[key];}};



M.context.sessionId.reactor(function(sessionId){
if(sessionId){
M.localStorageSet('sessionId',sessionId);}else 
{
M.localStorageRemove('sessionId');}}).

start();

M.context.uid.reactor(function(uid){
if(uid){
M.localStorageSet('uid',uid);}else 
{
M.localStorageRemove('uid');}}).

start();

ref && ref.onAuth(function(authData){
if(!authData && M.context.uid.get()){
console.info("Firebase-triggered logout");
// In case the Firebase session randomly expires,
// log out to avoid inconsistency between the API's
// session and Firebase's session.
M.logout();}});



window.addEventListener('storage',function(e){
// Handle localStorage change triggered from another tab/window
if(e.key == "sessionId"){
M.context.sessionId.set(e.newValue || undefined);}else 
if(e.key == "firebaseToken"){
if(e.newValue){
var authData=M.ref.getAuth();
if(!(authData && authData.token == e.newValue)){
M.ref.authWithCustomToken(e.newValue);}}}else 


if(e.key == "uid"){
M.context.uid.set(e.newValue);}});



Flint.router.onChange(function(){
M.context.route.set(window.location.pathname);
M.context.queryParams.set(IMap(_queryString2.default.parse(window.location.search)));});});})();



//# sourceMappingURL=m.js.map

(function(){
Flint.file("mframework/views/areYouSure.js",function(require){
Flint.staticStyles("AreYouSure",{
"$":"#_flintapp .ViewAreYouSure",
"$confirming":"#_flintapp confirming.AreYouSure, #_flintapp .AreYouSure.confirming, #_flintapp .ViewAreYouSure.confirming, #_flintapp .AreYouSure > .confirming",
"$prompt":"#_flintapp prompt.AreYouSure, #_flintapp .AreYouSure.prompt, #_flintapp .ViewAreYouSure.prompt, #_flintapp .AreYouSure > .prompt",
"$separator":"#_flintapp separator.AreYouSure, #_flintapp .AreYouSure.separator, #_flintapp .ViewAreYouSure.separator, #_flintapp .AreYouSure > .separator"},
{
"$":{},
"$confirming":{
flexDirection:'row',
alignItems:'center',
color:'#999',
fontSize:12},

"$prompt":{
marginRight:4,
fontFamily:'proximanova'},

"$separator":{
fontSize:12,
color:'#999',
marginLeft:4,
marginRight:4}});


Flint.view("AreYouSure",function(view,on,$){
var pro=initPro(view,{
children:atom(),
prompt:atom()});


var confirming=atom(false);view.render(function(){
return Flint.iff(!confirming.get()) && view.el(
["normal",1],
{if:!confirming.get(),onClick:function(){
return confirming.set(true);}},

pro.children.get());});

view.render(function(){
return Flint.iff(confirming.get()) && view.el(
["confirming",1],
{if:confirming.get()},
view.el(
["prompt",1],
null,
pro.prompt.get() || "Are you sure?"),

view.el(
["LinkButton",1],
{className:"yes",onClick:function(e){
if(view.props.onClick){
view.props.onClick(e);}

confirming.set(false);}},

"Yes"),

view.el(
["separator",1],
null,
"|"),

view.el(
["LinkButton",2],
{className:"no",onClick:function(e){
return confirming.set(false);}},

"No"));});




"d9a3edb4";
"a2ff007a";
"42aa570e";});});})();



//# sourceMappingURL=areYouSure.js.map

var _Object$assign=require('babel-runtime/core-js/object/assign').default;

(function(){
Flint.file('mframework/views/blank.js',function(require){
Flint.staticStyles('Blank',{
'$':'#_flintapp .ViewBlank'},
{
'$':{
display:'inline-block'}});


Flint.view('Blank',function(view,on,$){
var context=initContext(view,{
colors:atom(),
isMobile:atom()});


var pro=initPro(view,{
autoSaveOnCharCount:M.defaultAtom(null), // save after typing N chars
initialValue:atom(),
type:M.defaultAtom('string'),
defaultValue:atom(),
min:atom(),
max:atom(),
nullable:M.defaultAtom(false),
placeholder:atom(),
value:atom(),
inpStyle:M.mapAtom({})});


var valueToString=function valueToString(v){
if(view.props.valueToString){
return view.props.valueToString(v);}else 
if(pro.type.get() == 'number' || pro.type.get() == 'int'){
return v == null?'':'' + v;}else 
if(pro.type.get() == 'string'){
return v;}else 
{
throw new Error('Unknown type: ' + pro.type.get());}};



var stringToValue=function stringToValue(s){
if(pro.type.get() == 'int' || pro.type.get() == 'number'){
var v=pro.type.get() == 'int'?parseInt(s,10):parseFloat(s,10);
if(isNaN(v))return null;
if(pro.min.get() != null && v < pro.min.get())return null;
if(pro.max.get() != null && v > pro.max.get())return null;
return v;}else 
if(pro.type.get() == 'string'){
if(s){
return s;}else 
{
return pro.defaultValue.get() || '';}}else 

{
throw new Error('Unknown type: ' + pro.type.get());}};



var hovering=atom(false);
var editing=atom(false);

var value=atom(pro.initialValue.get());

pro.value.react(function(propValue){
if(propValue !== undefined){
value.set(propValue);}});



var workingValue=atom();

var str=atom(valueToString(value.get()));

var autoSaving=atom(false);

str.react(function(str){
workingValue.set(stringToValue(str));},
{
when:editing});


workingValue.react(function(workingValue){
if(workingValue != null && valueToString(workingValue) == str.get() && str.get().length >= pro.autoSaveOnCharCount.get()){
save();}},

{
when:function when(){
return pro.autoSaveOnCharCount.get() && autoSaving.get();}});



editing.react(function(editing){
if(editing){
autoSaving.set(false);
workingValue.set(value.get());
str.set(valueToString(workingValue.get()));}});



var save=function save(){
var nextValue=undefined;

if(workingValue.get() == null){
if(pro.defaultValue.get() != null){
nextValue = pro.defaultValue.get();}else 
if(pro.nullable.get()){
nextValue = null;}}else 

{
nextValue = workingValue.get();}


if(pro.value.get() === undefined){
value.set(nextValue);}


if(view.props.onChange){
view.props.onChange({value:nextValue});}


if(pro.value.get() === undefined){
editing.set(false);}else 
{
// In controlled-component mode, give props time to change the value
// shown in view mode.
on.delay(100,function(){
editing.set(false);});}



inp.get().blur();};


var inp=atom();view.render(function(){
return view.el(['TextBox',1],{
key:context.isMobile.get()?'':'editing-' + editing.get(),
type:window.navigator.userAgent.match(/iPad|iPhone/i) && (pro.type.get() == 'number' || pro.type.get() == 'int')?'number':null,
pattern:window.navigator.userAgent.match(/iPad|iPhone/i)?pro.type.get() == 'number'?'\\d+(\\.\\d*)?':pro.type.get() == 'int'?'\\d*':null:null,
onInit:function(v){
return inp.set(v);},

value:editing.get()?str:value.derive(valueToString).or(''),
enabled:context.isMobile.get() || editing.get(),
autoFocus:editing.get(),
autoSelect:true,
inpStyle:_Object$assign({
cursor:editing.get()?'text':'pointer',
color:context.colors.get().accent,
outline:0,
background:'none',
borderRadius:editing.get()?4:0},
editing.get()?{
borderWidth:1,
borderStyle:'solid',
borderColor:context.colors.get().accent,
padding:0}:
{
borderWidth:1,
borderStyle:['none','none','dotted','none'],
padding:[1,1,0,1],
borderColor:context.colors.get().accent,
background:hovering.get()?'rgba(225, 205, 225, 0.25)':'none'},
pro.inpStyle.get().toJS()),
placeholder:pro.placeholder.get(),
onChange:function(e){
if(editing.get()){
str.set(e.value);}},


onKeyDown:function(e){
on.delay(context.isMobile.get()?500:1,function(){
autoSaving.set(true);});},


onEnter:function(){
if(editing.get())save();},

onEscape:function(){
if(editing.get())editing.set(false);},

onBlur:function(){
if(editing.get())save();},

onClick:function(){
editing.set(true);},

onHover:function(e){
if(!context.isMobile.get()){
hovering.set(e.hovering);}}});});});});})();







//# sourceMappingURL=blank.js.map

var _Object$keys=require('babel-runtime/core-js/object/keys').default;

(function(){
Flint.file('mframework/views/carousel.js',function(require){
var _reactMotion=require('react-motion');

Flint.staticStyles('Carousel',{
'$':'#_flintapp .ViewCarousel',
'$leftSection':'#_flintapp leftSection.Carousel, #_flintapp .Carousel.leftSection, #_flintapp .ViewCarousel.leftSection, #_flintapp .Carousel > .leftSection',
'$midSection':'#_flintapp midSection.Carousel, #_flintapp .Carousel.midSection, #_flintapp .ViewCarousel.midSection, #_flintapp .Carousel > .midSection',
'$things':'#_flintapp things.Carousel, #_flintapp .Carousel.things, #_flintapp .ViewCarousel.things, #_flintapp .Carousel > .things',
'$leftShadow':'#_flintapp leftShadow.Carousel, #_flintapp .Carousel.leftShadow, #_flintapp .ViewCarousel.leftShadow, #_flintapp .Carousel > .leftShadow',
'$rightShadow':'#_flintapp rightShadow.Carousel, #_flintapp .Carousel.rightShadow, #_flintapp .ViewCarousel.rightShadow, #_flintapp .Carousel > .rightShadow',
'$rightSection':'#_flintapp rightSection.Carousel, #_flintapp .Carousel.rightSection, #_flintapp .ViewCarousel.rightSection, #_flintapp .Carousel > .rightSection',
'$Sortable':'#_flintapp .ViewCarousel .ViewSortable',
'$dot':'#_flintapp dot.Carousel, #_flintapp .Carousel.dot, #_flintapp .ViewCarousel.dot, #_flintapp .Carousel > .dot',
'$thing':'#_flintapp thing.Carousel, #_flintapp .Carousel.thing, #_flintapp .ViewCarousel.thing, #_flintapp .Carousel > .thing'},
{
'$':{
flexDirection:'row',
alignItems:'center'},

'$leftSection':{},
'$midSection':{
flexDirection:'row',

position:'relative'},

'$things':{
overflow:'hidden'},

'$leftShadow':{
position:'absolute',
pointerEvents:'none',
zIndex:2,
top:0,
left:0,
bottom:0,

background:'linear-gradient(to right, rgba(100, 100, 100, 0.8) 0%, rgba(150, 150, 150, 0) 100%)'},

'$rightShadow':{
position:'absolute',
pointerEvents:'none',
zIndex:2,
top:0,
right:0,
bottom:0,

background:'linear-gradient(to left, rgba(100, 100, 100, 0.8) 0%, rgba(150, 150, 150, 0) 100%)'},

'$rightSection':{},
'$Sortable':{
flexDirection:'row'},

'$dot':{
zIndex:1,

margin:[0,4],
borderRadius:'50%'},

'$thing':{
position:'absolute'}});


Flint.view('Carousel',function(view,on,$){
var context=initContext(view,{
colors:atom()});


var pro=initPro(view,{
children:atom(),
width:M.defaultAtom(200),
buttonWidth:M.defaultAtom(40),
height:M.defaultAtom(200),
sortable:M.defaultAtom(false),
initialSelectedIndex:atom(),
selectedIndex:atom(),
shadows:M.defaultAtom(false),
showButtons:M.defaultAtom(true),
wrapMode:M.defaultAtom('rewind'), // 'rewind'|'cylinder'|false
style:M.mergeAtom({
button:{
border:'none',
background:'#f6f6f6',
position:'relative',
fontSize:48,
display:'block',
flexDirection:'row',
cursor:'pointer',
alignItems:'center',
justifyContent:'center',
color:'#aaa',
fontFamily:'Franklin Gothic Book',
zIndex:5},

buttonHover:{
background:'#f9e7f2'},

dot:{
size:10},

dots:{
position:'absolute',
left:0,
right:0,
bottom:12,
flexDirection:'row',
justifyContent:'center'},

shadow:{
width:30}})});




var buttonStyle=derivation(function(){
return IMap({
width:pro.buttonWidth.get(),
height:innerHeight.get()}).
merge(pro.style.get().get('button'));});


var leftButtonStyle=derivation(function(){
return buttonStyle.get().merge({
borderRadius:[8,0,0,8]}).
merge(hoveringLeft.get()?pro.style.get().get('buttonHover'):undefined).merge(pro.style.get().get('leftButton'));});


var rightButtonStyle=derivation(function(){
return buttonStyle.get().merge({
borderRadius:[0,8,8,0]}).
merge(hoveringRight.get()?pro.style.get().get('buttonHover'):undefined).merge(pro.style.get().get('rightButton'));});


var innerWidth=derivation(function(){
return pro.width.get() - (pro.showButtons.get()?2 * pro.buttonWidth.get():0);});

var innerHeight=derivation(function(){
return pro.height.get();});


var desiredIndex=atom(pro.initialSelectedIndex.get() || 0);

pro.selectedIndex.react(function(propSelectedIndex){
var inc=M.util.mod(propSelectedIndex,pro.children.get().length) - M.util.mod(desiredIndex.get(),pro.children.get().length);
desiredIndex.set(desiredIndex.get() + inc);},
{
when:function when(){
return pro.selectedIndex.get() != null;}});



var selectedIndex=lens({
get:function get(){
return M.util.mod(desiredIndex.get(),pro.children.get().length);},

set:function set(val){
if(pro.selectedIndex.get() == null){
desiredIndex.set(val);}

view.props.onSelect && view.props.onSelect({
selectedIndex:M.util.mod(val,pro.children.get().length)});}});




selectedIndex.react(function(selectedIndex){
M.mixpanel.track("CarouselThingView",{
selectedIndex:selectedIndex,
numThings:pro.children.get().length});});



var selectedChild=derivation(function(){
return pro.children.get()[selectedIndex.get()] || null;});


pro.children.react(function(children){
if(desiredIndex.get() >= children.length){
desiredIndex.set(pro.children.get().length - 1);}});



var advance=function advance(inc,inputMethod){
if(pro.wrapMode.get() == 'cylinder'){
selectedIndex.set(desiredIndex.get() + inc);}else 
{
selectedIndex.set(M.util.mod(selectedIndex.get() + inc,pro.children.get().length));}


M.mixpanel.track("CarouselAdvance",{
inc:inc,
inputMethod:inputMethod,
numThings:pro.children.get().length});};



var panning=atom(false);
var panDeltaX=atom(0);

var things=atom(List());
var setThing=function setThing(i,thing){
if(!thing || things.get().contains(thing))return;
things.set(things.get().push(thing));

var hammer=Hammer(thing);

hammer.on('panstart',function(e){
panning.set(true);});


hammer.on('pan',function(e){
panDeltaX.set(e.deltaX);});


hammer.on('panend',function(e){
transact(function(){
if(panDeltaX.get() <= 0.15 * -innerWidth.get()){
if(pro.wrapMode.get() == 'cylinder' || selectedIndex.get() < pro.children.get().length - 1){
advance(1,'swipe');}}else 

if(panDeltaX.get() >= 0.15 * innerWidth.get()){
if(pro.wrapMode.get() == 'cylinder' || selectedIndex.get() > 0){
advance(-1,'swipe');}}



panning.set(false);
panDeltaX.set(0);});});};




var hoveringLeft=atom(false);
var hoveringRight=atom(false);view.render(function(){
return Flint.iff(pro.showButtons.get()) && view.el(
['leftSection',1],
{if:pro.showButtons.get()},
Flint.iff(pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() > 0)) && view.el(
['button',1],
{className:'leftButton',
if:pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() > 0),
onClick:function(){
return advance(-1,'button');},

onMouseEnter:function(){
return hoveringLeft.set(true);},

onMouseLeave:function(){
return hoveringLeft.set(false);},

style:leftButtonStyle.get().toJS()},

'<'));});


view.render(function(){
return view.el(
['midSection',1],
null,
Flint.iff(pro.shadows.get() && (selectedIndex.get() > 0 || pro.wrapMode.get() == 'cylinder')) && view.el(['leftShadow',1],{if:pro.shadows.get() && (selectedIndex.get() > 0 || pro.wrapMode.get() == 'cylinder')}),
Flint.iff(pro.shadows.get() && (selectedIndex.get() < pro.children.get().length - 1 || pro.wrapMode.get() == 'cylinder')) && view.el(['rightShadow',1],{if:pro.shadows.get() && (selectedIndex.get() < pro.children.get().length - 1 || pro.wrapMode.get() == 'cylinder')}),
view.el(
['things',1],
null,
view.el(
['TransitionMotion',1],
{
styles:(function(){
var makeStyle=function makeStyle(i){
return {
x:(0,_reactMotion.spring)((i - desiredIndex.get()) * innerWidth.get()),
dx:panning.get()?panDeltaX.get():(0,_reactMotion.spring)(0)};};



var styles={};
var start=desiredIndex.get() - (pro.wrapMode.get() == 'cylinder'?pro.children.get().length - 1:selectedIndex.get());
var end=desiredIndex.get() + (pro.wrapMode.get() == 'cylinder'?pro.children.get().length - 1:pro.children.get().length - 1 - selectedIndex.get());
for(var i=start;i <= end;view.set('i',i++,i,true)) {
styles[i] = makeStyle(i);
view.update();}


return styles;})()},


function(styles){
return Flint.range(_Object$keys(styles)).map(function(_,_index){
return view.el(
['thing',1,_,_index],
{repeat:_Object$keys(styles),
key:_,
ref:function(elem){
return setThing(_index,elem);},

style:{
left:styles[_].x + styles[_].dx}},


pro.children.get()[M.util.mod(parseInt(_),pro.children.get().length)]);});})),





Flint.iff(pro.children.get().length > 1) && view.el(
['dotsSection',1],
{if:pro.children.get().length > 1,
style:pro.style.get().get('dots').toJS()},

Flint.iff(pro.sortable.get()) && view.el(
['Sortable',1],
{if:pro.sortable.get(),
key:pro.children.get().map(function(c){
return c.key;}).
join('\n') + '\n' + selectedIndex.get(),
onSort:function(e){
if(e.oldIndex < selectedIndex.get()){
if(e.newIndex >= selectedIndex.get()){
selectedIndex.set(selectedIndex.get() - 1);}}else 

if(e.oldIndex > selectedIndex.get()){
if(e.newIndex <= selectedIndex.get()){
selectedIndex.set(selectedIndex.get() + 1);}}else 

if(e.oldIndex == selectedIndex.get()){
selectedIndex.set(e.newIndex);}

view.props.onSort(e);}},


Flint.range(pro.children.get()).map(function(_,_index){
return view.el(['dot',1,_,_index],{repeat:pro.children.get(),
onClick:function(){
var inc=_index - M.util.mod(desiredIndex.get(),pro.children.get().length);
selectedIndex.set(desiredIndex.get() + inc);}});})),




Flint.iff(!pro.sortable.get()) && Flint.range(pro.children.get()).map(function(_,_index){
return view.el(['dot',2,_,_index],{if:!pro.sortable.get(),repeat:pro.children.get(),
onClick:function(){
var inc=_index - M.util.mod(desiredIndex.get(),pro.children.get().length);
selectedIndex.set(desiredIndex.get() + inc);
M.mixpanel.track("CarouselDotClick",{
dotIndex:_index,
numThings:pro.children.get().length});}});})));});






view.render(function(){
return Flint.iff(pro.showButtons.get()) && view.el(
['rightSection',1],
{if:pro.showButtons.get()},
Flint.iff(pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() < pro.children.get().length - 1)) && view.el(
['button',2],
{className:'rightButton',
if:pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() < pro.children.get().length - 1),
onClick:function(){
return advance(1,'button');},

onMouseEnter:function(){
return hoveringRight.set(true);},

onMouseLeave:function(){
return hoveringRight.set(false);},

style:rightButtonStyle.get().toJS()},

'>'));});




$["leftSection"] = function(_,_index){
return {
width:pro.buttonWidth.get()};};



$["midSection"] = function(_,_index){
return {width:innerWidth.get(),
height:innerHeight.get()};};


$["things"] = function(_,_index){
return {
width:innerWidth.get(),
height:innerHeight.get()};};


$["leftShadow"] = function(_,_index){
return {width:pro.style.get().get('shadow').get('width')};};


$["rightShadow"] = function(_,_index){
return {width:pro.style.get().get('shadow').get('width')};};


$["rightSection"] = function(_,_index){
return {
width:pro.buttonWidth.get()};};



'2530395c';

$["dot"] = function(_,_index){
return {width:pro.style.get().get('dot').get('size'),
height:pro.style.get().get('dot').get('size'),background:_index == selectedIndex.get()?context.colors.get().accent:'#999',
cursor:pro.sortable.get()?'move':'pointer'};};



$["thing"] = function(_,_index){
return {width:innerWidth.get(),
height:innerHeight.get()};};});});})();





//# sourceMappingURL=carousel.js.map

(function(){
Flint.file("mframework/views/checkboxPicker.js",function(require){
/*
      props:
        options: [
          {label, value}
        ]
    */

Flint.staticStyles("CheckboxPicker",{
"$label":"#_flintapp label.CheckboxPicker, #_flintapp .CheckboxPicker.label, #_flintapp .ViewCheckboxPicker.label, #_flintapp .CheckboxPicker > .label"},
{
"$label":{
cursor:'pointer'}});


Flint.view("CheckboxPicker",function(view,on,$){
var pro=initPro(view,{
options:atom(),
initialValues:M.listAtom([]),
values:M.listAtom()});


var selectedValues=atom(pro.initialValues.get());

pro.values.react(function(values){
if(values != null){
selectedValues.set(values);}});



selectedValues.reactor(function(selectedValues){
if(view.props.onChange){
view.props.onChange({selectedValues:selectedValues});}}).

start();

var onChange=function onChange(e){
var value=e.target.value;
var index=selectedValues.get().indexOf(value);
if(index >= 0){
selectedValues.set(selectedValues.get().splice(index,1));}else 
{
selectedValues.set(selectedValues.get().push(value).sort(M.util.compare));}};

view.render(function(){
return view.el(
["content",1],
null,
Flint.range(pro.options.get()).map(function(_,_index){
return view.el(
["label",1,_,_index],
{repeat:pro.options.get()},
view.el(["input",1,_,_index],{type:"checkbox",
value:_.value,
checked:selectedValues.get().indexOf(_.value) >= 0,
onChange:onChange}),

_.label);}));});});});})();







//# sourceMappingURL=checkboxPicker.js.map

(function(){
Flint.file('mframework/views/facebookPhotoChooser.js',function(require){
Flint.staticStyles('FacebookPhotoChooser',{
'$noPhoto':'#_flintapp noPhoto.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.noPhoto, #_flintapp .ViewFacebookPhotoChooser.noPhoto, #_flintapp .FacebookPhotoChooser > .noPhoto',
'$actionRow':'#_flintapp actionRow.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.actionRow, #_flintapp .ViewFacebookPhotoChooser.actionRow, #_flintapp .FacebookPhotoChooser > .actionRow',
'$topRow':'#_flintapp topRow.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.topRow, #_flintapp .ViewFacebookPhotoChooser.topRow, #_flintapp .FacebookPhotoChooser > .topRow',
'$tip':'#_flintapp tip.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.tip, #_flintapp .ViewFacebookPhotoChooser.tip, #_flintapp .FacebookPhotoChooser > .tip',
'$cancelModal':'#_flintapp cancelModal.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.cancelModal, #_flintapp .ViewFacebookPhotoChooser.cancelModal, #_flintapp .FacebookPhotoChooser > .cancelModal'},
{
'$noPhoto':{
cursor:'pointer',

alignItems:'center',
justifyContent:'center',
background:'white',
border:'1px dashed #ccc'},

'$actionRow':{
flexDirection:'row'},

'$topRow':{
flexDirection:'row',
alignSelf:'stretch',
alignItems:'stretch',
alignContent:'stretch',
paddingBottom:20,
borderBottom:'1px solid #eee',
marginBottom:20},

'$tip':{
flexGrow:1},

'$cancelModal':{
alignSelf:'flex-end'}});


Flint.view('FacebookPhotoChooser',function(view,on,$){
var pro=initPro(view,{
width:M.defaultAtom(300),
height:M.defaultAtom(168),
circle:M.defaultAtom(false),
children:atom(),
style:M.mergeAtom({}),
noPicStyle:M.mapAtom({})});


var showingFbPhotos=atom(false);
var selectedPhoto=M.mapAtom(null);

selectedPhoto.react(function(selectedPhoto){
if(view.props.onSelect){
view.props.onSelect({photo:selectedPhoto.toJS()});}},

{skipFirst:true});

var showFbPhotos=function showFbPhotos(){
FB.login(function(response){
if(response.authResponse && response.authResponse.grantedScopes.split(',').indexOf('user_photos') >= 0){
showingFbPhotos.set(true);
M.mixpanel.track("FacebookPhotoChooserView");}else 
{
M.mixpanel.track("FacebookPhotoChooserPermissionDenied");}},

{
scope:'user_photos',
auth_type:'rerequest',
return_scopes:true});};

view.render(function(){
return Flint.iff(selectedPhoto.get()) && view.el(
['selectedPhoto',1],
{if:selectedPhoto.get()},
view.el(['FacebookPhotoImage',1],{photo:selectedPhoto.get(),
width:pro.width.get(),
height:pro.height.get(),
style:pro.style.get()}),

view.el(
['actionRow',1],
null,
view.el(['EditLink',1],{onClick:showFbPhotos}),
view.el(['DeleteButton',1],{onClick:function(){
return selectedPhoto.set(null);}})));});



view.render(function(){
return Flint.iff(!selectedPhoto.get()) && view.el(
['noPhoto',1],
{if:!selectedPhoto.get(),
style:IMap({
borderRadius:pro.circle.get()?'50%':8}).
merge(pro.noPicStyle.get()).toJS(),
onClick:showFbPhotos},

pro.children.get());});

view.render(function(){
return Flint.iff(showingFbPhotos.get()) && view.el(
['MModal',1],
{if:showingFbPhotos.get(),
onRequestClose:function(){
showingFbPhotos.set(false);
M.mixpanel.track("FacebookPhotoChooserCancel");},

contentStyle:{
margin:50,
flexGrow:1,
border:'1px solid #ccc',
orderRadius:8},

overlayStyle:{
alignItems:'stretch',
justifyContent:'stretch',
background:'white'}},


view.el(
['topRow',1],
null,
view.el(
['tip',1],
null,
'Choose a Facebook photo.'),

view.el(['CancelLink',1],{className:'cancelModal',
onClick:function(){
showingFbPhotos.set(false);
M.mixpanel.track("FacebookPhotoChooserCancel");}})),



view.el(['FacebookPhotos',1],{onSelect:function(_ref){
var photo=_ref.photo;

selectedPhoto.set(photo);
showingFbPhotos.set(false);
M.mixpanel.track("FacebookPhotoChooserSelect");}}));});




'7959bd9a';

$["noPhoto"] = function(_,_index){
return {width:pro.width.get(),
height:pro.height.get()};};


'621ae1a2';
'c3851ca8';
'69c68a31';
'0458ce7f';});});})();



//# sourceMappingURL=facebookPhotoChooser.js.map

(function(){
Flint.file('mframework/views/facebookPhotoImage.js',function(require){
Flint.staticStyles('FacebookPhotoImage',{
'$image':'#_flintapp image.FacebookPhotoImage, #_flintapp .FacebookPhotoImage.image, #_flintapp .ViewFacebookPhotoImage.image, #_flintapp .FacebookPhotoImage > .image'},
{
'$image':{
backgroundRepeat:'no-repeat',
backgroundSize:'cover',
backgroundPosition:'50% 50%'}});


Flint.view('FacebookPhotoImage',function(view,on,$){
var pro=initPro(view,{
photo:M.mapAtom(),
width:M.defaultAtom(400),
height:M.defaultAtom(300),
style:M.mergeAtom({})});


var bestImage=pro.photo.derive(function(photo){
photo = photo.toJS();

var best=null;
photo.images.forEach(function(image){
if(!best || image.width <= pro.width.get() && best.width < image.width || pro.width.get() <= image.width && image.width < best.width){
best = image;}});


return immutable.fromJS(best);});
view.render(function(){
return view.el(['image',1],{src:bestImage.get().get('source'),
style:pro.style.get().toJS()});});



$["image"] = function(_,_index){
return {
width:pro.width.get(),
height:pro.height.get(),
backgroundImage:'url(' + bestImage.get().get('source') + ')'};};});});})();




//# sourceMappingURL=facebookPhotoImage.js.map

(function(){
Flint.file('mframework/views/facebookPhotos.js',function(require){
Flint.staticStyles('FacebookPhotos',{
'$loading':'#_flintapp loading.FacebookPhotos, #_flintapp .FacebookPhotos.loading, #_flintapp .ViewFacebookPhotos.loading, #_flintapp .FacebookPhotos > .loading',
'$Loader':'#_flintapp .ViewFacebookPhotos .ViewLoader',
'$photosSection':'#_flintapp photosSection.FacebookPhotos, #_flintapp .FacebookPhotos.photosSection, #_flintapp .ViewFacebookPhotos.photosSection, #_flintapp .FacebookPhotos > .photosSection',
'$photoSection':'#_flintapp photoSection.FacebookPhotos, #_flintapp .FacebookPhotos.photoSection, #_flintapp .ViewFacebookPhotos.photoSection, #_flintapp .FacebookPhotos > .photoSection',
'$FacebookPhotoImage':'#_flintapp .ViewFacebookPhotos .ViewFacebookPhotoImage'},
{
'$loading':{
fontSize:12,
color:'#999'},

'$Loader':{
marginTop:20},

'$photosSection':{
flexDirection:'row',
flexWrap:'wrap',
justifyContent:'space-around'},

'$photoSection':{
margin:10,
cursor:'pointer'},

'$FacebookPhotoImage':{
border:'1px solid #ddd'}});


Flint.view('FacebookPhotos',function(view,on,$){
var fbPhotos=M.listAtom();
var selectedPhoto=M.mapAtom(null);

selectedPhoto.reactor(function(photo){
if(view.props.onSelect){
view.props.onSelect({photo:photo.toJS()});}}).

start();

on.mount(function(){
FB.api('/me/photos','GET',{
fields:'images',
limit:200},
function(response){
fbPhotos.set(response.data);});});

view.render(function(){
return Flint.iff(fbPhotos.get() === undefined) && view.el(
['loading',1],
{if:fbPhotos.get() === undefined},
'Loading Facebook photos...',
view.el(['Loader',1],null));});

view.render(function(){
return Flint.iff(fbPhotos.get()) && view.el(
['photosSection',1],
{if:fbPhotos.get()},
Flint.range(fbPhotos.get()).map(function(_,_index){
return view.el(
['photoSection',1,_,_index],
{
repeat:fbPhotos.get(),
onClick:function(){
return selectedPhoto.set(_);}},


view.el(['FacebookPhotoImage',1,_,_index],{
photo:_,
width:200,
height:200}));}));});






'fbaef0a0';
'5037db5a';});});})();



//# sourceMappingURL=facebookPhotos.js.map

var _defineProperty=require('babel-runtime/helpers/define-property').default;

var _Object$keys=require('babel-runtime/core-js/object/keys').default;

(function(){
Flint.file('mframework/views/fadeTransitioner.js',function(require){
var _reactMotion=require('react-motion');

Flint.staticStyles('FadeTransitioner',{
'$':'#_flintapp .ViewFadeTransitioner',
'$thing':'#_flintapp thing.FadeTransitioner, #_flintapp .FadeTransitioner.thing, #_flintapp .ViewFadeTransitioner.thing, #_flintapp .FadeTransitioner > .thing'},
{
'$':{},
'$thing':{
position:'absolute'}});


Flint.view('FadeTransitioner',function(view,on,$){
var pro=initPro(view,{
children:atom(),
preloadChildren:M.defaultAtom(true),
selectedIndex:atom(),
springStiffness:M.defaultAtom(290),
springDamping:M.defaultAtom(29),
style:M.mergeAtom({})});


var desiredIndex=atom();
pro.selectedIndex.react(function(propSelectedIndex){
if(propSelectedIndex !== undefined){
desiredIndex.set(propSelectedIndex);}});



var children=pro.children.derive(function(c){
return List(React.Children.toArray(c));});


var selectedIndex=derivation(function(){
return Math.min(desiredIndex.get(),children.get().size);});


var makeSpring=function makeSpring(targetValue){
return (0,_reactMotion.spring)(targetValue,[pro.springStiffness.get(),pro.springDamping.get()]);};
view.render(function(){
return view.el(
['TransitionMotion',1],
{
defaultStyles:(function(){
if(pro.preloadChildren.get()){
var _ret=(function(){
var ret={};
children.get().forEach(function(child,i){
ret[i] = {
opacity:i == selectedIndex.get()?1:0,
zIndex:i == selectedIndex.get()?1:-1};});


return {
v:ret};})();



if(typeof _ret === 'object')return _ret.v;}else 
{
return selectedIndex.get() == -1?{}:_defineProperty({},selectedIndex.get(),{
opacity:1});}})(),



styles:(function(){
if(pro.preloadChildren.get()){
var _ret2=(function(){
var ret={};
children.get().forEach(function(child,i){
ret[i] = {
opacity:makeSpring(i == selectedIndex.get()?1:0),
zIndex:i == selectedIndex.get()?1:-1};});


return {
v:ret};})();



if(typeof _ret2 === 'object')return _ret2.v;}else 
{
return selectedIndex.get() == -1?{}:_defineProperty({},selectedIndex.get(),{
opacity:makeSpring(1)});}})(),



willEnter:function(i){
return {
opacity:0};},


willLeave:function(i){
return {
opacity:makeSpring(0)};}},



function(styles){
return Flint.range(_Object$keys(styles)).map(function(_,_index){
return view.el(
['thing',1,_,_index],
{repeat:_Object$keys(styles),key:_,style:styles[_]},
children.get().get(_));});});});






$["$"] = function(_,_index){
return {
width:pro.style.get().get('width'),
height:pro.style.get().get('height')};};});});})();





//# sourceMappingURL=fadeTransitioner.js.map

(function(){
Flint.file('mframework/views/filterOption.js',function(require){
Flint.view('FilterOption',function(view,on,$){
var context=initContext(view,{
colors:atom()});


var pro=initPro(view,{
children:atom(),
initialSelected:atom(),
selected:M.defaultAtom(false),
innerStyle:M.mapAtom({})});


var selected=atom(pro.initialSelected.get());

pro.selected.react(function(propSelected){
selected.set(propSelected);},
{when:function when(){
return pro.selected.get() != null;}});


var onClick=function onClick(e){
var nextSelected=!selected.get();

if(pro.selected.get() == null){
selected.set(nextSelected);}


if(view.props.onChange){
view.props.onChange({selected:nextSelected});}};



var hovering=atom(false);
hovering.reactor(function(hovering){
if(view.props.onHover)view.props.onHover({hovering:hovering});}).
start();view.render(function(){
return view.el(
['filterOption',1],
{
onClick:onClick,
onMouseEnter:function(){
return hovering.set(true);},

onMouseLeave:function(){
return hovering.set(false);},

style:IMap({
flexGrow:1,
alignSelf:'stretch',
alignItems:'center',
justifyContent:'center',
textAlign:'center',
borderRadius:8,
padding:4,
cursor:'pointer',
fontSize:13,
border:'1px solid #d5dade',
background:selected.get()?context.colors.get().accent:'linear-gradient(to bottom, #f1f1f6 0%, #c1c1d2 100%)',
color:selected.get()?'white':'black'}).
merge(pro.innerStyle.get()).toJS()},

pro.children.get());});});});})();





//# sourceMappingURL=filterOption.js.map

(function(){
Flint.file('mframework/views/lightbox.js',function(require){
Flint.view('Lightbox',function(view,on,$){
var pro=initPro(view,{
picKeys:M.listAtom(),
isOpen:M.defaultAtom(true),
selectedIndex:atom(),
initialSelectedIndex:atom()});


var bodyWidth=atom(document.body.offsetWidth);
var bodyHeight=atom(document.body.offsetHeight);

on.resize(window,function(e){
bodyWidth.set(document.body.offsetWidth);
bodyHeight.set(document.body.offsetHeight);});


var isOpen=atom();

var openCloseReactor=isOpen.reactor(function(isOpen){
if(isOpen){
view.props.onOpen && view.props.onOpen({});}else 
{
view.props.onClose && view.props.onClose({});}}).

start();

pro.isOpen.react(function(propIsOpen){
openCloseReactor.stop();
isOpen.set(propIsOpen);
openCloseReactor.start();});


var selectedIndex=atom(pro.initialSelectedIndex.get() || 0);
var selectReactor=selectedIndex.reactor(function(selectedIndex){
view.props.onSelect && view.props.onSelect({selectedIndex:selectedIndex});}).
start();

pro.selectedIndex.react(function(propSelectedIndex){
if(propSelectedIndex != null){
selectReactor.stop();
selectedIndex.set(propSelectedIndex);
selectReactor.start();}});



on.keydown(window,function(e){
if(!view.mounted){
// This code path is due to a Flint bug
return;}


if(e.keyCode == 37){
// Left
selectedIndex.set((selectedIndex.get() + pro.picKeys.get().size - 1) % pro.picKeys.get().size);}else 
if(e.keyCode == 39){
// Right
selectedIndex.set((selectedIndex.get() + 1) % pro.picKeys.get().size);}});

view.render(function(){
return view.el(
['MModal',1],
{
isOpen:isOpen.get(),
onRequestClose:function(){
return isOpen.set(false);},

overlayStyle:{
cursor:'zoom-out'},

contentStyle:{
cursor:'default',
borderRadius:8}},


Flint.iff(pro.picKeys.get().size >= 2) && view.el(
['Carousel',1],
{if:pro.picKeys.get().size >= 2,
selectedIndex:selectedIndex.get(),
onSelect:function(e){
return selectedIndex.set(e.selectedIndex);},

width:.8 * bodyWidth.get(),
height:.9 * bodyHeight.get(),
buttonWidth:60},

Flint.range(pro.picKeys.get()).map(function(_,_index){
return view.el(['Pic',1,_,_index],{repeat:pro.picKeys.get(),
picKey:_,
fit:'clip',
style:{
width:.8 * bodyWidth.get() - 120,
height:.9 * bodyHeight.get(),
background:'#f6f6f6'}});})),




Flint.iff(pro.picKeys.get().size == 1) && view.el(['Pic',2],{if:pro.picKeys.get().size == 1,
picKey:pro.picKeys.get().get(0),
fit:'clip',
style:{
maxWidth:.8 * bodyWidth.get(),
maxHeight:.9 * bodyHeight.get(),
background:'#f6f6f6',
cursor:'zoom-out'},

onClick:function(){
return isOpen.set(false);}}));});});});})();







//# sourceMappingURL=lightbox.js.map

(function(){
Flint.file('mframework/views/link.js',function(require){
Flint.staticStyles('Link',{
'$':'#_flintapp .ViewLink'},
{
'$':{
textDecoration:'none',
display:'flex'}});


Flint.viewRoots["Link"] = 'a';
Flint.view('Link',function(view,on,$){
var pro=initPro(view,{
to:atom(),
target:atom(),
children:atom(),
track:M.defaultAtom(true)});


var go=function go(e){
if(e.button == 0 && !e.metaKey){
var oldPreventDefault=e.preventDefault.bind(e);

var defaultPrevented=false;
e.preventDefault = function(){
defaultPrevented = true;};


if(view.props.onClick)view.props.onClick(e);

e.preventDefault = oldPreventDefault;

if(defaultPrevented){
oldPreventDefault();}else 
{
if(pro.track.get()){
M.mixpanel.track("LinkClick",{
to:pro.to.get(),
linkId:pro.track.get() === true?null:pro.track.get()});}



if(pro.target.get() != '_blank' && 
// Flint.router.go can't handle redirecting to another site
pro.to.get().indexOf('://') == -1){
oldPreventDefault();
Flint.router.go(pro.to.get());
document.body.scrollTop = 0;}}}};





var hovering=atom(false);
hovering.react(function(hovering){
if(view.props.onHover){
view.props.onHover({hovering:hovering});}},

{skipFirst:true});view.render(function(){
return view.el(
['a',1],
{root:true,
href:pro.to.get(),
target:pro.target.get(),
onClick:go,
onMouseEnter:function(){
return hovering.set(true);},

onMouseLeave:function(){
return hovering.set(false);}},


pro.children.get());});});});})();





//# sourceMappingURL=link.js.map

(function(){
Flint.file('mframework/views/linkButton.js',function(require){
Flint.view('LinkButton',function(view,on,$){
var pro=initPro(view,{
children:atom(),
style:M.defaultAtom({})});
view.render(function(){
return view.el(
['linkButton',1],
{
style:IMap({
cursor:'pointer',
color:'black'}).
merge(pro.style.get()).toJS(),
onClick:view.props.onClick},

pro.children.get());});});});})();





//# sourceMappingURL=linkButton.js.map

(function(){
Flint.file('mframework/views/loader.js',function(require){
Flint.staticStyles('Loader',{
'$':'#_flintapp .ViewLoader'},
{
'$':{
opacity:0.5,
width:50,
alignItems:'center',
justifyContent:'center'}});


Flint.view('Loader',function(view,on,$){
;view.render(function(){
return view.el(['img',1],{src:'/images/loader.gif'});});});});})();




//# sourceMappingURL=loader.js.map

(function(){
Flint.file('mframework/views/mediaChooser.js',function(require){
Flint.view('MediaChooser',function(view,on,$){
var context=initContext(view,{
isAdmin:atom()});


var pro=initPro(view,{
initialMediaKey:M.defaultAtom(null),
editable:M.defaultAtom(false),
width:M.defaultAtom(300),
height:M.defaultAtom(300),
allowUpload:M.defaultAtom(true),
allowFacebook:M.defaultAtom(false),
circle:M.defaultAtom(false),
mediaStyle:M.mapAtom({}),
noMediaStyle:M.mapAtom({}),
zoomable:M.defaultAtom(false),

children:atom()});


var mediaKey=atom(pro.initialMediaKey.get());
mediaKey.reactor(function(mediaKey){
if(view.props.onSelect){
view.props.onSelect({mediaKey:mediaKey});}}).

start();

var picKey=mediaKey.lens({
get:function get(mediaKey){
return mediaKey && mediaKey.indexOf('pics/') == 0?mediaKey:null;},

set:function set(mediaKey,picKey){
return picKey;}});


var videoKey=mediaKey.lens({
get:function get(mediaKey){
return mediaKey && mediaKey.indexOf('videos/') == 0?mediaKey:null;},

set:function set(mediaKey,videoKey){
return videoKey;}});

view.render(function(){
return Flint.iff(!videoKey.get()) && view.el(
['PicChooser',1],
{if:!videoKey.get(),
initialPicKey:picKey.get(),
editable:pro.editable.get(),
width:pro.width.get(),
height:pro.height.get(),
circle:pro.circle.get(),
picStyle:pro.mediaStyle.get(),
noPicStyle:pro.noMediaStyle.get(),
zoomable:pro.zoomable.get(),
onSelect:function(e){
return picKey.set(e.picKey);},

onZoomIn:view.props.onZoomIn,
onZoomOut:view.props.onZoomOut},

pro.children.get());});

view.render(function(){
return Flint.iff(!picKey.get()) && view.el(
['VideoChooser',1],
{if:!picKey.get(),
initialVideoKey:videoKey.get(),
editable:pro.editable.get()

// Only admins can edit video media right now because the UI is crude
 && context.isAdmin.get(),
circle:pro.circle.get(),
width:pro.width.get(),
height:pro.height.get(),
videoStyle:pro.mediaStyle.get(),
noVideoStyle:pro.noMediaStyle.get(),
zoomable:pro.zoomable.get(),
onSelect:function(e){
return videoKey.set(e.videoKey);},

onZoomIn:view.props.onZoomIn,
onZoomOut:view.props.onZoomOut},

pro.children.get());});});});})();





//# sourceMappingURL=mediaChooser.js.map

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('mframework/views/mmodal.js',function(require){
var _reactModal=require('react-modal');

var _reactModal2=_interopRequireDefault(_reactModal);

Flint.view('MModal',function(view,on,$){
var pro=initPro(view,{
contentStyle:M.mapAtom({}),
overlayStyle:M.mapAtom({}),
isOpen:M.defaultAtom(true),
children:atom()});
view.render(function(){
return view.el(
[_reactModal2.default,'ReactModal',1],
{
appElement:document.getElementById('_flintapp'),
isOpen:pro.isOpen.get(),
onRequestClose:view.props.onRequestClose,
style:{
content:IMap({
top:null,
bottom:null,
left:null,
right:null,
position:null,
display:'flex',
overflow:'auto'}).
merge(pro.contentStyle.get()).toJS(),
overlay:IMap({
display:'flex',
alignItems:'center',
justifyContent:'center',
overflow:null,
zIndex:100}).
merge(pro.overlayStyle.get()).toJS()}},


view.el(
['hack',1],
{id:'_flintapp'},
pro.children.get()));});




// The <hack> tag addresses two problems:
// 1. Flint's styles only work inside a tag with id="_flintapp"
// 2. ReactModal.setAppElement appears to be totally broken.
// Therefore we'll just wrap the modal's elements in a second
// component with id="_flintapp".
});});})();


//# sourceMappingURL=mmodal.js.map

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('mframework/views/motion.js',function(require){
var _reactMotion=require('react-motion');

var _reactMotion2=_interopRequireDefault(_reactMotion);

var RMotion=_reactMotion2.default.Motion;
var RStaggeredMotion=_reactMotion2.default.StaggeredMotion;
var RTransitionMotion=_reactMotion2.default.TransitionMotion;
var spring=_reactMotion2.default.spring;

Flint.view('Motion',function(view,on,$){
var pro=initPro(view,{
defaultStyle:M.mapAtom({}),
style:M.mergeAtom()});


var styleAtom=atom(pro.defaultStyle.get());

var der=styleAtom.derive(function(styleMap){
return view.props.children(styleMap.toJS());});


var elemFunc=function elemFunc(style){
styleAtom.set(immutable.fromJS(style));
return der.get();};
view.render(function(){
return view.el(
[RMotion,'RMotion',1],
{
defaultStyle:pro.defaultStyle.get().toJS(),
style:pro.style.get().toJS()},

(function(){
der.get(); // Register derivable dependencies
return elemFunc;})());});});




Flint.staticStyles('TransitionMotion',{
'$wrapper':'#_flintapp wrapper.TransitionMotion, #_flintapp .TransitionMotion.wrapper, #_flintapp .ViewTransitionMotion.wrapper, #_flintapp .TransitionMotion > .wrapper'},
{
'$wrapper':{
position:'relative'}});


Flint.view('TransitionMotion',function(view,on,$){
var pro=initPro(view,{
defaultStyles:M.mapAtom({}),
styles:M.mapAtom(),
willEnter:atom(),
willLeave:atom()});


var stylesAtom=atom(pro.defaultStyles.get());

var der=stylesAtom.derive(function(stylesMap){
var ret=view.props.children(stylesMap.toJS());
if(ret instanceof List || ret instanceof Array){
return view.el(
['wrapper',1],
null,
ret);}else 

{
return ret;}});



var elemFunc=function elemFunc(styles){
stylesAtom.set(immutable.fromJS(styles));
return der.get();};
view.render(function(){
return view.el(
[RTransitionMotion,'RTransitionMotion',1],
{
defaultStyles:pro.defaultStyles.get().toJS(),
styles:pro.styles.get().toJS(),
willEnter:pro.willEnter.get(),
willLeave:pro.willLeave.get()},

(function(){
der.get(); // Register derivable dependencies
return elemFunc;})());});});});})();






//# sourceMappingURL=motion.js.map

(function(){
Flint.file('mframework/views/optionsPicker.js',function(require){
/*
      props:
        options: [
          {label, value}
        ]
    */

Flint.staticStyles('OptionsPicker',{
'$':'#_flintapp .ViewOptionsPicker'},
{
'$':{
flexDirection:'row',
flexWrap:'wrap'}});


Flint.view('OptionsPicker',function(view,on,$){
var pro=initPro(view,{
innerStyle:M.mapAtom({}),
options:M.listAtom(),
initialValues:M.listAtom([]),
limit:M.defaultAtom(null),
values:M.listAtom()});


var selectedValues=atom(pro.initialValues.get());

pro.values.react(function(propValues){
selectedValues.set(propValues);},
{when:function when(){
return pro.values.get() != null;}});


var onChange=function onChange(value,selected){
var nextSelectedValues=selectedValues.get();

var index=selectedValues.get().indexOf(value);
if(selected){
if(index == -1){
if(pro.limit.get() == null || selectedValues.get().size < pro.limit.get()){
nextSelectedValues = selectedValues.get().push(value).sort(M.util.compare);}else 
if(pro.limit.get() == 1){
nextSelectedValues = List([value]);}}}else 


{
if(index >= 0){
nextSelectedValues = selectedValues.get().splice(index,1);}}



if(pro.values.get() == null){
selectedValues.set(nextSelectedValues);}


if(view.props.onChange){
view.props.onChange({selectedValues:nextSelectedValues});}};



var hoveringIndex=atom(-1);view.render(function(){
return Flint.range(pro.options.get()).map(function(_,_index){
return view.el(
['FilterOption',1,_,_index],
{repeat:pro.options.get(),
selected:selectedValues.get().indexOf(_.value) >= 0,
onChange:function(e){
return onChange(_.value,e.selected);},

onHover:function(e){
return hoveringIndex.set(e.hovering?_index:-1);},

innerStyle:IMap({
padding:[4,8],
margin:4}).
merge(pro.innerStyle.get()).merge(selectedValues.get().size?null:hoveringIndex.get() == _index?null:{background:'#fff'}).toJS()},

_.label);});});});});})();






//# sourceMappingURL=optionsPicker.js.map

(function(){
Flint.file('mframework/views/paginator.js',function(require){
Flint.staticStyles('Paginator',{
'$':'#_flintapp .ViewPaginator'},
{
'$':{
flexDirection:'row'}});


Flint.view('Paginator',function(view,on,$){
var pro=initPro(view,{
initialPageIndex:M.defaultAtom(0),
numPages:atom(),
pageIndex:atom(),
pageRadius:M.defaultAtom(2),
style:M.mergeAtom({
page:{
padding:[8,12],
borderRadius:8,
border:'1px solid #eee',
cursor:'pointer',
margin:2,
background:'white',
color:'#999'},

selectedPage:{
background:'rgb(215, 98, 124)',
fontWeight:'bold',
color:'white'}})});




var pageIndex=atom(pro.initialPageIndex.get());
pro.pageIndex.react(function(propPageIndex){
if(propPageIndex != null){
pageIndex.set(propPageIndex);}});



var requestPage=function requestPage(i){
if(pro.pageIndex.get() == null){
pageIndex.set(i);}


if(view.props.onSelect){
view.props.onSelect({page:i});}};

view.render(function(){
return Flint.iff(pageIndex.get() > 0) && view.el(
['prevSec',1],
{if:pageIndex.get() > 0,
style:pro.style.get().get('page').toJS(),
onClick:function(){
return requestPage(pageIndex.get() - 1);}},


'<');});

view.render(function(){
return Flint.iff(pro.numPages.get() > 1) && Flint.range(2 * pro.pageRadius.get() + 1).map(function(_,_index){
return view.el(
['pageSecWrapper',1,_,_index],
{if:pro.numPages.get() > 1,repeat:2 * pro.pageRadius.get() + 1},
Flint.iff(pageIndex.get() - pro.pageRadius.get() + _index >= 0 && pageIndex.get() - pro.pageRadius.get() + _index < pro.numPages.get()) && view.el(
['pageSec',1,_,_index],
{
if:pageIndex.get() - pro.pageRadius.get() + _index >= 0 && pageIndex.get() - pro.pageRadius.get() + _index < pro.numPages.get(),
onClick:function(){
return requestPage(pageIndex.get() - pro.pageRadius.get() + _index);},

style:pro.style.get().get('page').merge(pageIndex.get() - pro.pageRadius.get() + _index == pageIndex.get()?pro.style.get().get('selectedPage'):{}).toJS()},

pageIndex.get() - pro.pageRadius.get() + _index + 1));});});



view.render(function(){
return Flint.iff(pageIndex.get() < pro.numPages.get() - 1) && view.el(
['nextSec',1],
{if:pageIndex.get() < pro.numPages.get() - 1,
style:pro.style.get().get('page').toJS(),
onClick:function(){
return requestPage(pageIndex.get() + 1);}},


'>');});});});})();





//# sourceMappingURL=paginator.js.map

(function(){
Flint.file('mframework/views/pic.js',function(require){
Flint.view('Pic',function(view,on,$){
var pro=initPro(view,{
picKey:atom(),
style:M.mergeAtom({}),

enhance:M.defaultAtom(true),
faces:M.defaultAtom(false),
fit:M.defaultAtom('crop'),
entropy:M.defaultAtom(false),

zoomable:M.defaultAtom(false)});


var zoomedIn=atom(false);

var imgixUrl=derivation(function(){
var params={
auto:pro.enhance.get()?'enhance':null,
crop:pro.faces.get()?'faces':pro.entropy.get()?'entropy':null,
fit:pro.fit.get(),
w:pro.style.get().get('width') || pro.style.get().get('maxWidth'),
h:pro.style.get().get('height') || pro.style.get().get('maxHeight')};

var paramString=M.util.objToParamString(params);
return '' + M.config.imgixPrefix + pro.picKey.get() + '?' + paramString;});
view.render(function(){
return view.el(
['pic',1],
{
style:IMap({
alignItems:'center',
justifyContent:'center',
cursor:pro.zoomable.get()?'zoom-in':null}).
merge(pro.style.get()).toJS(),
onClick:function(e){
if(pro.zoomable.get()){
zoomedIn.set(true);
if(zoomedIn.get() && view.props.onZoomIn){
view.props.onZoomIn({});}else 
if(!zoomedIn.get() && view.props.onZoomOut){
view.props.onZoomOut({});}}


view.props.onClick && view.props.onClick(e);}},


view.el(['img',1],{
src:imgixUrl.get(),
style:pro.style.get().merge({
width:null,
height:null}).
toJS()}),

Flint.iff(zoomedIn.get()) && view.el(['Lightbox',1],{if:zoomedIn.get(),
onClose:function(){
return zoomedIn.set(false);},

picKeys:[pro.picKey.get()]}));});});});})();






//# sourceMappingURL=pic.js.map

(function(){
Flint.file('mframework/views/picChooser.js',function(require){
Flint.staticStyles('PicChooser',{
'$':'#_flintapp .ViewPicChooser',
'$fbLoading':'#_flintapp fbLoading.PicChooser, #_flintapp .PicChooser.fbLoading, #_flintapp .ViewPicChooser.fbLoading, #_flintapp .PicChooser > .fbLoading',
'$Loader':'#_flintapp .ViewPicChooser .ViewLoader',
'$fromUpload':'#_flintapp fromUpload.PicChooser, #_flintapp .PicChooser.fromUpload, #_flintapp .ViewPicChooser.fromUpload, #_flintapp .PicChooser > .fromUpload',
'$orSection':'#_flintapp orSection.PicChooser, #_flintapp .PicChooser.orSection, #_flintapp .ViewPicChooser.orSection, #_flintapp .PicChooser > .orSection',
'$fromFacebook':'#_flintapp fromFacebook.PicChooser, #_flintapp .PicChooser.fromFacebook, #_flintapp .ViewPicChooser.fromFacebook, #_flintapp .PicChooser > .fromFacebook',
'$deviceIcon':'#_flintapp deviceIcon.PicChooser, #_flintapp .PicChooser.deviceIcon, #_flintapp .ViewPicChooser.deviceIcon, #_flintapp .PicChooser > .deviceIcon',
'$fbIcon':'#_flintapp fbIcon.PicChooser, #_flintapp .PicChooser.fbIcon, #_flintapp .ViewPicChooser.fbIcon, #_flintapp .PicChooser > .fbIcon'},
{
'$':{
flexDirection:'row'},

'$fbLoading':{
border:'1px dashed #ccc',
alignItems:'center',
justifyContent:'center'},

'$Loader':{
marginTop:20},

'$fromUpload':{
alignItems:'center',
position:'relative',
top:-6,
color:'#999',
fontSize:12},

'$orSection':{
marginLeft:20,
marginRight:20,
alignSelf:'center',
color:'#999'},

'$fromFacebook':{
alignItems:'center',
position:'relative',
top:4,
color:'#999',
fontSize:12},

'$deviceIcon':{
opacity:0.7},

'$fbIcon':{
width:40,
height:40,
opacity:0.8,
marginBottom:16}});


Flint.view('PicChooser',function(view,on,$){
var context=initContext(view,{
isMobile:atom()});


var pro=initPro(view,{
initialPicKey:M.defaultAtom(null),
editable:M.defaultAtom(true),
circle:M.defaultAtom(false),
width:M.defaultAtom(300),
height:M.defaultAtom(300),
allowUpload:M.defaultAtom(true),
allowFacebook:M.defaultAtom(false),
picStyle:M.mapAtom({}),
noPicStyle:M.mapAtom({}),
zoomable:M.defaultAtom(false)});


var noPicStyle=derivation(function(){
return IMap({
width:pro.width.get(),
height:pro.height.get(),
alignItems:'center',
justifyContent:'center',
background:'white',
border:'1px dashed #ccc',
borderRadius:pro.circle.get()?'50%':8}).
merge(pro.noPicStyle.get());});


var picKey=atom(pro.initialPicKey.get());
var pendingFbPhoto=atom(null);

picKey.react(function(picKey){
if(view.props.onSelect){
view.props.onSelect({picKey:picKey});}},

{skipFirst:true});

var selectFbPhoto=function selectFbPhoto(photo){
pendingFbPhoto.set(photo);

var biggestImage=null;
photo.images.forEach(function(image){
if(!biggestImage || image.width > biggestImage.width){
biggestImage = image;}});



M.apiPost('transloadPic',{
params:{
url:biggestImage.source}}).

then(function(apiResponse){
pendingFbPhoto.set(null);
picKey.set(apiResponse.picKey);},
function(err){
pendingFbPhoto.set(null);
M.util.alertError(err);});};

view.render(function(){
return Flint.iff(pro.allowUpload.get()) && view.el(
['uploadSection',1],
{if:pro.allowUpload.get()},
view.el(
['UploadPicChooser',1],
{
initialPicKey:pro.initialPicKey.get(),
editable:pro.editable.get(),
width:pro.width.get(),
height:pro.height.get(),
zoomable:pro.zoomable.get(),
circle:pro.circle.get(),
picStyle:pro.picStyle.get(),
noPicStyle:pro.noPicStyle.get(),
onSelect:function(e){
return picKey.set(e.picKey);},

onZoomIn:view.props.onZoomIn,
onZoomOut:view.props.onZoomOut},

view.el(
['fromUpload',1],
null,
view.el(['img',1],{className:'deviceIcon',
src:context.isMobile.get()?"/images/device.png":"/images/computerIconGray.png"}),

context.isMobile.get()?"upload a pic":"upload a pic")));});



view.render(function(){
return Flint.iff(pro.allowUpload.get() && pro.allowFacebook.get()) && view.el(
['orSection',1],
{if:pro.allowUpload.get() && pro.allowFacebook.get()},
'or');});

view.render(function(){
return Flint.iff(pro.allowFacebook.get()) && view.el(
['facebookSection',1],
{if:pro.allowFacebook.get()},
Flint.iff(!pendingFbPhoto.get()) && view.el(
['FacebookPhotoChooser',1],
{
if:!pendingFbPhoto.get(),
editable:pro.editable.get(),
width:pro.width.get(),
height:pro.height.get(),
circle:pro.circle.get(),
picStyle:pro.picStyle.get(),
noPicStyle:pro.noPicStyle.get(),
onSelect:function(_ref){
var photo=_ref.photo;
return selectFbPhoto(photo);}},


view.el(
['fromFacebook',1],
null,
view.el(['img',2],{className:'fbIcon',src:'/images/facebookIconGray.png'}),
'pic from Facebook')),


Flint.iff(pendingFbPhoto.get()) && view.el(
['fbLoading',1],
{if:pendingFbPhoto.get(),
style:noPicStyle.get().toJS()},

view.el(['Loader',1],null)));});




$["fbLoading"] = function(_,_index){
return {
width:pro.width.get(),
height:pro.height.get()};};


'23ff41e5';

$["deviceIcon"] = function(_,_index){
return {
width:context.isMobile.get()?50:80,
height:context.isMobile.get()?50:80,
marginBottom:context.isMobile.get()?10:0};};});});})();




//# sourceMappingURL=picChooser.js.map

(function(){
Flint.file('mframework/views/s3Uploader.js',function(require){
/*
      Props:
        onStartUpload: ({file}) => void
        onUploaded: ({s3Key}) => void
    */

Flint.view('S3Uploader',function(view,on,$){
var pro=initPro(view,{
accept:atom(),
children:atom()});


var uploading=atom(false);

var handleFile=function handleFile(e){
var file=e.target.files[0];
var s3Key=undefined;

uploading.set(true);

M.apiPost('signS3Upload',{
params:{
fileType:file.type}}).

then(function(apiResponse){
s3Key = apiResponse.s3Key;
var s3Url='' + M.config.s3UrlPrefix + s3Key;

return fetch(apiResponse.signedRequest,{
method:'put',
headers:{
'x-amz-acl':'public-read'},

body:file});},

function(err){
uploading.set(false);
console.error("Error signing S3 upload:",err);
M.util.alertError(err);}).
then(function(s3Response){
uploading.set(false);

if(view.props.onUploaded){
view.props.onUploaded({s3Key:s3Key});}},

function(err){
uploading.set(false);
console.error("Error uploading to S3:",err);});


if(view.props.onStartUpload){
view.props.onStartUpload({file:file});}};

view.render(function(){
return Flint.iff(!uploading.get()) && view.el(
['notUploading',1],
{if:!uploading.get()},
view.el(
['Uploader',1],
{accept:pro.accept.get(),onChange:handleFile},
pro.children.get()));});


view.render(function(){
return Flint.iff(uploading.get()) && view.el(
['uploading',1],
{if:uploading.get()},
pro.children.get());});});});})();





//# sourceMappingURL=s3Uploader.js.map

(function(){
Flint.file('mframework/views/scrollable.js',function(require){
Flint.staticStyles('Scrollable',{
'$':'#_flintapp .ViewScrollable',
'$container':'#_flintapp container.Scrollable, #_flintapp .Scrollable.container, #_flintapp .ViewScrollable.container, #_flintapp .Scrollable > .container',
'$scrollable':'#_flintapp scrollable.Scrollable, #_flintapp .Scrollable.scrollable, #_flintapp .ViewScrollable.scrollable, #_flintapp .Scrollable > .scrollable',
'$scrollContent':'#_flintapp scrollContent.Scrollable, #_flintapp .Scrollable.scrollContent, #_flintapp .ViewScrollable.scrollContent, #_flintapp .Scrollable > .scrollContent',
'$topShadow':'#_flintapp topShadow.Scrollable, #_flintapp .Scrollable.topShadow, #_flintapp .ViewScrollable.topShadow, #_flintapp .Scrollable > .topShadow',
'$bottomShadow':'#_flintapp bottomShadow.Scrollable, #_flintapp .Scrollable.bottomShadow, #_flintapp .ViewScrollable.bottomShadow, #_flintapp .Scrollable > .bottomShadow'},
{
'$':{
overflow:'auto',
alignItems:'stretch',
position:'relative'},

'$container':{
overflow:'auto',
flexGrow:1,
alignItems:'stretch'},

'$scrollable':{
overflow:'auto',
alignItems:'stretch',
flexGrow:1},

'$scrollContent':{
flexGrow:1,
alignItems:'stretch'},

'$topShadow':{
position:'absolute',
pointerEvents:'none',
zIndex:2,
top:0,

left:0,
right:0,
height:3,
background:'linear-gradient(to bottom, rgba(150, 150, 150, 0.8) 0%, rgba(150, 150, 150, 0) 100%)'},

'$bottomShadow':{
position:'absolute',
pointerEvents:'none',
zIndex:2,
bottom:0,

left:0,
right:0,
height:3,
background:'linear-gradient(to bottom, rgba(150, 150, 150, 0) 0%, rgba(150, 150, 150, 0.8) 100%)'}});


Flint.view('Scrollable',function(view,on,$){
var pro=initPro(view,{
autoBottom:M.defaultAtom(false),
children:atom()});


var elem=atom();
var offsetHeight=atom();
var scrollHeight=atom();
var scrollTop=atom(0);

var scrollHeightAfterAuto=atom();
var scrollTopAfterAuto=atom();

var atTop=derivation(function(){
return scrollTop.get() == 0;});


var atBottom=derivation(function(){
if(elem.get() && offsetHeight.get()){
return scrollTop.get() >= scrollHeight.get() - offsetHeight.get();}else 
{
return false;}});



scrollHeight.react(function(scrollHeight){
if(elem.get() && pro.autoBottom.get() && (scrollHeightAfterAuto.get() == undefined || scrollHeight > scrollHeightAfterAuto.get() && scrollTop.get() >= scrollTopAfterAuto.get() - 5)){
elem.get().scrollTop = elem.get().scrollHeight;
transact(function(){
scrollHeightAfterAuto.set(elem.get().scrollHeight);
scrollTopAfterAuto.set(elem.get().scrollTop);});}});




on.change(function(){
on.delay(1,function(){
if(elem.get()){
transact(function(){
scrollHeight.set(elem.get().scrollHeight);
offsetHeight.set(elem.get().offsetHeight);});}});});



view.render(function(){
return view.el(
['scrollable',1],
{
ref:function(el){
return elem.set(el);},

onScroll:function(e){
scrollTop.set(e.target.scrollTop);}},


view.el(
['scrollContent',1],
null,
pro.children.get()));});


view.render(function(){
return view.el(['topShadow',1],null);});
view.render(function(){
return view.el(['bottomShadow',1],null);});


$["topShadow"] = function(_,_index){
return {visibility:atTop.get()?'hidden':'visible'};};


$["bottomShadow"] = function(_,_index){
return {visibility:atBottom.get()?'hidden':'visible'};};});});})();




//# sourceMappingURL=scrollable.js.map

var _defineProperty=require('babel-runtime/helpers/define-property').default;

var _Object$keys=require('babel-runtime/core-js/object/keys').default;

(function(){
Flint.file('mframework/views/slideTransitioner.js',function(require){
var _reactMotion=require('react-motion');

Flint.staticStyles('SlideTransitioner',{
'$':'#_flintapp .ViewSlideTransitioner',
'$thing':'#_flintapp thing.SlideTransitioner, #_flintapp .SlideTransitioner.thing, #_flintapp .ViewSlideTransitioner.thing, #_flintapp .SlideTransitioner > .thing'},
{
'$':{},
'$thing':{
position:'absolute'}});


Flint.view('SlideTransitioner',function(view,on,$){
var pro=initPro(view,{
children:atom(),
selectedIndex:M.defaultAtom(-1),
springStiffness:M.defaultAtom(290),
springDamping:M.defaultAtom(29),
width:M.defaultAtom(100)});


var desiredIndex=atom();
pro.selectedIndex.react(function(propSelectedIndex){
if(propSelectedIndex != null){
desiredIndex.set(propSelectedIndex);}});



var children=pro.children.derive(function(c){
return List(React.Children.toArray(c));});


var selectedIndex=derivation(function(){
return Math.min(desiredIndex.get(),children.get().size);});


var makeSpring=function makeSpring(targetValue){
return (0,_reactMotion.spring)(targetValue,[pro.springStiffness.get(),pro.springDamping.get()]);};
view.render(function(){
return view.el(
['TransitionMotion',1],
{
defaultStyles:(function(){
return selectedIndex.get() == -1?{}:_defineProperty({},selectedIndex.get(),{
left:-pro.width.get()});})(),


styles:(function(){
return selectedIndex.get() == -1?{}:_defineProperty({},selectedIndex.get(),{
left:makeSpring(0)});})(),


willEnter:function(i){
return {
left:-pro.width.get()};},


willLeave:function(i){
return {
left:makeSpring(-pro.width.get())};}},



function(styles){
return Flint.range(_Object$keys(styles)).map(function(_,_index){
return view.el(
['thing',1,_,_index],
{repeat:_Object$keys(styles),key:_,style:styles[_]},
children.get().get(_));});});});});});})();








//# sourceMappingURL=slideTransitioner.js.map

(function(){
Flint.file('mframework/views/slider.js',function(require){
/*
      Wrapper for jQuery UI Slider
    */

Flint.staticStyles('Slider',{
'$':'#_flintapp .ViewSlider',
'$slider':'#_flintapp slider.Slider, #_flintapp .Slider.slider, #_flintapp .ViewSlider.slider, #_flintapp .Slider > .slider',
'$notch':'#_flintapp notch.Slider, #_flintapp .Slider.notch, #_flintapp .ViewSlider.notch, #_flintapp .Slider > .notch',
'$valueLabelContainer':'#_flintapp valueLabelContainer.Slider, #_flintapp .Slider.valueLabelContainer, #_flintapp .ViewSlider.valueLabelContainer, #_flintapp .Slider > .valueLabelContainer'},
{
'$':{
position:'relative'},

'$slider':{
zIndex:2,
borderStyle:'solid',
borderWidth:1,
borderTopColor:'#ddd',
borderLeftColor:'#ddd',
borderBottomColor:'#aaa',
borderRightColor:'#aaa'},

'$notch':{
position:'absolute',

width:2,
borderLeft:'1px solid rgba(50, 50, 50, 0.5)', //#6e7a8d',
borderRight:'1px solid rgba(200, 200, 200, 0.5)',
zIndex:2},

'$valueLabelContainer':{
flexDirection:'row',
position:'absolute',
width:0,

fontSize:13,
whiteSpace:'nowrap'}});


Flint.view('Slider',function(view,on,$){
var context=initContext(view,{
colors:atom()});


var pro=initPro(view,{
value:atom(),
values:M.listAtom(),

width:M.defaultAtom(400),
min:M.defaultAtom(0),
max:M.defaultAtom(100),
handleWidth:M.defaultAtom(14),
handleHeight:M.defaultAtom(14),
labelContent:atom(),
labelHeight:M.defaultAtom(26),
notchInterval:M.defaultAtom(1),
centerLabel:M.defaultAtom(true),
barHeight:M.defaultAtom(8),
range:M.defaultAtom(false), // true, false, 'min', 'max'
rangeStyle:M.mapAtom({}),
handleStyle:M.mapAtom({}),
barStyle:M.mapAtom({})});


var numNotches=derivation(function(){
if(pro.notchInterval.get()){
return Math.max(0,Math.floor((pro.max.get() - pro.min.get()) / pro.notchInterval.get() - 1));}else 
{
return 0;}});



var barWidth=derivation(function(){
return pro.width.get() - pro.handleWidth.get();});


var values=M.listAtom(pro.values.get() || List([pro.value.get() || 0]));

var hovering=atom(false);
hovering.reactor(function(hovering){
if(view.props.onHover)view.props.onHover({hovering:hovering});}).
start();

var rangeStyle=derivation(function(){
return IMap({
height:pro.barHeight.get(),
background:'rgba(221, 19, 123, 0.75)',
borderRadius:1,
zIndex:2}).
merge(pro.rangeStyle.get());});


var handleStyle=derivation(function(){
return IMap({
background:'black',
borderRadius:'50%',
cursor:'pointer',
height:pro.handleHeight.get(),
width:pro.handleWidth.get(),
border:'none',
top:pro.barHeight.get() / 2 - pro.handleHeight.get() / 2,
marginLeft:-pro.handleWidth.get() / 2 + 2,
zIndex:2}).
merge(hovering.get()?{
background:'black'}:
null).merge(pro.handleStyle.get());});


var barStyle=derivation(function(){
return IMap({
background:'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #ceced9 100%)',
cursor:'pointer',
borderRadius:2}).
merge(pro.barStyle.get());});


var slider=atom();
slider.react(function(slider){
if(slider){
jQuery(slider).slider({
range:pro.range.get(),
min:pro.min.get(),
max:pro.max.get(),
value:pro.value.get(),
values:pro.value.get() == null?values.get().toJS():null,
slide:function slide(event,ui){
if(view.props.onSlide){
var ret=view.props.onSlide({
value:ui.value,
values:ui.values});

if(ret === false){
event.preventDefault();
return;}}


values.set(List(ui.values || [ui.value]));}});



styleJQuery();}});



pro.value.react(function(propValue){
jQuery(slider.get()).slider({value:propValue});},
{when:function when(){
return pro.value.get() != null && slider.get();}});


var styleJQuery=function styleJQuery(){
if(!slider.get())return;

jQuery(slider.get()).css(barStyle.get().toJS());
jQuery(slider.get()).find('.ui-slider-range').css(rangeStyle.get().toJS());
jQuery(slider.get()).find('.ui-slider-handle').attr({
/* The tabIndex is a jQuery UI accessibility feature
             but it makes an awkward rectangle around the focused
             slider control. */
tabIndex:null}).
css(handleStyle.get().toJS());};


derivation(function(){
return List([barStyle.get(),rangeStyle.get(),handleStyle.get()]);}).
reactor(styleJQuery).start();

var getLabelContent=function getLabelContent(value){
if(pro.labelContent.get() instanceof Function){
return pro.labelContent.get()(value);}else 
if(pro.labelContent.get() === true){
return '' + value;}else 
if(pro.labelContent.get()){
return pro.labelContent.get();}else 
{
return null;}};

view.render(function(){
return view.el(
['slider',1],
{ref:function(elem){
return slider.set(elem);},

onClick:view.props.onClick,
onMouseDown:view.props.onMouseDown,
onMouseUp:view.props.onMouseUp,
onMouseEnter:function(){
return hovering.set(true);},

onMouseLeave:function(){
return hovering.set(false);}},


Flint.range(numNotches.get()).map(function(_,_index){
return view.el(['notch',1,_,_index],{repeat:numNotches.get()});}));});


view.render(function(){
return Flint.iff(pro.labelContent.get()) && Flint.range(values.get()).map(function(_,_index){
return view.el(
['valueLabelContainer',1,_,_index],
{if:pro.labelContent.get(),repeat:values.get()},
getLabelContent(_));});});




$["$"] = function(_,_index){
return {
paddingTop:Math.max(0,(pro.handleHeight.get() - pro.barHeight.get()) / 2) - 2 + (pro.labelContent.get()?pro.labelHeight.get():0),
paddingBottom:Math.max(0,(pro.handleHeight.get() - pro.barHeight.get()) / 2) - 2,
paddingLeft:pro.handleWidth.get() / 2,
paddingRight:pro.handleWidth.get() / 2};};


$["slider"] = function(_,_index){
return {
width:pro.width.get() - pro.handleWidth.get(),
height:pro.barHeight.get() + 2};};


$["notch"] = function(_,_index){
return {height:pro.barHeight.get(),left:barWidth.get() * (_index + 1) / (numNotches.get() + 1)};};



$["valueLabelContainer"] = function(_,_index){
return {justifyContent:pro.centerLabel.get()?'center':null,
marginTop:-pro.handleHeight.get() / 2 - pro.labelHeight.get(),
left:4 + (pro.centerLabel.get()?pro.handleWidth.get() / 2 + (pro.width.get() - pro.handleWidth.get()) * (values.get().get(_index) - pro.min.get()) / (pro.max.get() - pro.min.get()):(pro.width.get() - pro.handleWidth.get()) * (values.get().get(_index) - pro.min.get()) / (pro.max.get() - pro.min.get()))};};});});})();




//# sourceMappingURL=slider.js.map

(function(){
Flint.file('mframework/views/sortable.js',function(require){
/*
      Wrapper for Sortable
      https://github.com/RubaXa/Sortable
    */

Flint.staticStyles('Sortable',{
'$ghost':'#_flintapp ghost.Sortable, #_flintapp .Sortable.ghost, #_flintapp .ViewSortable.ghost, #_flintapp .Sortable > .ghost'},
{
'$ghost':{
opacity:0}});


Flint.viewRoots["Sortable"] = 'sortable';
Flint.view('Sortable',function(view,on,$){
var pro=initPro(view,{
children:atom(),
animation:M.defaultAtom(150),
enabled:M.defaultAtom(true),
ghostClass:M.defaultAtom('ghost'),
handle:atom(),
filter:M.defaultAtom('.noDrag'),
group:atom()});


var children=pro.children.derive(function(propChildren){
if(propChildren instanceof Array){
return propChildren;}else 
{
return [propChildren];}});



var wrapper=atom();
var sortable=atom();

var initSortable=function initSortable(){
if(sortable.get()){
sortable.get().destroy();}

sortable.set(window.Sortable.create(wrapper.get(),{
animation:pro.animation.get(),
ghostClass:pro.ghostClass.get(),
handle:pro.handle.get(),
filter:pro.filter.get(),
group:pro.group.get(),

onStart:view.props.onStart,
onEnd:view.props.onEnd,
onAdd:view.props.onAdd,
onUpdate:view.props.onUpdate,
onSort:view.props.onSort,
onRemove:view.props.onRemove,
onFilter:view.props.onFilter,
onMove:view.props.onMove}));};



wrapper.react(function(wrapper){
if(wrapper){
if(pro.enabled.get()){
initSortable();}}else 

{
if(sortable.get()){
sortable.get().destroy();
sortable.set(null);}}});


view.render(function(){
return view.el(
['sortable',1],
{key:pro.enabled.get()?children.get().map(function(c){
return c.key;}).
join('\n'):'frozen',
ref:wrapper.set.bind(wrapper)},

children.get());});});});})();





//# sourceMappingURL=sortable.js.map

(function(){
Flint.file('mframework/views/tabs.js',function(require){
Flint.staticStyles('Tabs',{
'$':'#_flintapp .ViewTabs'},
{
'$':{
flexDirection:'row'}});


Flint.view('Tabs',function(view,on,$){
var context=initContext(view,{
colors:atom()});


var pro=initPro(view,{
// [{value, label}]
options:M.listAtom(),

initialSelectedValue:atom(),
selectedValue:atom(),
style:M.mergeAtom({})});


var selectedValue=atom(pro.initialSelectedValue.get());
pro.selectedValue.react(function(propSelectedValue){
if(propSelectedValue !== undefined){
selectedValue.set(propSelectedValue);}});



var selectedIndex=derivation(function(){
if(selectedValue == null){
return -1;}

return pro.options.get().findIndex(selectedValue.get());});


selectedValue.reactor(function(selectedValue){
if(view.props.onSelect)view.props.onSelect({value:selectedValue});}).
start();view.render(function(){
return Flint.range(pro.options.get()).map(function(_,_index){
return view.el(
['tab',1,_,_index],
{repeat:pro.options.get(),
onClick:function(){
return selectedValue.set(_.value);},

style:IMap({
background:selectedValue.get() == _.value?'white':'#ececf0',
color:selectedValue.get() == _.value?context.colors.get().accent:'#70767b',
fontFamily:'bebas',
fontStyle:'italic',
wordSpacing:4,
cursor:selectedValue.get() == _.value?null:'pointer',
padding:[12,20],
borderRadius:[8,8,0,0],
borderStyle:'solid',
borderWidth:1,
borderLeftColor:selectedValue.get() == _.value?'#ccc':'#ddd',
borderTopColor:selectedValue.get() == _.value?'#ccc':'#ddd',
borderRightColor:selectedValue.get() == _.value?'#ccc':'#ddd',
borderBottomColor:selectedValue.get() == _.value?'white':'#ccc',
position:'relative',
zIndex:1,
top:1}).
merge(pro.style.get().get('tab') || {}).toJS()},

_.label);});});});});})();






//# sourceMappingURL=tabs.js.map

(function(){
Flint.file('mframework/views/textBox.js',function(require){
'use strict';

Flint.staticStyles('TextBox',{
'$':'#_flintapp .ViewTextBox'},
{
'$':{}});

Flint.view('TextBox',function(view,on,$){
var pro=initPro(view,{
autoFocus:M.defaultAtom(false),
autoSelect:M.defaultAtom(false),
enabled:M.defaultAtom(true),
multiline:M.defaultAtom(false),
initialValue:M.defaultAtom(''),
value:atom(),
inpStyle:M.mapAtom({}),
placeholder:atom(),
tabIndex:atom(),
type:M.defaultAtom('text'),
pattern:atom()});


if(view.props.onInit){
view.props.onInit(view);}


var inp=atom();
var hovering=atom(false);

view.focus = function(){
inp.get() && inp.get().focus();};


view.blur = function(){
inp.get() && inp.get().blur();};


var value=atom(pro.initialValue.get());
pro.value.react(function(propValue){
if(propValue != null){
value.set(propValue);}});



value.react(function(value){
if(inp.get() && inp.get().value != value){
inp.get().value = value;}});



var onChange=function onChange(newValueFromUser){
if(pro.value.get() == null){
value.set(newValueFromUser);}


view.props.onChange && view.props.onChange({value:newValueFromUser});};


var onKeyDown=function onKeyDown(e){
if(e.key == 'Enter' && view.props.onEnter){
view.props.onEnter({value:value.get()});}else 
if(e.key == 'Escape' && view.props.onEscape){
view.props.onEscape({value:value.get()});}


if(view.props.onKeyDown)view.props.onKeyDown({event:e});};


var onFocus=function onFocus(e){
if(pro.autoSelect.get()){
on.delay(1,function(){
if(inp.get()){
inp.get().select();}});}



if(view.props.onFocus)view.props.onFocus(e);};

var onBlur=function onBlur(e){
if(view.props.onBlur)view.props.onBlur(e);};


var onMouseEnter=function onMouseEnter(e){
hovering.set(true);
if(view.props.onMouseEnter)view.props.onMouseEnter(e);};

var onMouseLeave=function onMouseLeave(e){
hovering.set(false);
if(view.props.onMouseLeave)view.props.onMouseLeave(e);};

hovering.react(function(hovering){
if(view.props.onHover)view.props.onHover({hovering:hovering});});
view.render(function(){
return Flint.iff(!pro.multiline.get()) && view.el(['input',1],{className:'inp',if:!pro.multiline.get(),
ref:function(elem){
if(elem)inp.set(elem);},

type:pro.type.get() || 'text',
pattern:pro.pattern.get(),
autoFocus:pro.autoFocus.get(),
defaultValue:value.get(),
disabled:!pro.enabled.get(),
onChange:function(e){
return onChange(e.target.value);},

onKeyDown:onKeyDown,
onFocus:onFocus,
onBlur:onBlur,
onMouseEnter:onMouseEnter,
onMouseLeave:onMouseLeave,
style:pro.inpStyle.get().toJS(),
placeholder:pro.placeholder.get(),
tabIndex:pro.tabIndex.get(),
onClick:view.props.onClick});});

view.render(function(){
return Flint.iff(pro.multiline.get()) && view.el(['textarea',1],{className:'inp',if:pro.multiline.get(),
ref:function(elem){
if(elem)inp.set(elem);},

autoFocus:pro.autoFocus.get(),
defaultValue:value.get(),
disabled:!pro.enabled.get(),
onChange:function(e){
return onChange(e.target.value);},

onKeyDown:onKeyDown,
onFocus:onFocus,
onBlur:onBlur,
onMouseEnter:onMouseEnter,
onMouseLeave:onMouseLeave,
placeholder:pro.placeholder.get(),
style:pro.inpStyle.get().toJS(),
tabIndex:pro.tabIndex.get(),
onClick:view.props.onClick});});});});})();





//# sourceMappingURL=textBox.js.map

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('mframework/views/timestamp.js',function(require){
var _moment=require('moment');

var _moment2=_interopRequireDefault(_moment);

Flint.staticStyles('Timestamp',{
'$timestamp':'#_flintapp .ViewTimestamp'},
{
'$timestamp':{}});

Flint.viewRoots["Timestamp"] = 'timestamp';
Flint.view('Timestamp',function(view,on,$){
var context=initContext(view,{
fonts:atom()});


var pro=initPro(view,{
timestamp:atom()});


var timestampString=atom((0,_moment2.default)(pro.timestamp.get()).fromNow());

on.every(5000,function(){
timestampString.set((0,_moment2.default)(pro.timestamp.get()).fromNow());});
view.render(function(){
return view.el(
['timestamp',1],
null,
timestampString.get());});



$["timestamp"] = function(_,_index){
return {
font:context.fonts.get().normal};};});});})();





//# sourceMappingURL=timestamp.js.map

(function(){
Flint.file('mframework/views/triangle.js',function(require){
Flint.view('Triangle',function(view,on,$){
var pro=initPro(view,{
pointAngle:M.defaultAtom('down'),
style:M.mergeAtom({
color:'black',
width:50})});

view.render(function(){
return Flint.iff(pro.pointAngle.get() == 'down') && view.el(['triangle',1],{if:pro.pointAngle.get() == 'down',style:{
width:0,
height:0,
borderStyle:['solid','solid','none','solid'],
borderWidth:[pro.style.get().get('height'),pro.style.get().get('width'),0,pro.style.get().get('width')],
borderColor:pro.style.get().get('color') + ' transparent transparent transparent'}});});

view.render(function(){
return Flint.iff(pro.pointAngle.get() == 'up') && view.el(['triangle',2],{if:pro.pointAngle.get() == 'up',style:{
width:0,
height:0,
borderStyle:['none','solid','solid','solid'],
borderWidth:[0,pro.style.get().get('width'),pro.style.get().get('height'),pro.style.get().get('width')],
borderColor:'transparent transparent ' + pro.style.get().get('color') + ' transparent'}});});});});})();





//# sourceMappingURL=triangle.js.map

(function(){
Flint.file('mframework/views/uploadPicChooser.js',function(require){
Flint.staticStyles('UploadPicChooser',{
'$actionRow':'#_flintapp actionRow.UploadPicChooser, #_flintapp .UploadPicChooser.actionRow, #_flintapp .ViewUploadPicChooser.actionRow, #_flintapp .UploadPicChooser > .actionRow',
'$uploader':'#_flintapp uploader.UploadPicChooser, #_flintapp .UploadPicChooser.uploader, #_flintapp .ViewUploadPicChooser.uploader, #_flintapp .UploadPicChooser > .uploader'},
{
'$actionRow':{
flexDirection:'row',
width:'100%',
justifyContent:'space-around'},

'$uploader':{
flexGrow:1}});


Flint.view('UploadPicChooser',function(view,on,$){
var pro=initPro(view,{
initialPicKey:M.defaultAtom(null),
editable:M.defaultAtom(true),
width:M.defaultAtom(300),
height:M.defaultAtom(168),
circle:M.defaultAtom(false),
children:atom(),
picStyle:M.mapAtom({}),
noPicStyle:M.mapAtom({}),
zoomable:M.defaultAtom(false)});


var picKey=atom(pro.initialPicKey.get());
var uploading=atom(false);

picKey.react(function(picKey){
if(view.props.onSelect){
view.props.onSelect({picKey:picKey});}

M.mixpanel.track("UploadPicChooserSelect",{picKey:picKey});},
{skipFirst:true});

var noPicStyle=derivation(function(){
return IMap({
width:pro.width.get(),
height:pro.height.get(),
alignItems:'center',
justifyContent:'center',
background:'white',
border:'1px dashed #ccc',
borderRadius:pro.circle.get()?'50%':8}).
merge(pro.noPicStyle.get());});
view.render(function(){
return view.el(
['picSection',1],
null,
Flint.iff(picKey.get() && !uploading.get()) && view.el(['Pic',1],{if:picKey.get() && !uploading.get(),
picKey:picKey.get(),
faces:true,
zoomable:pro.zoomable.get(),
onZoomIn:view.props.onZoomIn,
onZoomOut:view.props.onZoomOut,
style:IMap({
width:pro.width.get(),
height:pro.height.get(),
borderRadius:pro.circle.get()?'50%':null}).
merge(pro.picStyle.get()).toJS()}),

Flint.iff(pro.editable.get() && !picKey.get() && !uploading.get()) && view.el(
['S3Uploader',1],
{if:pro.editable.get() && !picKey.get() && !uploading.get(),
accept:'image/*',
onStartUpload:function(){
return uploading.set(true);},

onUploaded:function(e){
uploading.set(false);
picKey.set(e.s3Key);}},


view.el(
['noPic',1],
{style:noPicStyle.get().toJS()},
pro.children.get())),


Flint.iff(!pro.editable.get() && !picKey.get() && !uploading.get()) && view.el(['noPic',2],{if:!pro.editable.get() && !picKey.get() && !uploading.get(),
style:noPicStyle.get().toJS()}),

Flint.iff(uploading.get()) && view.el(
['noPic',3],
{if:uploading.get(),style:noPicStyle.get().toJS()},
view.el(['Loader',1],null)));});


view.render(function(){
return Flint.iff(picKey.get() && pro.editable.get()) && view.el(
['actionRow',1],
{if:picKey.get() && pro.editable.get()},
view.el(
['S3Uploader',2],
{
accept:'image/*',
onStartUpload:function(){
return uploading.set(true);},

onUploaded:function(e){
uploading.set(false);
picKey.set(e.s3Key);}},


view.el(['EditLink',1],null)),

view.el(['DeleteButton',1],{onClick:function(){
return picKey.set(null);}}));});});});})();






//# sourceMappingURL=uploadPicChooser.js.map

(function(){
Flint.file("mframework/views/uploader.js",function(require){
Flint.staticStyles("Uploader",{
"$label":"#_flintapp label.Uploader, #_flintapp .Uploader.label, #_flintapp .ViewUploader.label, #_flintapp .Uploader > .label",
"$input":"#_flintapp input.Uploader, #_flintapp .Uploader.input, #_flintapp .ViewUploader.input, #_flintapp .Uploader > .input"},
{
"$label":{
position:'relative',
overflow:'hidden'},

"$input":{
position:'absolute',
cursor:'pointer',
borderRadius:0,

// Get the button+text UI out of the visible container area because
// e.g. the button doesn't have the cursor:'pointer' style we want.
width:2000,
left:-500,
right:0,
top:0,
bottom:0,

background:'yellow'}});


Flint.view("Uploader",function(view,on,$){
var context=initContext(view,{
isMobile:atom()});


var pro=initPro(view,{
accept:atom(),
children:atom()});


var dragging=atom(false);view.render(function(){
return view.el(
["label",1],
{
onDragEnter:function(){
return dragging.set(true);},

onDragLeave:function(){
return dragging.set(false);}},


view.el(
["childrenSec",1],
null,
pro.children.get() || "Choose file..."),

view.el(["input",1],{
type:"file",
capture:"camera",
accept:pro.accept.get(),
onChange:view.props.onChange}));});




$["input"] = function(_,_index){
return {opacity:dragging.get()?0.3:0};};});});})();





//# sourceMappingURL=uploader.js.map

(function(){
Flint.file('mframework/views/video.js',function(require){
var _reactMotion=require('react-motion');

Flint.view('Video',function(view,on,$){
var context=initContext(view,{
colors:atom()});


var pro=initPro(view,{
videoKey:M.requiredAtom(),

// Wrapping Wistia config
allowPause:M.defaultAtom(true), // WARNING: False messes up mobile browsers
allowPlay:M.defaultAtom(true),
autoPlay:M.defaultAtom(false),
controlsVisibleOnLoad:M.defaultAtom(true),
endVideoBehavior:M.defaultAtom('default'), // default | reset | loop
initialTime:M.defaultAtom(null),
initialVolume:M.defaultAtom(null), // null means previous Wistia setting
playerColor:M.defaultAtom(context.colors.get().accent),
showPlaybar:M.defaultAtom(true),
showVolume:M.defaultAtom(true),
wmode:M.defaultAtom('transparent'),

// Non-Wistia config
enabled:M.defaultAtom(true),
smoothVolume:M.defaultAtom(false),

// Style
circle:M.defaultAtom(false),
height:M.defaultAtom(400 * 9 / 16),
width:M.defaultAtom(400),
videoStyle:M.mapAtom({}),

// Parent-controlled state
playing:atom(),
time:atom(),
volume:atom()});
view.render(function(){
return view.el(['WistiaVideo',1],{
videoKey:pro.videoKey.get(),
allowPause:pro.allowPause.get(),
allowPlay:pro.allowPlay.get(),
autoPlay:pro.autoPlay.get(),
controlsVisibleOnLoad:pro.controlsVisibleOnLoad.get(),
endVideoBehavior:pro.endVideoBehavior.get(),
initialTime:pro.initialTime.get(),
initialVolume:pro.initialVolume.get(),
playerColor:pro.playerColor.get(),
showPlaybar:pro.showPlaybar.get(),
showVolume:pro.showVolume.get(),
wmode:pro.wmode.get(),

enabled:pro.enabled.get(),
smoothVolume:pro.smoothVolume.get(),

circle:pro.circle.get(),
height:pro.height.get(),
width:pro.width.get(),
videoStyle:pro.videoStyle.get(),

playing:pro.playing.get(),
time:pro.time.get(),
volume:pro.volume.get(),

onEnd:view.props.onEnd,
onTime:view.props.onTime,
onVideoData:view.props.onVideoData});});});});})();





//# sourceMappingURL=video.js.map

(function(){
Flint.file('mframework/views/videoChooser.js',function(require){
Flint.staticStyles('VideoChooser',{
'$actionRow':'#_flintapp actionRow.VideoChooser, #_flintapp .VideoChooser.actionRow, #_flintapp .ViewVideoChooser.actionRow, #_flintapp .VideoChooser > .actionRow'},
{
'$actionRow':{
flexDirection:'row',

justifyContent:'space-around'}});


Flint.view('VideoChooser',function(view,on,$){
var pro=initPro(view,{
initialVideoKey:M.defaultAtom(null),
editable:M.defaultAtom(true),
circle:M.defaultAtom(false),
width:M.defaultAtom(300),
height:M.defaultAtom(300),
videoStyle:M.mapAtom({}),
noVideoStyle:M.mapAtom({}),
zoomable:M.defaultAtom(false),

// If we get children, the children are the viewer when we have a videoKey.
// Otherwise we'll provide our own viewer.
children:atom()});


var videoKey=atom(pro.initialVideoKey.get());

var workingVideoKey=atom(null);

var editing=atom(false);

var previewVideoKey=derivation(function(){
return editing.get()?workingVideoKey.get():videoKey.get();});


videoKey.react(function(videoKey){
if(pro.editable.get() && !videoKey){
editing.set(true);}});



editing.react(function(editing){
if(editing){
workingVideoKey.set(videoKey.get());}});



var select=function select(){
videoKey.set(workingVideoKey.get());

if(view.props.onSelect){
view.props.onSelect({videoKey:videoKey.get()});}


editing.set(false);};


var wistiaId=workingVideoKey.lens({
get:function get(videoKey){
return videoKey?videoKey.split('/')[2]:null;},

set:function set(videoKey,wistiaId){
return wistiaId?'videos/wistia/' + wistiaId:null;}});

view.render(function(){
return Flint.iff(editing.get()) && view.el(
['editSection',1],
{if:editing.get()},
view.el(['TextBox',1],{className:'inpVideoKey',
placeholder:'Wistia video hash-id',
value:wistiaId.or(''),
onChange:function(e){
return wistiaId.set(e.value.trim() || null);},

onEnter:select,
inpStyle:{
width:pro.width.get()}}));});



view.render(function(){
return Flint.iff(!videoKey.get()) && view.el(['noVideo',1],{if:!videoKey.get(),
style:pro.noVideoStyle.get()});});

view.render(function(){
return Flint.iff(!editing.get() && videoKey.get() && !pro.children.get() || editing.get() && previewVideoKey.get()) && view.el(['Video',1],{if:!editing.get() && videoKey.get() && !pro.children.get() || editing.get() && previewVideoKey.get(),
videoKey:previewVideoKey.get(),
width:pro.width.get(),
height:pro.height.get(),
circle:pro.circle.get(),
videoStyle:pro.videoStyle.get()});});

view.render(function(){
return Flint.iff(!editing.get() && videoKey.get() && pro.children.get()) && view.el(
['customViewMode',1],
{if:!editing.get() && videoKey.get() && pro.children.get()},
pro.children.get());});

view.render(function(){
return Flint.iff(pro.editable.get() && !editing.get()) && view.el(
['actionRow',1],
{if:pro.editable.get() && !editing.get()},
view.el(['EditLink',1],{onClick:function(){
return editing.set(true);}}),

Flint.iff(videoKey.get()) && view.el(['DeleteButton',1],{if:videoKey.get(),onClick:function(){
workingVideoKey.set(null);
select();}}));});




'26e8dd5d';

$["actionRow"] = function(_,_index){
return {width:pro.width.get()};};});});})();




//# sourceMappingURL=videoChooser.js.map

(function(){
Flint.file('mframework/views/videoThumbnail.js',function(require){
Flint.staticStyles('VideoThumbnail',{
'$':'#_flintapp .ViewVideoThumbnail',
'$Loader':'#_flintapp .ViewVideoThumbnail .ViewLoader',
'$img':'#_flintapp img.VideoThumbnail, #_flintapp .VideoThumbnail.img, #_flintapp .ViewVideoThumbnail.img, #_flintapp .VideoThumbnail > .img'},
{
'$':{
borderRadius:8,
alignItems:'center',
justifyContent:'center'},

'$Loader':{
opacity:0.1},

'$img':{}});

Flint.view('VideoThumbnail',function(view,on,$){
var pro=initPro(view,{
videoKey:M.requiredAtom(),
width:M.defaultAtom(50),
height:M.defaultAtom(50),
circle:M.defaultAtom(false)});


var wistiaId=derivation(function(){
return pro.videoKey.get().split('/')[2];});


var oEmbedUrl=derivation(function(){
return '//fast.wistia.net/oembed?url=http://home.wistia.com/medias/' + wistiaId.get();});


var thumbnailUrl=atom();

fetch(oEmbedUrl.get()).then(function(response){
return response.json();}).
then(function(videoJson){
if(videoJson.thumbnail_url){
thumbnailUrl.set(videoJson.thumbnail_url.replace(/\bimage_crop_resized=(\d+)x(\d+)\b/,'image_crop_resized=' + Math.ceil(pro.width.get()) + 'x' + Math.ceil(pro.height.get())));}else 
{
thumbnailUrl.set(null);}})[

'catch'](function(err){
console.error("Video thumbnail fetch error:",err);
thumbnailUrl.set(null);});
view.render(function(){
return Flint.iff(thumbnailUrl.get() === undefined) && view.el(['Loader',1],{if:thumbnailUrl.get() === undefined});});
view.render(function(){
return Flint.iff(thumbnailUrl.get()) && view.el(['img',1],{if:thumbnailUrl.get(),src:thumbnailUrl.get()});});


$["$"] = function(_,_index){
return {
width:pro.width.get(),
height:pro.height.get()};};


'bf0c32a6';

$["img"] = function(_,_index){
return {
width:pro.width.get(),
height:pro.height.get(),
borderRadius:pro.circle.get()?'50%':8};};});});})();





//# sourceMappingURL=videoThumbnail.js.map

(function(){
Flint.file('mframework/views/volumeBars.js',function(require){
var lastVolumeSetting=atom(0.5);

Flint.staticStyles('VolumeBars',{
'$':'#_flintapp .ViewVolumeBars',
'$mouseTarget':'#_flintapp mouseTarget.VolumeBars, #_flintapp .VolumeBars.mouseTarget, #_flintapp .ViewVolumeBars.mouseTarget, #_flintapp .VolumeBars > .mouseTarget',
'$bar':'#_flintapp bar.VolumeBars, #_flintapp .VolumeBars.bar, #_flintapp .ViewVolumeBars.bar, #_flintapp .VolumeBars > .bar'},
{
'$':{
flexDirection:'row'},

'$mouseTarget':{
cursor:'pointer'},

'$bar':{
borderStyle:'solid',
borderColor:'#ccc',
borderWidth:1}});


Flint.view('VolumeBars',function(view,on,$){
var context=initContext(view,{
colors:atom()});


var pro=initPro(view,{
height:M.defaultAtom(30),
initialVolume:M.defaultAtom(null),
inverted:M.defaultAtom(false),
numBars:M.defaultAtom(5),
volume:atom(),
width:M.defaultAtom(30)});


var spacerWidth=atom(1);
var selectedColor=atom(context.colors.get().accent);
var hoveringColor=atom('rgba(221, 19, 123, 0.5)');

var barWidth=derivation(function(){
return (pro.width.get() - spacerWidth.get() * (pro.numBars.get() - 1)) / pro.numBars.get();});

var getBarHeight=function getBarHeight(barIndex){
var heightFraction=(barIndex + 1) / pro.numBars.get();
return heightFraction * pro.height.get();};

var barBorderRadius=derivation(function(){
return barWidth.get() / 2 + 2;});


var desiredVolume=atom(pro.initialVolume.get());
var hoveringBarIndex=atom(null);

pro.volume.react(function(propVolume){
if(propVolume !== undefined){
desiredVolume.set(propVolume);}});



var volume=derivation(function(){
return desiredVolume.get() == null?lastVolumeSetting.get():desiredVolume.get();});

volume.react(function(initialVolume){
view.props.onInit && view.props.onInit({volume:initialVolume});},
{once:true});

var selectedBarIndex=volume.derive(function(volume){
return Math.ceil(volume * pro.numBars.get()) - 1;});


var setSelectedBarIndex=function setSelectedBarIndex(i){
var userDesiredVolume=(i + 1) / pro.numBars.get();
transact(function(){
desiredVolume.set(userDesiredVolume);
lastVolumeSetting.set(userDesiredVolume);});

if(view.props.onChange){
view.props.onChange({volume:volume.get()});}};

view.render(function(){
return Flint.range(pro.numBars.get()).map(function(_,_index){
return view.el(
['mouseTarget',1,_,_index],
{repeat:pro.numBars.get(),
onMouseEnter:function(){
return hoveringBarIndex.set(_index);},

onMouseLeave:function(){
return hoveringBarIndex.set(null);},

onClick:function(){
return setSelectedBarIndex(_index);}},


view.el(['bar',1,_,_index],null));});});




$["mouseTarget"] = function(_,_index){
return {height:pro.height.get(),
justifyContent:pro.inverted.get()?'flex-start':'flex-end'};};



$["bar"] = function(_,_index){
return {
background:hoveringBarIndex.get() == null || hoveringBarIndex.get() == selectedBarIndex.get()?_index <= selectedBarIndex.get()?selectedColor.get():'white':_index <= hoveringBarIndex.get()?hoveringColor.get():'white',width:barWidth.get(),
height:getBarHeight(_index),
borderRadius:pro.inverted.get()?[0,0,barBorderRadius.get(),barBorderRadius.get()]:[barBorderRadius.get(),barBorderRadius.get(),0,0],
marginRight:_index < pro.numBars.get() - 1?spacerWidth.get():null};};});});})();





//# sourceMappingURL=volumeBars.js.map

var _defineProperty=require('babel-runtime/helpers/define-property').default;

(function(){
Flint.file('mframework/views/wistiaVideo.js',function(require){
var _reactMotion=require('react-motion');

Flint.staticStyles('WistiaVideo',{
'$wistia_embed':'#_flintapp wistia_embed.WistiaVideo, #_flintapp .WistiaVideo.wistia_embed, #_flintapp .ViewWistiaVideo.wistia_embed, #_flintapp .WistiaVideo > .wistia_embed',
'$wrapper':'#_flintapp wrapper.WistiaVideo, #_flintapp .WistiaVideo.wrapper, #_flintapp .ViewWistiaVideo.wrapper, #_flintapp .WistiaVideo > .wrapper'},
{
'$wistia_embed':{},
'$wrapper':{
overflow:'hidden',

alignItems:'center',
zIndex:1,
position:'relative'}});


Flint.view('WistiaVideo',function(view,on,$){
var context=initContext(view,{
colors:atom()});


var pro=initPro(view,{
videoKey:M.requiredAtom(),

// Wrapping Wistia config
allowPause:M.defaultAtom(true),
allowPlay:M.defaultAtom(true),
autoPlay:M.defaultAtom(false),
controlsVisibleOnLoad:M.defaultAtom(true),
endVideoBehavior:M.defaultAtom('default'), // default | reset | loop
initialTime:M.defaultAtom(null),
initialVolume:M.defaultAtom(null), // null means previous Wistia setting
playerColor:M.defaultAtom(context.colors.get().accent),
showPlaybar:M.defaultAtom(true),
showVolume:M.defaultAtom(true),
wmode:M.defaultAtom('transparent'),

// Non-Wistia config
enabled:M.defaultAtom(true),
smoothVolume:M.defaultAtom(false),

// Style
circle:M.defaultAtom(false),
height:M.defaultAtom(400 * 9 / 16),
width:M.defaultAtom(400),
videoStyle:M.mapAtom({}),

// Parent-controlled state
playing:atom(),
time:atom(),
volume:atom()});


var wistiaId=pro.videoKey.derive(function(videoKey){
if(videoKey.indexOf('videos/wistia/') != 0){
throw new Error('Invalid Wistia video key: ' + videoKey);}

return videoKey.split('/')[2];});


var wantToPlay=atom(pro.autoPlay.get());
var targetVolume=atom(pro.initialVolume.get());
var time=atom(pro.initialTime.get());
var wistiaTime=atom();

// Controlled by <Motion> as a function of targetVolume
var volume=atom(targetVolume.get());

var VIEW_ID=parseInt(Math.random() * 10000000000);
var wistia=atom();
var lastRenderedWistiaConfig=atom();
var refreshCount=atom(0);

// Data reported from Wistia
var aspect=atom();
var duration=atom();
var videoData=derivation(function(){
var data=IMap({
aspect:aspect.get(),
duration:duration.get()});

if(List(data.values()).findIndex(function(v){
return v === undefined;}) == 
-1){
return data;}});


videoData.reactor(function(videoData){
if(view.props.onVideoData){
view.props.onVideoData({videoData:videoData});}}).

start();

pro.playing.react(function(propPlaying){
if(propPlaying != null){
wantToPlay.set(propPlaying);}});


pro.time.react(function(propTime){
if(propTime != null){
time.set(propTime);}});


pro.volume.react(function(propVolume){
if(propVolume !== undefined){
targetVolume.set(propVolume);}});



var playing=derivation(function(){
return pro.enabled.get() && wantToPlay.get();});

playing.react(function(playing){
if(wistia.get()){
if(playing){
wistia.get().play();}else 
{
wistia.get().pause();}}});




wistiaTime.reactor(function(wistiaTime){
time.set(wistiaTime);

if(view.props.onTime){
view.props.onTime({time:wistiaTime});}}).

start();

time.react(function(time){
if(wistia.get()){
if(wistiaTime.get() === undefined || Math.abs(time - wistiaTime.get()) > 0.25){
wistia.get().time(time);}}});




volume.react(function(volume){
if(wistia.get()){
wistia.get().volume(volume);}});



var diameter=derivation(function(){
return Math.min(pro.width.get(),pro.height.get());});

var width=derivation(function(){
if(pro.circle.get()){
var aspectGuess=aspect.get() || 16 / 9;
return Math.max(diameter.get(),diameter.get() * aspectGuess);}else 
{
return pro.width.get();}});


var height=derivation(function(){
if(pro.circle.get()){
var aspectGuess=aspect.get() || 16 / 9;
return Math.max(diameter.get(),diameter.get() / aspectGuess);}else 
{
return pro.height.get();}});



wistia.reactor(function(wistia){
wistia.hasData(function(){
transact(function(){
aspect.set(wistia.aspect());
duration.set(wistia.duration());});});



wistia.bind('play',function(){
if(!playing.get()){
if(wistiaTime.get() == null && time.get() != null){
// This happens when programmatically seeking to a time when Wistia's
// state is beforePlay. It changes to play, but then it'll change
// immediately back to pause. So do nothing.
}else {
// Since our state would have had the video stay paused, this must
// be a user-triggered event.
if(pro.allowPlay.get()){
wantToPlay.set(true);}else 
{
wistia.pause();}}}});





wistia.bind('pause',function(){
if(playing.get()){
// Since our state would have had the video keep playing, this must
// be a user-triggered event.
if(duration.get() && time.get() >= duration.get() - 0.5){
// Ignore this because it's probably justfrom the video ending
return;}


if(pro.allowPause.get() && !pro.playing.get()){
wantToPlay.set(false);}else 
{
wistia.play();}}});




wistia.bind('volumechange',function(v){
if(v != volume.get()){
// User-triggered volume change
targetVolume.set(v);
volume.set(v);}});



wistia.bind('timechange',function(t){
wistiaTime.set(t);});


wistia.bind('end',function(){
if(view.props.onEnd){
view.props.onEnd();}});}).


start();

var tellWistia=function tellWistia(wistiaMessage){
// Wistia's script watches a global message queue so we can "tell it"
// to call our callback with a handle or update some configs.

// We use refreshCount.get() + 1 because we need to get the message
// to Wistia before this component's rendered elements refresh
var matcher='video_' + VIEW_ID + '_' + (refreshCount.get() + 1);
window._wq = window._wq || [];
_wq.push(_defineProperty({},matcher,wistiaMessage));};


var refreshWistia=function refreshWistia(){
if(wistia.get()){
wistia.get().remove();
wistiaTime.set(undefined);}


var wistiaConfigSnapshot=wistiaConfig.get();
tellWistia(function(wistiaVideoHandle){
return wistia.set(wistiaVideoHandle);});

tellWistia(wistiaConfigSnapshot.toJS());
refreshCount.set(refreshCount.get() + 1);

on.delay(1,function(){
lastRenderedWistiaConfig.set(wistiaConfigSnapshot);});};



pro.videoKey.react(function(videoKey){
if(view.mounted){
lastRenderedWistiaConfig.set(null);}});



var wistiaConfig=derivation(function(){
return IMap({
autoPlay:playing.get(),
controlsVisibleOnLoad:pro.controlsVisibleOnLoad.get(),
endVideoBehavior:pro.endVideoBehavior.get(),
playbar:pro.showPlaybar.get(),
playerColor:pro.playerColor.get(),
time:time.get(),
volumeControl:pro.showVolume.get(),
volume:targetVolume.get(),
wmode:pro.wmode.get()});});



var needsRefreshing=derivation(function(){
var lastConfig=lastRenderedWistiaConfig.get();
if(!lastConfig){
return true;}

return !immutable.is(IMap({
endVideoBehavior:pro.endVideoBehavior.get(),
playbar:pro.showPlaybar.get(),
playerColor:pro.playerColor.get(),
volumeControl:pro.showVolume.get(),
wmode:pro.wmode.get()}),
IMap({
endVideoBehavior:lastConfig.get('endVideoBehavior'),
playbar:lastConfig.get('playbar'),
playerColor:lastConfig.get('playerColor'),
volumeControl:lastConfig.get('volumeControl'),
wmode:lastConfig.get('wmode')}));});


needsRefreshing.react(function(needsRefreshing){
if(needsRefreshing && view.mounted){
refreshWistia();}});



on.mount(function(){
if(lastRenderedWistiaConfig.get() === undefined){
// First render
refreshWistia();}else 
{
lastRenderedWistiaConfig.set(null);}});



on.unmount(function(){
if(wistia.get()){
wistia.get().remove();}});

view.render(function(){
return view.el(
['Motion',1],
{
defaultStyle:{v:targetVolume.get() || 0},
style:{
v:pro.smoothVolume.get() && targetVolume.get() != null && targetVolume.get() != volume.get()?(0,_reactMotion.spring)(targetVolume.get()):targetVolume.get()}},


function(style){
if(style.v != null){
setTimeout(function(){
volume.set(style.v);},
1);}


return view.el(
['wrapper',1],
{style:pro.videoStyle.get().toJS()},
Flint.iff(refreshCount.get()) && view.el(['div',1],{if:refreshCount.get(),
key:'render_' + refreshCount.get(),
id:'video_' + VIEW_ID + '_' + refreshCount.get(),
className:'wistia_embed wistia_async_' + wistiaId.get()}));});});






$["wistia_embed"] = function(_,_index){
return {
width:width.get(),
height:height.get()};};



$["wrapper"] = function(_,_index){
return {width:pro.circle.get()?diameter.get():pro.width.get(),
height:pro.circle.get()?diameter.get():pro.height.get(),borderRadius:pro.circle.get()?'50%':8};};});});})();





//# sourceMappingURL=wistiaVideo.js.map

(function(){
Flint.file('views/carouselCards/emrCard.js',function(require){
Flint.staticStyles('EmrCard',{
'$Link':'#_flintapp .ViewEmrCard .ViewLink'},
{
'$Link':{
alignSelf:'stretch',
flexGrow:1,

backgroundSize:'contain',
backgroundPosition:'50% 50%',
backgroundRepeat:'no-repeat'}});


Flint.view('EmrCard',function(view,on,$){
;view.render(function(){
return view.el(['Link',1],{to:'/enchant-mr-right'});});


'1ee447cb';

$["Link"] = function(_,_index){
return {backgroundImage:'url(/images/carousel/enchant-mr-right.png)'};};});});})();




//# sourceMappingURL=emrCard.js.map

(function(){
Flint.file("views/carouselCards/mrRightCard.js",function(require){
Flint.staticStyles("MrRightCard",{
"$Link":"#_flintapp .ViewMrRightCard .ViewLink"},
{
"$Link":{
alignSelf:'stretch',
flexGrow:1,

backgroundSize:'contain',
backgroundPosition:'50% 50%',
backgroundRepeat:'no-repeat'}});


Flint.view("MrRightCard",function(view,on,$){
;view.render(function(){
return view.el(["Link",1],{to:"https://mrright.net",target:"_blank"});});


"1ee447cb";

$["Link"] = function(_,_index){
return {backgroundImage:"url(/images/carousel/mrright.png)"};};});});})();




//# sourceMappingURL=mrRightCard.js.map

(function(){
Flint.file("views/carouselCards/textingTipsCard.js",function(require){
Flint.staticStyles("TextingTipsCard",{
"$Link":"#_flintapp .ViewTextingTipsCard .ViewLink"},
{
"$Link":{
alignSelf:'stretch',
flexGrow:1,

backgroundSize:'contain',
backgroundPosition:'50% 50%',
backgroundRepeat:'no-repeat'}});


Flint.view("TextingTipsCard",function(view,on,$){
;view.render(function(){
return view.el(["Link",1],{to:"https://texting.tips",target:"_blank"});});


"1ee447cb";

$["Link"] = function(_,_index){
return {backgroundImage:"url(/images/carousel/textingtips.png)"};};});});})();




//# sourceMappingURL=textingTipsCard.js.map

(function(){
Flint.file('views/carouselCards/tsaCard.js',function(require){
Flint.staticStyles('TsaCard',{
'$Link':'#_flintapp .ViewTsaCard .ViewLink'},
{
'$Link':{
alignSelf:'stretch',
flexGrow:1,

backgroundSize:'contain',
backgroundPosition:'50% 50%',
backgroundRepeat:'no-repeat'}});


Flint.view('TsaCard',function(view,on,$){
;view.render(function(){
return view.el(['Link',1],{to:'/3sa'});});


'1ee447cb';

$["Link"] = function(_,_index){
return {backgroundImage:'url(/images/carousel/3sa.png)'};};});});})();




//# sourceMappingURL=tsaCard.js.map

(function(){
Flint.file("views/footer.js",function(require){
Flint.staticStyles("Footer",{
"$":"#_flintapp .ViewFooter",
"$mobileMode":"#_flintapp mobileMode.Footer, #_flintapp .Footer.mobileMode, #_flintapp .ViewFooter.mobileMode, #_flintapp .Footer > .mobileMode",
"$copyright":"#_flintapp copyright.Footer, #_flintapp .Footer.copyright, #_flintapp .ViewFooter.copyright, #_flintapp .Footer > .copyright",
"$mobileLogo":"#_flintapp mobileLogo.Footer, #_flintapp .Footer.mobileLogo, #_flintapp .ViewFooter.mobileLogo, #_flintapp .Footer > .mobileLogo",
"$mobileRow":"#_flintapp mobileRow.Footer, #_flintapp .Footer.mobileRow, #_flintapp .ViewFooter.mobileRow, #_flintapp .Footer > .mobileRow",
"$mobileLink":"#_flintapp mobileLink.Footer, #_flintapp .Footer.mobileLink, #_flintapp .ViewFooter.mobileLink, #_flintapp .Footer > .mobileLink",
"$cols":"#_flintapp cols.Footer, #_flintapp .Footer.cols, #_flintapp .ViewFooter.cols, #_flintapp .Footer > .cols",
"$colu":"#_flintapp colu.Footer, #_flintapp .Footer.colu, #_flintapp .ViewFooter.colu, #_flintapp .Footer > .colu",
"$NavLink":"#_flintapp .ViewFooter .ViewNavLink",
"$bigText":"#_flintapp bigText.Footer, #_flintapp .Footer.bigText, #_flintapp .ViewFooter.bigText, #_flintapp .Footer > .bigText",
"$heading":"#_flintapp heading.Footer, #_flintapp .Footer.heading, #_flintapp .ViewFooter.heading, #_flintapp .Footer > .heading",
"$logoColu":"#_flintapp logoColu.Footer, #_flintapp .Footer.logoColu, #_flintapp .ViewFooter.logoColu, #_flintapp .Footer > .logoColu",
"$logo":"#_flintapp logo.Footer, #_flintapp .Footer.logo, #_flintapp .ViewFooter.logo, #_flintapp .Footer > .logo",
"$lastColu":"#_flintapp lastColu.Footer, #_flintapp .Footer.lastColu, #_flintapp .ViewFooter.lastColu, #_flintapp .Footer > .lastColu"},
{
"$":{
alignItems:'center',
marginBottom:30},

"$mobileMode":{
alignItems:'center'},

"$copyright":{
marginTop:8,
color:'#999',

alignSelf:'center',
textAlign:'center'},

"$mobileLogo":{
width:240,
marginTop:40},

"$mobileRow":{
marginTop:14,
flexDirection:'row'},

"$mobileLink":{
margin:[0,10],
display:'inline-block'},

"$cols":{
flexDirection:'row',
alignItems:'stretch'},

"$colu":{
flexGrow:1},

"$NavLink":{
marginBottom:6},

"$bigText":{
color:'#999',

textTransform:'uppercase',
fontStyle:'italic',
marginBottom:6},

"$heading":{
marginBottom:8},

"$logoColu":{
alignItems:'center'},

"$logo":{
minHeight:0},

"$lastColu":{
marginRight:0}});


Flint.view("Footer",function(view,on,$){
var context=initContext(view,{
isMobile:atom()});
view.render(function(){
return Flint.iff(context.isMobile.get()) && view.el(
["mobileMode",1],
{if:context.isMobile.get()},
view.el(
["NavLink",1],
{to:"/",track:"footerLogo"},
view.el(["img",1],{className:"mobileLogo",src:"/images/pr-logo-small.png"})),

view.el(
["mobileRow",1],
null,
view.el(
["NavLink",2],
{className:"mobileLink",to:"/about"},
"About"),

view.el(
["NavLink",3],
{className:"mobileLink",to:"/contact"},
"Contact"),

view.el(
["NavLink",4],
{className:"mobileLink",to:"/terms"},
"Privacy & Terms")),


view.el(
["copyright",1],
null,
"© 2016 Positive Relating, Inc"));});


view.render(function(){
return Flint.iff(!context.isMobile.get()) && view.el(
["desktopMode",1],
{if:!context.isMobile.get()},
view.el(
["cols",1],
null,
view.el(
["colu",1],
{className:"logoColu"},
view.el(
["NavLink",5],
{to:"/"},
view.el(["img",2],{className:"logo",src:"/images/pr-logo-compact-small.png"})),

view.el(
["copyright",2],
null,
"© 2016 Positive Relating, Inc")),


view.el(
["colu",2],
{className:"prLinks"},
view.el(
["bigText",1],
{className:"heading"},
"Home"),

view.el(
["NavLink",6],
{to:"/about"},
"About"),

view.el(
["NavLink",7],
{to:"/contact"},
"Contact"),

view.el(
["NavLink",8],
{to:"/terms"},
"Privacy & Terms")),


view.el(
["colu",3],
null,
view.el(
["bigText",2],
{className:"heading"},
"Shows"),

view.el(
["NavLink",9],
{to:"http://thegirlsgame.tv"},
"The Girl's Game")),


view.el(
["colu",4],
null,
view.el(
["bigText",3],
{className:"heading"},
"Products"),

view.el(
["NavLink",10],
{to:"https://mrright.net"},
"Mr. Right"),

view.el(
["NavLink",11],
{to:"/3sa"},
"3 Second Attraction"),

view.el(
["NavLink",12],
{to:"/enchant-mr-right"},
"Enchant Mr. Right"),

view.el(
["NavLink",13],
{to:"https://texting.tips"},
"Texting Tips")),


view.el(
["colu",5],
{className:"lastColu"},
view.el(
["bigText",4],
{className:"heading"},
"Coaching"),

view.el(
["NavLink",14],
{to:"/residential/men"},
"Men's Residential Weekend"),

view.el(
["NavLink",15],
{to:"/residential/women"},
"Women's Residential Weekend"))));});






$["$"] = function(_,_index){
return {
width:context.width.get()};};


"e0b1dbac";
"66113cbb";

$["copyright"] = function(_,_index){
return {fontSize:context.isMobile.get()?10:Math.max(8,0.01 * context.width.get())};};


"0c72b710";
"5e28afb8";
"567e105e";
"5d247234";
"7cb3d25b";

$["colu"] = function(_,_index){
return {marginRight:.05 * context.width.get()};};



"c3de04f0";

$["NavLink"] = function(_,_index){
return {
fontSize:Math.max(12,.014 * context.width.get()),link:{
whiteSpace:'nowrap'}};};




"3e73276e";

$["bigText"] = function(_,_index){
return {fontSize:Math.max(12,.014 * context.width.get())};};


"8f96ce3a";
"4c4a8b36";

$["logoColu"] = function(_,_index){
return {marginRight:.07 * context.width.get()};};



"514d5e58";

$["logo"] = function(_,_index){
return {
width:.15 * context.width.get()};};


"c43b7c26";});});})();



//# sourceMappingURL=footer.js.map

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('views/girlsGameEmbeds.js',function(require){
var _data=require('../data');

var _data2=_interopRequireDefault(_data);

Flint.staticStyles('GirlsGameEmbeds',{
'$':'#_flintapp .ViewGirlsGameEmbeds',
'$ggEmbed':'#_flintapp ggEmbed.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.ggEmbed, #_flintapp .ViewGirlsGameEmbeds.ggEmbed, #_flintapp .GirlsGameEmbeds > .ggEmbed',
'$previewSec':'#_flintapp previewSec.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.previewSec, #_flintapp .ViewGirlsGameEmbeds.previewSec, #_flintapp .GirlsGameEmbeds > .previewSec',
'$ggVideo':'#_flintapp ggVideo.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.ggVideo, #_flintapp .ViewGirlsGameEmbeds.ggVideo, #_flintapp .GirlsGameEmbeds > .ggVideo',
'$thumb':'#_flintapp thumb.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.thumb, #_flintapp .ViewGirlsGameEmbeds.thumb, #_flintapp .GirlsGameEmbeds > .thumb',
'$play':'#_flintapp play.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.play, #_flintapp .ViewGirlsGameEmbeds.play, #_flintapp .GirlsGameEmbeds > .play',
'$captionSec':'#_flintapp captionSec.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.captionSec, #_flintapp .ViewGirlsGameEmbeds.captionSec, #_flintapp .GirlsGameEmbeds > .captionSec',
'$videoTitle':'#_flintapp videoTitle.GirlsGameEmbeds, #_flintapp .GirlsGameEmbeds.videoTitle, #_flintapp .ViewGirlsGameEmbeds.videoTitle, #_flintapp .GirlsGameEmbeds > .videoTitle'},
{
'$':{
flexDirection:'row',
flexGrow:1,
flexWrap:'wrap',
justifyContent:'space-between'},

'$ggEmbed':{},
'$previewSec':{
position:'relative'},

'$ggVideo':{},
'$thumb':{
borderRadius:4},

'$play':{
position:'absolute',
width:40,
height:40,
zIndex:1,
margin:'auto',
left:0,
right:0,
top:0,
bottom:0},

'$captionSec':{
flexGrow:1,
alignSelf:'stretch',
alignItems:'center'},

'$videoTitle':{
textAlign:'center',
color:'white',
fontSize:12,
fontWeight:'bold',
marginTop:4}});


Flint.view('GirlsGameEmbeds',function(view,on,$){
var context=initContext(view,{
isMobile:atom()});


var pro=initPro(view,{
numEpisodes:M.defaultAtom(4),
style:M.mergeAtom({
width:400})});



var getExternalUrl=function getExternalUrl(ggEpisode){
return 'http://thegirlsgame.tv/yahoo/s' + ggEpisode.season + ('e' + ('0' + ggEpisode.episode).slice(-2));};


var spacing=atom(22);

var embedWidth=derivation(function(){
if(context.isMobile.get()){
return (pro.style.get().get('width') - 3 * spacing.get()) / 2;}else 
{
return (pro.style.get().get('width') - (pro.numEpisodes.get() + 1) * spacing.get()) / pro.numEpisodes.get();}});


var embedHeight=embedWidth.derive(function(w){
return w * 9 / 16;});


var episodes=_data2.default.girlsGameEpisodes.toJS();
M.util.shuffle(episodes);view.render(function(){
return Flint.range(episodes.slice(0,pro.numEpisodes.get())).map(function(_,_index){
return view.el(
['ggEmbed',1,_,_index],
{repeat:episodes.slice(0,pro.numEpisodes.get())},
view.el(
['previewSec',1,_,_index],
null,
view.el(
['Link',1,_,_index],
{
to:getExternalUrl(_),
target:'_blank'},

view.el(['img',1,_,_index],{className:'play',src:'/images/playicon.png'}),
view.el(['img',2,_,_index],{className:'thumb',
src:_.thumbUrl})),


Flint.iff(false) && view.el(['iframe',1,_,_index],{className:'ggVideo',if:false,
src:_.url + '?format=embed',
scrolling:'no',
frameBorder:'0',
allowFullScreen:'true',
allowtransparency:'true'})),


view.el(
['captionSec',1,_,_index],
null,
view.el(
['Link',2,_,_index],
{className:'videoTitle',to:getExternalUrl(_)},
_.title)));});});






$["$"] = function(_,_index){
return {padding:[spacing.get(),spacing.get(),0]};};



$["ggEmbed"] = function(_,_index){
return {
width:embedWidth.get(),
marginBottom:spacing.get()};};



'a2cbb15a';

$["ggVideo"] = function(_,_index){
return {
width:embedWidth.get(),
height:embedHeight.get()};};



'64cf7984';

$["thumb"] = function(_,_index){
return {
width:embedWidth.get(),
height:embedHeight.get()};};


'f0f18014';
'dc086c74';
'3339d717';});});})();



//# sourceMappingURL=girlsGameEmbeds.js.map

(function(){
Flint.file("views/hamburgerMenu.js",function(require){
Flint.staticStyles("HamburgerMenu",{
"$overlay":"#_flintapp overlay.HamburgerMenu, #_flintapp .HamburgerMenu.overlay, #_flintapp .ViewHamburgerMenu.overlay, #_flintapp .HamburgerMenu > .overlay",
"$childrenSec":"#_flintapp childrenSec.HamburgerMenu, #_flintapp .HamburgerMenu.childrenSec, #_flintapp .ViewHamburgerMenu.childrenSec, #_flintapp .HamburgerMenu > .childrenSec",
"$ham":"#_flintapp ham.HamburgerMenu, #_flintapp .HamburgerMenu.ham, #_flintapp .ViewHamburgerMenu.ham, #_flintapp .HamburgerMenu > .ham",
"$hamWrapper":"#_flintapp hamWrapper.HamburgerMenu, #_flintapp .HamburgerMenu.hamWrapper, #_flintapp .ViewHamburgerMenu.hamWrapper, #_flintapp .HamburgerMenu > .hamWrapper",
"$shadowSec":"#_flintapp shadowSec.HamburgerMenu, #_flintapp .HamburgerMenu.shadowSec, #_flintapp .ViewHamburgerMenu.shadowSec, #_flintapp .HamburgerMenu > .shadowSec",
"$expandedHam":"#_flintapp expandedHam.HamburgerMenu, #_flintapp .HamburgerMenu.expandedHam, #_flintapp .ViewHamburgerMenu.expandedHam, #_flintapp .HamburgerMenu > .expandedHam"},
{
"$overlay":{
position:'fixed',
width:'100%',
height:'100%',
background:'rgba(0, 0, 0, 0.75)'},

"$childrenSec":{
flexShrink:0},

"$ham":{
height:34,
width:34,
margin:8,
cursor:'pointer'},

"$hamWrapper":{
paddingRight:20,

width:2000,
overflow:'auto'},

"$shadowSec":{
background:'linear-gradient(to right, rgba(50, 50, 50, 0.8) 0%, rgba(0, 0, 0, 0) 100%)',
position:'absolute',
zIndex:2,
top:0,
right:-20,
bottom:0,
width:20},

"$expandedHam":{
position:'fixed',
height:'100%',
zIndex:100}});


Flint.view("HamburgerMenu",function(view,on,$){
var context=initContext(view,{
height:atom(),
width:atom()});


var pro=initPro(view,{
children:atom()});


var expanded=atom(false);
expanded.react(function(expanded){
if(expanded){
M.mixpanel.track("HamburgerMenuOpen");}else 
{
M.mixpanel.track("HamburgerMenuClose");}},

{skipFirst:true});

var hamWrapperHeight=derivation(function(){
return context.viewportHeight.get() - 50;});


var onTouchMove=function onTouchMove(e){
// Prevent awkwardly scrolling the whole body while
// menu is open
e.preventDefault();};


expanded.react(function(expanded){
if(expanded){
document.body.style.overflow = 'hidden';
document.body.addEventListener('touchmove',onTouchMove);
document.body.scrollTop = 0;}else 
{
document.body.style.overflow = null;
document.body.removeEventListener('touchmove',onTouchMove);}},

{skipFirst:true});

on.unmount(function(){
document.body.style.overflow = null;
document.body.removeEventListener('touchmove',onTouchMove);});
view.render(function(){
return view.el(["img",1],{className:"ham",src:"/images/hamburger.png",
onClick:function(){
return expanded.set(!expanded.get());}});});


view.render(function(){
return view.el(
["FadeTransitioner",1],
{
selectedIndex:expanded.get()?0:-1,
preloadChildren:false},

view.el(["overlay",1],null));});

view.render(function(){
return view.el(
["SlideTransitioner",1],
{className:"expandedHam",
selectedIndex:expanded.get()?0:-1,
width:250},

view.el(
["hamWrapper",1],
{
ref:function(elem){
if(elem){
elem.addEventListener('touchmove',function(e){
// We apparently don't get proper bubbling if we
// mix the document.body.addEventListener call with
// React's onTouchMove virtual event handler, so
// we're using elem.addEventListener.
e.stopPropagation();});}},



onClick:function(){
return expanded.set(false);}},


view.el(
["childrenSec",1],
{onClick:function(e){
return e.stopPropagation();}},

pro.children.get()),

view.el(["shadowSec",1],null)));});




"b2024ba4";
"006d1a4e";
"fd09ee1c";

$["ham"] = function(_,_index){
return {opacity:expanded.get()?0.2:0.7};};



"fb8bf918";

$["hamWrapper"] = function(_,_index){
return {height:hamWrapperHeight.get()};};


"08bf1e61";
"ec181500";});});})();



//# sourceMappingURL=hamburgerMenu.js.map

(function(){
Flint.file('views/heroCarousel.js',function(require){
Flint.staticStyles('HeroCarousel',{
'$':'#_flintapp .ViewHeroCarousel'},
{
'$':{
alignItems:'center'}});


Flint.view('HeroCarousel',function(view,on,$){
var context=initContext(view,{
colors:atom(),
width:atom(),
isMobile:atom()});


var pro=initPro(view,{
children:atom(),
autoSwipeInterval:M.defaultAtom(8000),
stopAfterUserHasSwiped:M.defaultAtom(true)});


var selectedIndex=atom(0);
var timeSinceSwipe=atom(0);
var userHasSwiped=atom(false);

on.every(1000,function(){
timeSinceSwipe.set(timeSinceSwipe.get() + 1000);
if(userHasSwiped.get() && pro.stopAfterUserHasSwiped.get())return;

if(pro.autoSwipeInterval.get() && timeSinceSwipe.get() >= pro.autoSwipeInterval.get()){
transact(function(){
selectedIndex.set((selectedIndex.get() + 1) % React.Children.count(pro.children.get()));
timeSinceSwipe.set(0);});}});




var buttonWidth=derivation(function(){
return context.isMobile.get()?0:50;});
view.render(function(){
return view.el(
['Carousel',1],
{
width:context.width.get(),
height:(context.width.get() - 2 * buttonWidth.get()) / 2.63,
buttonWidth:buttonWidth.get(),
showButtons:!context.isMobile.get(),
wrapMode:'cylinder',
shadows:true,
selectedIndex:userHasSwiped.get() && pro.stopAfterUserHasSwiped.get()?null:selectedIndex.get(),
onSelect:function(e){
selectedIndex.set(e.selectedIndex);
on.delay(100,function(){
userHasSwiped.set(true);
timeSinceSwipe.set(0);});},


style:{
button:{},
buttonHover:{
color:context.colors.get().accent},

dots:{
bottom:context.isMobile.get()?-22:-28},

border:'1px solid #eee',
borderRadius:8}},


pro.children.get());});



$["$"] = function(_,_index){
return {width:context.width.get(),
paddingBottom:context.isMobile.get()?42:50};};});});})();





//# sourceMappingURL=heroCarousel.js.map

var _extends=require('babel-runtime/helpers/extends').default;

var _Object$assign=require('babel-runtime/core-js/object/assign').default;

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('views/main.js',function(require){
var _fastclick=require('fastclick');

var _fastclick2=_interopRequireDefault(_fastclick);

Flint.staticStyles('Main',{
'$':'#_flintapp .ViewMain',
'$page':'#_flintapp page.Main, #_flintapp .Main.page, #_flintapp .ViewMain.page, #_flintapp .Main > .page'},
{
'$':{
width:'100%',
minHeight:'100%',
alignItems:'center',
overflowX:'hidden'},

'$page':{}});

Flint.view('Main',function(view,on,$){
var MIN_DESKTOP_WIDTH=680;
var MAX_DESKTOP_WIDTH=960;
var DESKTOP_PADDING=20;

var getWidth=function getWidth(){
var ret=Math.min(document.body.offsetWidth - DESKTOP_PADDING * 2,MAX_DESKTOP_WIDTH);
if(ret < MIN_DESKTOP_WIDTH){
// It's gonna be mobile mode so take out the padding
ret += DESKTOP_PADDING * 2;}

return ret;};


_Object$assign(M.context,{
colors:atom(Record({
// accent: 'rgb(255, 190, 49)'
accent:'rgb(215, 98, 124)',
logoPrimary:'rgb(155, 103, 113)',
'default':'#666'})()),

fonts:atom(Record({
normal:null})()),

width:atom(getWidth()),
isMobile:derivation(function(){
return M.context.width.get() < MIN_DESKTOP_WIDTH;}),

viewportHeight:atom(document.body.offsetHeight),
viewportWidth:atom(document.body.offsetWidth)});


on.resize(window,function(){
M.context.width.set(getWidth());
M.context.viewportWidth.set(document.body.offsetWidth);
M.context.viewportHeight.set(document.body.offsetHeight);});


_fastclick2.default.attach(document.body);

var mixpanelSuperProperties=derivation(function(){
return IMap({
isMobile:M.context.isMobile.get()});});


mixpanelSuperProperties.react(function(mixpanelSuperProperties){
M.mixpanel.register(mixpanelSuperProperties.toJS());});


var canonicalRoute=derivation(function(){
return '/' + M.context.route.get().split('/').filter(function(pathPart){
return !!pathPart;}).
join('/');});

canonicalRoute.react(function(canonicalRoute){
if(canonicalRoute != M.context.route.get()){
history.replaceState({},'',canonicalRoute);}});



var isStaticRoute=derivation(function(){
var staticRoutes=['/','/3sa','/about','/contact','/enchant-mr-right','/residential/men','/residential/women','/sandbox','/terms'];
return staticRoutes.indexOf(M.context.route.get()) >= 0;});
view.render(function(){
return view.el(
['page',1],
{ref:function(){
// After the page renders, the scroll bar might appear and change the
// offsetWidth without a resize event.
M.context.width.set(getWidth());}},

Flint.routeMatch('/') && view.el(['HomePage',1],_extends({route:'/'},Flint.routeParams('/'))),
Flint.routeMatch('/3sa') && view.el(['TsaPage',1],_extends({route:'/3sa'},Flint.routeParams('/3sa'))),
Flint.routeMatch('/enchant-mr-right') && view.el(['EmrPage',1],_extends({route:'/enchant-mr-right'},Flint.routeParams('/enchant-mr-right'))),
Flint.routeMatch('/residential/men') && view.el(['MensResiPage',1],_extends({route:'/residential/men'},Flint.routeParams('/residential/men'))),
Flint.routeMatch('/residential/women') && view.el(['WomensResiPage',1],_extends({route:'/residential/women'},Flint.routeParams('/residential/women'))),
Flint.routeMatch('/about') && view.el(['AboutPage',1],_extends({route:'/about'},Flint.routeParams('/about'))),
Flint.routeMatch('/contact') && view.el(['ContactPage',1],_extends({route:'/contact'},Flint.routeParams('/contact'))),
Flint.iff(!isStaticRoute.get()) && view.el(['NotFoundPage',1],{if:!isStaticRoute.get()}),
Flint.routeMatch('/terms') && view.el(['TermsPage',1],_extends({route:'/terms'},Flint.routeParams('/terms'))),
Flint.routeMatch('/sandbox') && view.el(['SandboxPage',1],_extends({route:'/sandbox'},Flint.routeParams('/sandbox'))));});



$["page"] = function(_,_index){
return {
width:M.context.width.get() + 2 * DESKTOP_PADDING,
padding:[0,DESKTOP_PADDING]};};});});})();





//# sourceMappingURL=main.js.map

(function(){
Flint.file('views/navBar.js',function(require){
Flint.staticStyles('NavBar',{
'$':'#_flintapp .ViewNavBar',
'$mobileMode':'#_flintapp mobileMode.NavBar, #_flintapp .NavBar.mobileMode, #_flintapp .ViewNavBar.mobileMode, #_flintapp .NavBar > .mobileMode',
'$desktopMode':'#_flintapp desktopMode.NavBar, #_flintapp .NavBar.desktopMode, #_flintapp .ViewNavBar.desktopMode, #_flintapp .NavBar > .desktopMode',
'$logoSec':'#_flintapp logoSec.NavBar, #_flintapp .NavBar.logoSec, #_flintapp .ViewNavBar.logoSec, #_flintapp .NavBar > .logoSec',
'$hamSection':'#_flintapp hamSection.NavBar, #_flintapp .NavBar.hamSection, #_flintapp .ViewNavBar.hamSection, #_flintapp .NavBar > .hamSection',
'$hamContents':'#_flintapp hamContents.NavBar, #_flintapp .NavBar.hamContents, #_flintapp .ViewNavBar.hamContents, #_flintapp .NavBar > .hamContents',
'$hamHeader':'#_flintapp hamHeader.NavBar, #_flintapp .NavBar.hamHeader, #_flintapp .ViewNavBar.hamHeader, #_flintapp .NavBar > .hamHeader',
'$hamCategory':'#_flintapp hamCategory.NavBar, #_flintapp .NavBar.hamCategory, #_flintapp .ViewNavBar.hamCategory, #_flintapp .NavBar > .hamCategory',
'$mobileLogo':'#_flintapp mobileLogo.NavBar, #_flintapp .NavBar.mobileLogo, #_flintapp .ViewNavBar.mobileLogo, #_flintapp .NavBar > .mobileLogo',
'$logo':'#_flintapp logo.NavBar, #_flintapp .NavBar.logo, #_flintapp .ViewNavBar.logo, #_flintapp .NavBar > .logo',
'$menus':'#_flintapp menus.NavBar, #_flintapp .NavBar.menus, #_flintapp .ViewNavBar.menus, #_flintapp .NavBar > .menus',
'$PRMenu':'#_flintapp .ViewNavBar .ViewPRMenu'},
{
'$':{
alignSelf:'stretch'},

'$mobileMode':{
position:'absolute',
width:'100%',
left:0,
zIndex:100,
background:'rgb(248, 236, 240)',
height:50,
flexGrow:1,
flexDirection:'row',
alignItems:'center'},

'$desktopMode':{
flexDirection:'row',
alignItems:'center',
alignSelf:'stretch',
justifyContent:'stretch',
flexGrow:1},

'$logoSec':{
flexGrow:1,
paddingLeft:8},

'$hamSection':{
flexGrow:1},

'$hamContents':{
background:'rgb(190, 173, 179)',
width:250},

'$hamHeader':{
background:'rgb(114, 91, 98)',
color:'white',
alignSelf:'stretch',
padding:[4,8]},

'$hamCategory':{
alignSelf:'stretch'},

'$mobileLogo':{
marginRight:10},

'$logo':{
width:200,
height:23},

'$menus':{
flexDirection:'row',
flexGrow:1,
alignSelf:'flex-end',
marginRight:8,
justifyContent:'flex-end',
height:50,
alignItems:'center'},

'$PRMenu':{
marginLeft:40}});


Flint.view('NavBar',function(view,on,$){
var context=initContext(view,{
route:atom(),
width:atom(),
isMobile:atom()});


var HAM_STYLE={
alignSelf:'stretch',
alignItems:'stretch',
link:{
padding:12,
borderBottom:'1px solid #ddd',
background:'rgba(255, 255, 255, 0.8)',
whiteSpace:'nowrap'}};

view.render(function(){
return Flint.iff(context.isMobile.get()) && view.el(
['mobileMode',1],
{if:context.isMobile.get()},
view.el(
['hamSection',1],
null,
view.el(
['HamburgerMenu',1],
null,
view.el(
['hamContents',1],
null,
view.el(
['NavLink',1],
{style:HAM_STYLE,to:'/'},
'Home'),

view.el(
['NavLink',2],
{style:HAM_STYLE,to:'/about'},
'About'),

view.el(
['hamCategory',1],
null,
view.el(
['hamHeader',1],
null,
'Shows'),

view.el(
['NavLink',3],
{style:HAM_STYLE,to:'http://thegirlsgame.tv'},
'The Girl\'s Game')),


view.el(
['hamCategory',2],
null,
view.el(
['hamHeader',2],
null,
'Products'),

view.el(
['NavLink',4],
{style:HAM_STYLE,to:'https://mrright.net'},
'Mr. Right'),

view.el(
['NavLink',5],
{style:HAM_STYLE,to:'/3sa'},
'3 Second Attraction'),

view.el(
['NavLink',6],
{style:HAM_STYLE,to:'/enchant-mr-right'},
'Enchant Mr. Right'),

view.el(
['NavLink',7],
{style:HAM_STYLE,to:'https://texting.tips'},
'Texting Tips')),


view.el(
['hamCategory',3],
null,
view.el(
['hamHeader',3],
null,
'Coaching'),

view.el(
['NavLink',8],
{style:HAM_STYLE,to:'/residential/men'},
'Men\'s Residential'),

view.el(
['NavLink',9],
{style:HAM_STYLE,to:'/residential/women'},
'Women\'s Residential')),


view.el(
['hamCategory',4],
null,
view.el(
['hamHeader',4],
null,
' '),

view.el(
['NavLink',10],
{style:HAM_STYLE,to:'/contact'},
'Contact'),

view.el(
['NavLink',11],
{style:HAM_STYLE,to:'/terms'},
'Privacy & Terms'))))),





view.el(
['NavLink',12],
{className:'mobileLogo',to:'/'},
view.el(['img',1],{className:'logo',src:'/images/pr-logo.png'})));});


view.render(function(){
return Flint.iff(!context.isMobile.get()) && view.el(
['desktopMode',1],
{if:!context.isMobile.get()},
Flint.iff(context.route.get() != '/') && view.el(
['logoSec',1],
{if:context.route.get() != '/'},
view.el(
['NavLink',13],
{to:'/'},
view.el(['img',2],{className:'logo',src:'/images/pr-logo.png'}))),


view.el(
['menus',1],
null,
view.el(
['NavLink',14],
{to:'/about'},
'About'),

view.el(['PRMenu',1],{
title:'Shows',
options:[{
label:"The Girl's Game",
url:'http://thegirlsgame.tv',
target:'_blank'}]}),


view.el(['PRMenu',2],{
title:'Products',
options:[{
label:'Mr. Right',
url:'https://mrright.net',
target:'_blank'},
{
label:'3 Second Attraction',
url:'/3sa'},
{
label:'Enchant Mr. Right',
url:'/enchant-mr-right'},
{
label:'Texting Tips',
url:'https://texting.tips'}]}),


view.el(['PRMenu',3],{
title:'Coaching',
options:[{
label:"Men's Residential Weekend",
url:'/residential/men'},
{
label:"Women's Residential Weekend",
url:'/residential/women'}],

style:{
menuWrapper:{
right:0}}})));});







$["$"] = function(_,_index){
return {height:context.isMobile.get()?50:null};};



'483f2ebc';
'20e45d34';
'6d0a0c9c';
'6d0a0c9c';
'57bd1d02';
'7ad33e1c';
'7ad33e1c';
'486109c8';
'1f81b058';
'6b2e9433';
'41d97eaa';});});})();



//# sourceMappingURL=navBar.js.map

(function(){
Flint.file('views/navLink.js',function(require){
Flint.view('NavLink',function(view,on,$){
var context=initContext(view,{
colors:atom(),
route:atom()});


var pro=initPro(view,{
to:atom(),
target:atom()});


var selected=derivation(function(){
return M.routeIsActive(pro.to.get());});
view.render(function(){
return view.el(
['Link',1],
{to:pro.to.get(),target:pro.target.get(),style:IMap({
color:selected.get()?context.colors.get().accent:'black'}).
merge(pro.style.get().get('link')).toJS()},
pro.children.get());});});});})();





//# sourceMappingURL=navLink.js.map

(function(){
Flint.file("views/pages/aboutPage.js",function(require){
Flint.staticStyles("AboutPage",{
"$page":"#_flintapp page.AboutPage, #_flintapp .AboutPage.page, #_flintapp .ViewAboutPage.page, #_flintapp .AboutPage > .page",
"$header":"#_flintapp header.AboutPage, #_flintapp .AboutPage.header, #_flintapp .ViewAboutPage.header, #_flintapp .AboutPage > .header",
"$aboutSec":"#_flintapp aboutSec.AboutPage, #_flintapp .AboutPage.aboutSec, #_flintapp .ViewAboutPage.aboutSec, #_flintapp .AboutPage > .aboutSec",
"$para":"#_flintapp para.AboutPage, #_flintapp .AboutPage.para, #_flintapp .ViewAboutPage.para, #_flintapp .AboutPage > .para",
"$aboutLink":"#_flintapp aboutLink.AboutPage, #_flintapp .AboutPage.aboutLink, #_flintapp .ViewAboutPage.aboutLink, #_flintapp .AboutPage > .aboutLink",
"$teamMemberSec":"#_flintapp teamMemberSec.AboutPage, #_flintapp .AboutPage.teamMemberSec, #_flintapp .ViewAboutPage.teamMemberSec, #_flintapp .AboutPage > .teamMemberSec",
"$portrait":"#_flintapp portrait.AboutPage, #_flintapp .AboutPage.portrait, #_flintapp .ViewAboutPage.portrait, #_flintapp .AboutPage > .portrait",
"$teamMemberName":"#_flintapp teamMemberName.AboutPage, #_flintapp .AboutPage.teamMemberName, #_flintapp .ViewAboutPage.teamMemberName, #_flintapp .AboutPage > .teamMemberName",
"$teamMemberEmail":"#_flintapp teamMemberEmail.AboutPage, #_flintapp .AboutPage.teamMemberEmail, #_flintapp .ViewAboutPage.teamMemberEmail, #_flintapp .AboutPage > .teamMemberEmail",
"$teamMemberTitle":"#_flintapp teamMemberTitle.AboutPage, #_flintapp .AboutPage.teamMemberTitle, #_flintapp .ViewAboutPage.teamMemberTitle, #_flintapp .AboutPage > .teamMemberTitle",
"$teamMemberBio":"#_flintapp teamMemberBio.AboutPage, #_flintapp .AboutPage.teamMemberBio, #_flintapp .ViewAboutPage.teamMemberBio, #_flintapp .AboutPage > .teamMemberBio"},
{
"$page":{
padding:[20,20,32]},

"$header":{
fontSize:36,
marginBottom:12},

"$aboutSec":{
marginBottom:32},

"$para":{
marginBottom:20,
textAlign:'justify',
display:'block',
fontFamily:'helvetica neue',

fontSize:12,
lineHeight:'175%'},

"$aboutLink":{
fontWeight:'bold',
display:'inline'},

"$teamMemberSec":{
flexDirection:'row',
marginBottom:32},

"$portrait":{
flexShrink:0,
borderRadius:'50%',
border:'1px solid #ddd',
marginRight:20},

"$teamMemberName":{
flexDirection:'row',

fontSize:20},

"$teamMemberEmail":{
width:16,
position:'relative',
left:6,
opacity:0.8},

"$teamMemberTitle":{
fontSize:13},

"$teamMemberBio":{
display:'block',
textAlign:'justify',
fontSize:12,
lineHeight:'150%',
fontFamily:'helvetica neue'}});


Flint.view("AboutPage",function(view,on,$){
var context=initContext(view,{
colors:atom(),
isMobile:atom()});


on.mount(function(){
M.mixpanel.track("PageView",{page:'about'});});
view.render(function(){
return view.el(["NavBar",1],null);});
view.render(function(){
return view.el(
["page",1],
null,
view.el(
["aboutSec",1],
null,
view.el(
["header",1],
null,
"About"),

view.el(
["aboutInfo",1],
null,
view.el(
["para",1],
null,
"Positive Relating, Inc was founded in 2006 with a mission to explore what’s possible in our social lives: our family, friendships and romantic relationships. We are now one of the largest and most renowned dating companies in the world. We believe that meeting new romantic partners, having great conversations, and making real connections are skills that anyone can learn with our methodology."),

view.el(
["para",2],
null,
"Our men’s program, ",
view.el(
["Link",1],
{className:"aboutLink",to:"/3sa"},
"3 Second Attraction"),

", has helped tens of thousands of men all over of the world in their love life - including executives, self-made millionaires, working professionals and college students. Our women’s TV show, ",
view.el(
["Link",2],
{className:"aboutLink",to:"http://thegirlsgame.tv",target:"_blank"},
"The Girl’s Game"),

", has 6 million viewers."),

view.el(
["para",3],
null,
"We continue to teach workshops ",
view.el(
["Link",3],
{className:"aboutLink",to:"/residential/men"},
"for men"),

" and ",
view.el(
["Link",4],
{className:"aboutLink",to:"/residential/women"},
"for women"),

" on topics including:",
view.el(
["ul",1],
null,
view.el(
["li",1],
null,
"Revealing your true charming personality"),

view.el(
["li",2],
null,
"How to open a conversation with a stranger you’re attracted to"),

view.el(
["li",3],
null,
"What to look for in a short-term and long-term relationship"),

"Owning your sexual desire",
view.el(
["li",4],
null,
"Problem solving in a relationship"),

view.el(
["li",5],
null,
"Becoming more self-assured and emotionally available"),

view.el(
["li",6],
null,
"The ",
view.el(
["Link",5],
{className:"aboutLink",to:"http://integralcenter.org/what-is-circling/",target:"_blank"},
"Integral Circling"),

" experience to “see and be seen”")),


"Our professional dating coaches are based in over 40 major metropolitan English-speaking cities throughout the world, including Los Angeles, San Francisco, New York, Melbourne, Perth and London."),

view.el(
["para",4],
null,
"We created ",
view.el(
["Link",6],
{className:"aboutLink",to:"https://mrright.net",target:"_blank"},
"Mr. Right"),

", the dating app where men step up their game."),

view.el(
["para",5],
null,
"And we write the world’s most thorough analysis of texting: ",
view.el(
["Link",7],
{className:"aboutLink",to:"https://texting.tips",target:"_blank"},
"Texting Tips"),

"."))),



view.el(
["teamSec",1],
null,
view.el(
["header",2],
null,
"Team"),

view.el(
["teamInfo",1],
null,
view.el(
["teamMemberSec",1],
null,
view.el(["img",1],{className:"portrait",src:"/images/mehow-headshot.png"}),
view.el(
["teamMemberInfo",1],
null,
view.el(
["teamMemberName",1],
null,
"Mehow",
view.el(
["a",1],
{className:"teamMemberEmailLink",href:"mailto:mehow@positiverelating.tv"},
view.el(["img",2],{className:"teamMemberEmail",src:"/images/email.png"}))),


view.el(
["teamMemberTitle",1],
null,
"Founder & CEO"),

view.el(
["teamMemberBio",1],
null,
"Mehow was born Michal Pospieszalski in Warsaw, Poland. Since 2006, he has devoted himself to mastering the art of creating fulfilling relationships. Mehow has written eight books about attraction, seduction, dating and relationships. He has given countless talks and personally taught thousands of students. He is the host and creator of Yahoo's ",
view.el(
["i",1],
null,
"The Girl's Game"),

"."))),



view.el(
["teamMemberSec",2],
null,
view.el(["img",3],{className:"portrait",src:"/images/angie-headshot-2.png"}),
view.el(
["teamMemberInfo",2],
null,
view.el(
["teamMemberName",2],
null,
"Angie Chavez",
view.el(
["a",2],
{className:"teamMemberEmailLink",href:"mailto:angie@positiverelating.tv"},
view.el(["img",4],{className:"teamMemberEmail",src:"/images/email.png"}))),


view.el(
["teamMemberTitle",2],
null,
"Operations Manager"),

view.el(
["teamMemberBio",2],
null,
"Angie is the co-author of ",
view.el(
["Link",8],
{className:"aboutLink",to:"/3sa"},
"3 Second Attraction"),

" and ",
view.el(
["Link",9],
{className:"aboutLink",to:"/enchant-mr-right"},
"Enchant Mr. Right"),

". She has written dozens of lesson materials for Positive Relating. She leads the interview and evaluation process for ",
view.el(
["Link",10],
{className:"aboutLink",to:"https://mrright.net",target:"_blank"},
"Mr. Right"),

"."))),



view.el(
["teamMemberSec",3],
null,
view.el(["img",5],{className:"portrait",src:"/images/daniel-headshot.png"}),
view.el(
["teamMemberInfo",3],
null,
view.el(
["teamMemberName",3],
null,
"Daniel Crosser",
view.el(
["a",3],
{className:"teamMemberEmailLink",href:"mailto:daniel@positiverelating.tv"},
view.el(["img",6],{className:"teamMemberEmail",src:"/images/email.png"}))),


view.el(
["teamMemberTitle",3],
null,
"Head Coach"),

view.el(
["teamMemberBio",3],
null,
"Daniel is the author of ",
view.el(
["i",2],
null,
"Relationship Formula"),

" and has logged over 5,000 hours of experience coaching students in sparking attraction and building authentic, fulfilling relationships. He has helped many couples work through complex relationship situations and is ",
view.el(
["Link",11],
{className:"aboutLink",to:"http://integralcenter.org/t3/",target:"_blank"},
"T3 Integral Circling"),

" certified. He now oversees the coaching curriculum at Positive Relating."))))));});






view.render(function(){
return view.el(["Footer",1],null);});


"28439e14";

$["page"] = function(_,_index){
return {flexDirection:context.isMobile.get()?'column':'row'};};



"122f3ef8";
"7c6e598d";

$["aboutSec"] = function(_,_index){
return {marginRight:context.isMobile.get()?0:80};};



"1484c247";

$["para"] = function(_,_index){
return {color:context.colors.get()["default"]};};


"1babe06c";

$["aboutLink"] = function(_,_index){
return {
color:context.colors.get().logoPrimary};};


"a4df4d6a";
"e751e180";

$["portrait"] = function(_,_index){
return {
width:context.isMobile.get()?80:120,
height:context.isMobile.get()?80:120};};


"b58c8714";

$["teamMemberName"] = function(_,_index){
return {marginTop:context.isMobile.get()?0:2};};


"6a5d2b63";
"70ad5c44";
"2d7901e4";

$["teamMemberBio"] = function(_,_index){
return {color:context.colors.get()["default"]};};});});})();





//# sourceMappingURL=aboutPage.js.map

(function(){
Flint.file("views/pages/contactPage.js",function(require){
Flint.staticStyles("ContactPage",{
"$page":"#_flintapp page.ContactPage, #_flintapp .ContactPage.page, #_flintapp .ViewContactPage.page, #_flintapp .ContactPage > .page",
"$header":"#_flintapp header.ContactPage, #_flintapp .ContactPage.header, #_flintapp .ViewContactPage.header, #_flintapp .ContactPage > .header",
"$icon":"#_flintapp icon.ContactPage, #_flintapp .ContactPage.icon, #_flintapp .ViewContactPage.icon, #_flintapp .ContactPage > .icon",
"$addr":"#_flintapp addr.ContactPage, #_flintapp .ContactPage.addr, #_flintapp .ViewContactPage.addr, #_flintapp .ContactPage > .addr",
"$addressSec":"#_flintapp addressSec.ContactPage, #_flintapp .ContactPage.addressSec, #_flintapp .ViewContactPage.addressSec, #_flintapp .ContactPage > .addressSec",
"$emailSec":"#_flintapp emailSec.ContactPage, #_flintapp .ContactPage.emailSec, #_flintapp .ViewContactPage.emailSec, #_flintapp .ContactPage > .emailSec",
"$emailIcon":"#_flintapp emailIcon.ContactPage, #_flintapp .ContactPage.emailIcon, #_flintapp .ViewContactPage.emailIcon, #_flintapp .ContactPage > .emailIcon",
"$emailInfo":"#_flintapp emailInfo.ContactPage, #_flintapp .ContactPage.emailInfo, #_flintapp .ViewContactPage.emailInfo, #_flintapp .ContactPage > .emailInfo",
"$phoneSec":"#_flintapp phoneSec.ContactPage, #_flintapp .ContactPage.phoneSec, #_flintapp .ViewContactPage.phoneSec, #_flintapp .ContactPage > .phoneSec",
"$phoneIcon":"#_flintapp phoneIcon.ContactPage, #_flintapp .ContactPage.phoneIcon, #_flintapp .ViewContactPage.phoneIcon, #_flintapp .ContactPage > .phoneIcon",
"$phoneInfo":"#_flintapp phoneInfo.ContactPage, #_flintapp .ContactPage.phoneInfo, #_flintapp .ViewContactPage.phoneInfo, #_flintapp .ContactPage > .phoneInfo"},
{
"$page":{
padding:[20,20,60]},

"$header":{
fontSize:36},

"$icon":{
width:32,
height:32,
marginRight:16},

"$addr":{
fontFamily:'helvetica neue'},

"$addressSec":{
marginTop:12,
marginBottom:20,
flexDirection:'row'},

"$emailSec":{
flexDirection:'row',
marginBottom:20},

"$emailIcon":{
marginLeft:5,
width:24,
marginRight:17},

"$emailInfo":{
marginTop:2},

"$phoneSec":{
flexDirection:'row'},

"$phoneIcon":{
width:14,
height:29,
marginLeft:11,
opacity:0.7},

"$phoneInfo":{
marginTop:5,
marginLeft:6}});


Flint.view("ContactPage",function(view,on,$){
on.mount(function(){
M.mixpanel.track("PageView",{page:'contact'});});
view.render(function(){
return view.el(["NavBar",1],null);});
view.render(function(){
return view.el(
["page",1],
null,
view.el(
["header",1],
null,
"Contact"),

view.el(
["addressSec",1],
null,
view.el(["img",1],{className:"icon",src:"/images/location.png"}),
view.el(
["addressInfo",1],
null,
view.el(
["pr",1],
null,
"Positive Relating"),

view.el(
["addr",1],
null,
view.el(
["street",1],
null,
"701 Westbourne Dr"),

view.el(
["city",1],
null,
"West Hollywood, CA 90069")))),




view.el(
["emailSec",1],
null,
view.el(["img",2],{className:['icon','emailIcon'],src:"/images/email.png"}),
view.el(
["emailInfo",1],
null,
view.el(
["a",1],
{href:"mailto:info@positiverelating.tv"},
"info@positiverelating.tv"))),



view.el(
["phoneSec",1],
null,
view.el(["img",3],{className:['icon','phoneIcon'],src:"/images/phone.png"}),
view.el(
["phoneInfo",1],
null,
"1 (888) 634-6988")));});



view.render(function(){
return view.el(["Footer",1],null);});});});})();




//# sourceMappingURL=contactPage.js.map

(function(){
Flint.file("views/pages/emrPage.js",function(require){
Flint.staticStyles("EmrPage",{
"$emrPage":"#_flintapp emrPage.EmrPage, #_flintapp .EmrPage.emrPage, #_flintapp .ViewEmrPage.emrPage, #_flintapp .EmrPage > .emrPage",
"$enchantLogo":"#_flintapp enchantLogo.EmrPage, #_flintapp .EmrPage.enchantLogo, #_flintapp .ViewEmrPage.enchantLogo, #_flintapp .EmrPage > .enchantLogo",
"$page":"#_flintapp page.EmrPage, #_flintapp .EmrPage.page, #_flintapp .ViewEmrPage.page, #_flintapp .EmrPage > .page",
"$header":"#_flintapp header.EmrPage, #_flintapp .EmrPage.header, #_flintapp .ViewEmrPage.header, #_flintapp .EmrPage > .header",
"$headerTopLine":"#_flintapp headerTopLine.EmrPage, #_flintapp .EmrPage.headerTopLine, #_flintapp .ViewEmrPage.headerTopLine, #_flintapp .EmrPage > .headerTopLine",
"$headerBottomLine":"#_flintapp headerBottomLine.EmrPage, #_flintapp .EmrPage.headerBottomLine, #_flintapp .ViewEmrPage.headerBottomLine, #_flintapp .EmrPage > .headerBottomLine",
"$headerNormSize":"#_flintapp headerNormSize.EmrPage, #_flintapp .EmrPage.headerNormSize, #_flintapp .ViewEmrPage.headerNormSize, #_flintapp .EmrPage > .headerNormSize",
"$big":"#_flintapp big.EmrPage, #_flintapp .EmrPage.big, #_flintapp .ViewEmrPage.big, #_flintapp .EmrPage > .big",
"$squiggle":"#_flintapp squiggle.EmrPage, #_flintapp .EmrPage.squiggle, #_flintapp .ViewEmrPage.squiggle, #_flintapp .EmrPage > .squiggle",
"$mainPitch":"#_flintapp mainPitch.EmrPage, #_flintapp .EmrPage.mainPitch, #_flintapp .ViewEmrPage.mainPitch, #_flintapp .EmrPage > .mainPitch",
"$emrBookImg":"#_flintapp emrBookImg.EmrPage, #_flintapp .EmrPage.emrBookImg, #_flintapp .ViewEmrPage.emrBookImg, #_flintapp .EmrPage > .emrBookImg",
"$listHeading":"#_flintapp listHeading.EmrPage, #_flintapp .EmrPage.listHeading, #_flintapp .ViewEmrPage.listHeading, #_flintapp .EmrPage > .listHeading",
"$ul":"#_flintapp ul.EmrPage, #_flintapp .EmrPage.ul, #_flintapp .ViewEmrPage.ul, #_flintapp .EmrPage > .ul",
"$white":"#_flintapp white.EmrPage, #_flintapp .EmrPage.white, #_flintapp .ViewEmrPage.white, #_flintapp .EmrPage > .white",
"$rightSection":"#_flintapp rightSection.EmrPage, #_flintapp .EmrPage.rightSection, #_flintapp .ViewEmrPage.rightSection, #_flintapp .EmrPage > .rightSection",
"$goButton":"#_flintapp goButton.EmrPage, #_flintapp .EmrPage.goButton, #_flintapp .ViewEmrPage.goButton, #_flintapp .EmrPage > .goButton",
"$osHeadline":"#_flintapp osHeadline.EmrPage, #_flintapp .EmrPage.osHeadline, #_flintapp .ViewEmrPage.osHeadline, #_flintapp .EmrPage > .osHeadline",
"$squiggletwo":"#_flintapp squiggletwo.EmrPage, #_flintapp .EmrPage.squiggletwo, #_flintapp .ViewEmrPage.squiggletwo, #_flintapp .EmrPage > .squiggletwo",
"$offerPitch":"#_flintapp offerPitch.EmrPage, #_flintapp .EmrPage.offerPitch, #_flintapp .ViewEmrPage.offerPitch, #_flintapp .EmrPage > .offerPitch",
"$opTopLine":"#_flintapp opTopLine.EmrPage, #_flintapp .EmrPage.opTopLine, #_flintapp .ViewEmrPage.opTopLine, #_flintapp .EmrPage > .opTopLine",
"$opBottomLine":"#_flintapp opBottomLine.EmrPage, #_flintapp .EmrPage.opBottomLine, #_flintapp .ViewEmrPage.opBottomLine, #_flintapp .EmrPage > .opBottomLine",
"$squigglethree":"#_flintapp squigglethree.EmrPage, #_flintapp .EmrPage.squigglethree, #_flintapp .ViewEmrPage.squigglethree, #_flintapp .EmrPage > .squigglethree",
"$opNormSize":"#_flintapp opNormSize.EmrPage, #_flintapp .EmrPage.opNormSize, #_flintapp .ViewEmrPage.opNormSize, #_flintapp .EmrPage > .opNormSize",
"$free":"#_flintapp free.EmrPage, #_flintapp .EmrPage.free, #_flintapp .ViewEmrPage.free, #_flintapp .EmrPage > .free",
"$bonusBooksSection":"#_flintapp bonusBooksSection.EmrPage, #_flintapp .EmrPage.bonusBooksSection, #_flintapp .ViewEmrPage.bonusBooksSection, #_flintapp .EmrPage > .bonusBooksSection",
"$bonusBook":"#_flintapp bonusBook.EmrPage, #_flintapp .EmrPage.bonusBook, #_flintapp .ViewEmrPage.bonusBook, #_flintapp .EmrPage > .bonusBook",
"$bonusBookImg":"#_flintapp bonusBookImg.EmrPage, #_flintapp .EmrPage.bonusBookImg, #_flintapp .ViewEmrPage.bonusBookImg, #_flintapp .EmrPage > .bonusBookImg",
"$bonusBookInfo":"#_flintapp bonusBookInfo.EmrPage, #_flintapp .EmrPage.bonusBookInfo, #_flintapp .ViewEmrPage.bonusBookInfo, #_flintapp .EmrPage > .bonusBookInfo",
"$bonusBookTitle":"#_flintapp bonusBookTitle.EmrPage, #_flintapp .EmrPage.bonusBookTitle, #_flintapp .ViewEmrPage.bonusBookTitle, #_flintapp .EmrPage > .bonusBookTitle",
"$bonusBookDescription":"#_flintapp bonusBookDescription.EmrPage, #_flintapp .EmrPage.bonusBookDescription, #_flintapp .ViewEmrPage.bonusBookDescription, #_flintapp .EmrPage > .bonusBookDescription",
"$bottomSection":"#_flintapp bottomSection.EmrPage, #_flintapp .EmrPage.bottomSection, #_flintapp .ViewEmrPage.bottomSection, #_flintapp .EmrPage > .bottomSection",
"$bsHeadline":"#_flintapp bsHeadline.EmrPage, #_flintapp .EmrPage.bsHeadline, #_flintapp .ViewEmrPage.bsHeadline, #_flintapp .EmrPage > .bsHeadline",
"$bookAll":"#_flintapp bookAll.EmrPage, #_flintapp .EmrPage.bookAll, #_flintapp .ViewEmrPage.bookAll, #_flintapp .EmrPage > .bookAll",
"$goButtonOne":"#_flintapp goButtonOne.EmrPage, #_flintapp .EmrPage.goButtonOne, #_flintapp .ViewEmrPage.goButtonOne, #_flintapp .EmrPage > .goButtonOne",
"$goButtonTwo":"#_flintapp goButtonTwo.EmrPage, #_flintapp .EmrPage.goButtonTwo, #_flintapp .ViewEmrPage.goButtonTwo, #_flintapp .EmrPage > .goButtonTwo"},
{
"$emrPage":{
alignItems:'center',
color:'white'},

"$enchantLogo":{},
"$page":{
padding:[15,60,15],

alignItems:'center',
fontFamily:'helvetica neue'},

"$header":{
alignItems:'center',
width:'100%',

lineHeight:1.6},

"$headerTopLine":{},
"$headerBottomLine":{
flexDirection:'row'},

"$headerNormSize":{
whiteSpace:'nowrap'},

"$big":{
flexDirection:'column',

textAlign:'center',
lineHeight:.7},

"$squiggle":{},
"$mainPitch":{
justifyContent:'flex-start',

paddingTop:10},

"$emrBookImg":{
marginTop:15},

"$listHeading":{
fontStyle:'italic'},

"$ul":{
color:'rgb(253, 172, 223)'},

"$white":{
color:'white',
display:'inline-block'},

"$rightSection":{
flexDirection:'column',
alignItems:'center'},

"$goButton":{
border:'5px solid rgb(112, 40, 91)',
borderRadius:10,

fontWeight:'bold',
display:'inline-flex',
alignItems:'center',
justifyContent:'center',
cursor:'pointer',
color:'white'},

"$osHeadline":{
flexDirection:'row',
alignSelf:'center'},

"$squiggletwo":{
alignSelf:'center'},

"$offerPitch":{
justifyContent:'center',
alignItems:'center',

lineHeight:1.8},

"$opTopLine":{
flexDirection:'row'},

"$opBottomLine":{
flexDirection:'row'},

"$squigglethree":{},
"$opNormSize":{
whiteSpace:'nowrap'},

"$free":{
lineHeight:1,

alignItems:'center'},

"$bonusBooksSection":{
width:'80%',
marginTop:20},

"$bonusBook":{},
"$bonusBookImg":{},
"$bonusBookInfo":{
flexDirection:'column',
alignSelf:'center'},

"$bonusBookTitle":{
fontWeight:'bold',
paddingBottom:15},

"$bonusBookDescription":{
flexDirection:'column',

width:300,
paddingRight:8,
paddingLeft:8},

"$bottomSection":{
width:'100%',
marginTop:25},

"$bsHeadline":{
alignSelf:'center',
paddingBottom:25,

display:'inline-block',
textAlign:'center'},

"$bookAll":{
alignSelf:'center'},

"$goButtonOne":{
border:'5px solid rgb(112, 40, 91)',
borderRadius:10,

fontWeight:'bold',
display:'inline-flex',
alignItems:'center',
justifyContent:'center',
cursor:'pointer',
color:'white',
alignSelf:'center'},

"$goButtonTwo":{
border:'5px solid rgb(112, 40, 91)',
borderRadius:10,

fontWeight:'bold',
display:'inline-flex',
alignItems:'center',
justifyContent:'center',
cursor:'pointer',
color:'white',
alignSelf:'center'}});


Flint.view("EmrPage",function(view,on,$){
var context=initContext(view,{
width:atom(),
isMobile:atom()});


on.mount(function(){
M.mixpanel.track("PageView",{page:'enchant-mr-right'});});


var buttonOneHover=atom(false);
var buttonTwoHover=atom(false);view.render(function(){
return view.el(["NavBar",1],null);});
view.render(function(){
return view.el(
["emrPage",1],
null,
view.el(["img",1],{className:"enchantLogo",src:"/images/enchant-mr-right/emr-logo.png"}),
view.el(
["page",1],
null,
view.el(
["header",1],
null,
view.el(
["headerTopLine",1],
null,
view.el(
["headerNormSize",1],
null,
"A girl's essential reading to get the guy she"),

Flint.iff(!context.isMobile.get()) && view.el(
["big",1],
{if:!context.isMobile.get()},
"wants",
view.el(["img",2],{className:"squiggle",src:"/images/enchant-mr-right/squiggle.png"}))),


view.el(
["headerBottomLine",1],
null,
Flint.iff(context.isMobile.get()) && view.el(
["big",2],
{if:context.isMobile.get()},
"wants",
view.el(["img",3],{className:"squiggle",src:"/images/enchant-mr-right/squiggle.png"})),

view.el(
["headerNormSize",2],
null,
"not the guy she settles for"))),



view.el(
["mainPitch",1],
null,
view.el(
["Link",1],
{className:"emrBookLink",
to:"http://spellboundformula.com/",
target:"_blank"},

view.el(["img",4],{className:"emrBookImg",src:"/images/enchant-mr-right/enchant-mr-right-book.png"})),

view.el(
["rightSection",1],
null,
view.el(
["listPitch",1],
null,
view.el(
["listHeading",1],
null,
"You'll learn how to:"),

view.el(
["ul",1],
null,
view.el(
["li",1],
null,
view.el(
["white",1],
null,
"Make him ask you out")),


view.el(
["li",2],
null,
view.el(
["white",2],
null,
"Get his interest and keep it")),


view.el(
["li",3],
null,
view.el(
["white",3],
null,
"Have him chase you")),


view.el(
["li",4],
null,
view.el(
["white",4],
null,
"Reject guys you don't like")))),




view.el(
["Link",2],
{className:"goButtonOne",
to:"http://spellboundformula.com/",
target:"_blank",
onHover:function(e){
return buttonOneHover.set(e.hovering);}},


"Buy Now"))),



view.el(
["offerSection",1],
null,
view.el(
["osHeadline",1],
null,
"and a",
view.el(
["limited",1],
null,
view.el(
["span",1],
null,
" limited "),

view.el(["img",5],{className:"squiggletwo",src:"/images/enchant-mr-right/squiggle.png"})),

"time offer..."),

view.el(
["offerPitch",1],
null,
view.el(
["opTopLine",1],
null,
"4 ",
view.el(
["i",1],
null,
"amazing"),

" additional books to put your"),

view.el(
["opBottomLine",1],
null,
view.el(
["opNormSize",1],
null,
"knowledge into action completely "),

view.el(
["free",1],
null,
view.el(
["span",2],
null,
"free"),

view.el(["img",6],{className:"squigglethree",src:"/images/enchant-mr-right/squiggle.png"}))))),




view.el(
["bonusBooksSection",1],
null,
view.el(
["bonusBook",1],
null,
view.el(["img",7],{className:"bonusBookImg",src:"/images/enchant-mr-right/how-to-talk-to-hot-guys-book.png"}),
view.el(
["bonusBookInfo",1],
null,
view.el(
["bonusBookTitle",1],
null,
view.el(
["i",2],
null,
"How to Talk to Hot Guys")),


view.el(
["bonusBookDescription",1],
null,
"Learn how to tease and have a fun conversation so you'll stick in his mind."))),



view.el(
["bonusBook",2],
null,
view.el(["img",8],{className:"bonusBookImg",src:"/images/enchant-mr-right/texting-book.png"}),
view.el(
["bonusBookInfo",2],
null,
view.el(
["bonusBookTitle",2],
null,
view.el(
["i",3],
null,
"Texting")),


view.el(
["bonusBookDescription",2],
null,
"Romance in 2016 lives on the phone. Learn how to use your most powerful tool to your advantage."))),



view.el(
["bonusBook",3],
null,
view.el(["img",9],{className:"bonusBookImg",src:"/images/enchant-mr-right/age-defying-secrets-book.png"}),
view.el(
["bonusBookInfo",3],
null,
view.el(
["bonusBookTitle",3],
null,
view.el(
["i",4],
null,
"Age-defying Secrets")),


view.el(
["bonusBookDescription",3],
null,
"Learn how to present a cool personality that guys find irresistable no matter what your age."))),



view.el(
["bonusBook",4],
null,
view.el(["img",10],{className:"bonusBookImg",src:"/images/enchant-mr-right/screening-book.png"}),
view.el(
["bonusBookInfo",4],
null,
view.el(
["bonusBookTitle",4],
null,
view.el(
["i",5],
null,
"Screening")),


view.el(
["bonusBookDescription",4],
null,
"Learn how to attract the guys you actually want and keep away the guys you dislike.")))),




view.el(
["bottomSection",1],
null,
view.el(
["bsHeadline",1],
null,
"Invest in your future happiness",
view.el(
["i",6],
null,
" today")),


view.el(["img",11],{className:"bookAll",src:"/images/enchant-mr-right/whole-product.png"}),
view.el(
["Link",3],
{className:"goButtonTwo",
to:"http://spellboundformula.com/",
target:"_blank",
onHover:function(e){
return buttonTwoHover.set(e.hovering);}},


"Buy Now"))),



view.el(["Footer",1],null));});



"13669ad6";

$["emrPage"] = function(_,_index){
return {
width:context.width.get(),
borderRadius:context.isMobile.get()?0:12};};


$["enchantLogo"] = function(_,_index){
return {
width:Math.max(320,context.width.get() * .6),
height:465 / 1316 * Math.max(320,context.width.get() * .6),
padding:context.isMobile.get()?[15,10]:[25,0]};};



"6bc33b8e";

$["page"] = function(_,_index){
return {
background:'linear-gradient(to bottom, ' + 'rgb(119, 67, 149) 0%, rgb(160, 88, 180) 100%)',
width:context.width.get(),marginBottom:context.isMobile.get()?20:50,
borderRadius:context.isMobile.get()?0:12};};


"461f98ba";

$["header"] = function(_,_index){
return {
fontSize:context.isMobile.get()?14:28,marginTop:context.isMobile.get()?15:25};};


$["headerTopLine"] = function(_,_index){
return {
flexDirection:context.isMobile.get()?'column':'row'};};



"4cb1874b";
"7affce55";
"254eccb4";

$["big"] = function(_,_index){
return {
fontSize:context.isMobile.get()?21:36,width:context.isMobile.get()?65:112,height:context.isMobile.get()?0:10,
alignSelf:context.isMobile.get()?'flex-start':'flex-start',
paddingTop:context.isMobile.get()?2:9};};



$["squiggle"] = function(_,_index){
return {
width:context.isMobile.get()?60:112};};



"eabaa944";

$["mainPitch"] = function(_,_index){
return {
flexDirection:context.isMobile.get()?'column':'row',alignItems:context.isMobile.get()?'center':'flex-start',
width:context.isMobile.get()?context.width.get():'100%'};};


"3208a4f1";

$["emrBookImg"] = function(_,_index){
return {
width:context.isMobile.get()?200:context.width.get() * .36,
height:852 / 500 * (context.isMobile.get()?200:context.width.get() * .36),
paddingLeft:context.isMobile.get()?context.width.get() * .03:0};};


"745b2c04";

$["listHeading"] = function(_,_index){
return {fontSize:Math.max(16,.02 * context.width.get()),
alignSelf:context.isMobile.get()?'center':'flex-start'};};



"0de9f28e";

$["ul"] = function(_,_index){
return {
fontSize:Math.max(14,.023 * context.width.get())};};


"3e81579c";
"3e81579c";

$["rightSection"] = function(_,_index){
return {marginLeft:context.isMobile.get()?0:5,
marginTop:context.isMobile.get()?15:context.width.get() * .1,
marginRight:context.isMobile.get()?20:0};};



"3c8faaca";

$["goButton"] = function(_,_index){
return {
marginTop:.03 * context.width.get(),
marginBottom:.07 * context.width.get(),
width:Math.max(220,.25 * context.width.get()),
height:Math.max(74.8,.085 * context.width.get()),
background:'linear-gradient(to bottom, ' + 'rgb(254, 70, 117) 0%, rgb(202, 47, 79) 100%)',fontSize:Math.max(16,.023 * context.width.get()),alignSelf:context.isMobile.get()?'center':'flex-start'};};



"28353894";

$["osHeadline"] = function(_,_index){
return {
fontSize:Math.max(16,.03 * context.width.get())};};


"28353894";

$["squiggletwo"] = function(_,_index){
return {
width:Math.max(60,.105 * context.width.get())};};


"4f56a859";

$["offerPitch"] = function(_,_index){
return {
paddingTop:context.isMobile.get()?30:50,fontSize:context.isMobile.get()?14:28};};


"4f56a859";
"4f56a859";

$["squigglethree"] = function(_,_index){
return {
width:context.isMobile.get()?50:90};};



"4f56a859";
"7de185da";

$["free"] = function(_,_index){
return {
fontSize:context.isMobile.get()?24:44,paddingTop:context.isMobile.get()?1:2};};


"778897fb";

$["bonusBook"] = function(_,_index){
return {
flexDirection:context.isMobile.get()?'column':'row',
alignSelf:context.isMobile.get()?'center':'flex-start'};};



$["bonusBookImg"] = function(_,_index){
return {
maxWidth:Math.max(150,context.width.get() * .2),
maxHeight:67 / 44 * Math.max(150,context.width.get() * .2),
alignSelf:context.isMobile.get()?'center':'flex-start'};};



"76401977";

$["bonusBookInfo"] = function(_,_index){
return {marginBottom:context.isMobile.get()?30:70};};



"f8095636";

$["bonusBookTitle"] = function(_,_index){
return {
fontSize:context.isMobile.get()?16:22,alignSelf:context.isMobile.get()?'center':'flex-start'};};



"3753538d";

$["bonusBookDescription"] = function(_,_index){
return {fontSize:context.isMobile.get()?14:16,
alignItems:context.isMobile.get()?'center':'flex-start',
textAlign:context.isMobile.get()?'center':'left'};};


"724f4f81";
"e5c6be04";

$["bsHeadline"] = function(_,_index){
return {fontSize:Math.max(17,context.width.get() * .04)};};


"e5c6be04";

$["bookAll"] = function(_,_index){
return {
width:Math.max(220,context.width.get() * .5),
height:646 / 800 * Math.max(220,context.width.get() * .5)};};


"7734d5fd";

$["goButtonOne"] = function(_,_index){
return {
marginTop:context.isMobile.get()?15:0,
marginBottom:.07 * context.width.get(),
width:Math.max(220,.25 * context.width.get()),
height:Math.max(74.8,.085 * context.width.get()),
background:buttonOneHover.get()?'linear-gradient(to bottom, ' + 'pink 0%, rgb(202, 47, 79) 100%)':'linear-gradient(to bottom, ' + 'rgb(254, 70, 117) 0%, rgb(202, 47, 79) 100%)',fontSize:Math.max(16,.023 * context.width.get())};};


"7734d5fd";

$["goButtonTwo"] = function(_,_index){
return {
marginTop:context.isMobile.get()?15:0,
marginBottom:.07 * context.width.get(),
width:Math.max(220,.25 * context.width.get()),
height:Math.max(74.8,.085 * context.width.get()),
background:buttonTwoHover.get()?'linear-gradient(to bottom, ' + 'pink 0%, rgb(202, 47, 79) 100%)':'linear-gradient(to bottom, ' + 'rgb(254, 70, 117) 0%, rgb(202, 47, 79) 100%)',fontSize:Math.max(16,.023 * context.width.get())};};});});})();




//# sourceMappingURL=emrPage.js.map

(function(){
Flint.file("views/pages/homePage.js",function(require){
Flint.staticStyles("HomePage",{
"$":"#_flintapp .ViewHomePage",
"$home":"#_flintapp home.HomePage, #_flintapp .HomePage.home, #_flintapp .ViewHomePage.home, #_flintapp .HomePage > .home",
"$header":"#_flintapp header.HomePage, #_flintapp .HomePage.header, #_flintapp .ViewHomePage.header, #_flintapp .HomePage > .header",
"$section":"#_flintapp section.HomePage, #_flintapp .HomePage.section, #_flintapp .ViewHomePage.section, #_flintapp .HomePage > .section",
"$sHeading":"#_flintapp sHeading.HomePage, #_flintapp .HomePage.sHeading, #_flintapp .ViewHomePage.sHeading, #_flintapp .HomePage > .sHeading",
"$sTagline":"#_flintapp sTagline.HomePage, #_flintapp .HomePage.sTagline, #_flintapp .ViewHomePage.sTagline, #_flintapp .HomePage > .sTagline",
"$sBody":"#_flintapp sBody.HomePage, #_flintapp .HomePage.sBody, #_flintapp .ViewHomePage.sBody, #_flintapp .HomePage > .sBody",
"$girlsGameBody":"#_flintapp girlsGameBody.HomePage, #_flintapp .HomePage.girlsGameBody, #_flintapp .ViewHomePage.girlsGameBody, #_flintapp .HomePage > .girlsGameBody",
"$textingTipsBody":"#_flintapp textingTipsBody.HomePage, #_flintapp .HomePage.textingTipsBody, #_flintapp .ViewHomePage.textingTipsBody, #_flintapp .HomePage > .textingTipsBody",
"$imgLogo":"#_flintapp imgLogo.HomePage, #_flintapp .HomePage.imgLogo, #_flintapp .ViewHomePage.imgLogo, #_flintapp .HomePage > .imgLogo",
"$textingTipsLogo":"#_flintapp textingTipsLogo.HomePage, #_flintapp .HomePage.textingTipsLogo, #_flintapp .ViewHomePage.textingTipsLogo, #_flintapp .HomePage > .textingTipsLogo",
"$girlsGameLogo":"#_flintapp girlsGameLogo.HomePage, #_flintapp .HomePage.girlsGameLogo, #_flintapp .ViewHomePage.girlsGameLogo, #_flintapp .HomePage > .girlsGameLogo",
"$carouselCard":"#_flintapp carouselCard.HomePage, #_flintapp .HomePage.carouselCard, #_flintapp .ViewHomePage.carouselCard, #_flintapp .HomePage > .carouselCard"},
{
"$":{
marginBottom:60},

"$home":{},
"$header":{
marginTop:24,
alignSelf:'stretch',
alignItems:'center',
marginBottom:30,
paddingLeft:24,
paddingRight:24},

"$section":{
marginTop:50,

alignItems:'stretch'},

"$sHeading":{
flexDirection:'row',
alignItems:'center',

marginBottom:8},

"$sTagline":{
fontStyle:'italic',
color:'#666',
marginLeft:30},

"$sBody":{
minHeight:100,
flexGrow:1,
alignItems:'stretch'},

"$girlsGameBody":{
background:'linear-gradient(to bottom, #da5275 0%, #fd8eab 100%)'},

"$textingTipsBody":{
background:'linear-gradient(to bottom, #0057b3 0%, #218ffa 100%)'},

"$imgLogo":{
width:400,
height:47,
marginRight:50},

"$textingTipsLogo":{
width:250},

"$girlsGameLogo":{},
"$carouselCard":{
alignSelf:'stretch',
flexGrow:1}});


Flint.view("HomePage",function(view,on,$){
var context=initContext(view,{
width:atom(),
isMobile:atom()});


var cardWidth=derivation(function(){
return context.isMobile.get()?context.width.get():600;});

var cardHeight=derivation(function(){
return cardWidth.get() * 9 / 16;});


on.mount(function(){
M.mixpanel.track("PageView",{page:'home'});});
view.render(function(){
return view.el(["NavBar",1],null);});
view.render(function(){
return view.el(
["home",1],
null,
Flint.iff(!context.isMobile.get()) && view.el(
["header",1],
{if:!context.isMobile.get()},
view.el(["img",1],{className:"imgLogo",src:"/images/pr-logo.png"})),

view.el(
["HeroCarousel",1],
null,
view.el(["MrRightCard",1],{className:"carouselCard"}),
view.el(["TsaCard",1],{className:"carouselCard"}),
view.el(["EmrCard",1],{className:"carouselCard"}),
view.el(["TextingTipsCard",1],{className:"carouselCard"})),

view.el(
["section",1],
null,
view.el(
["sHeading",1],
null,
view.el(
["Link",1],
{to:"http://thegirlsgame.tv",target:"_blank"},
view.el(["img",2],{className:"girlsGameLogo",src:"/images/girlsgame.png"})),

Flint.iff(!context.isMobile.get()) && view.el(
["sTagline",1],
{if:!context.isMobile.get()},
"Real dating advice for women")),


view.el(
["sBody",1],
{className:"girlsGameBody"},
view.el(["GirlsGameEmbeds",1],{
style:{
width:context.width.get()}}))),




view.el(
["section",2],
null,
view.el(
["sHeading",2],
null,
view.el(
["Link",2],
{to:"https://texting.tips",target:"_blank"},
view.el(["img",3],{className:"textingTipsLogo",src:"/images/textingtips.png"})),

Flint.iff(!context.isMobile.get()) && view.el(
["sTagline",2],
{if:!context.isMobile.get()},
"Tap into modern romance")),


view.el(
["sBody",2],
{className:"textingTipsBody"},
view.el(["TextingTipsEmbeds",1],{
style:{
width:context.width.get()}}))));});





view.render(function(){
return view.el(["Footer",1],null);});


$["$"] = function(_,_index){
return {
width:context.width.get()};};


$["home"] = function(_,_index){
return {
padding:context.isMobile.get()?0:[16,0,50]};};



"cf6a5dc0";
"8064c836";

$["section"] = function(_,_index){
return {width:context.width.get()};};


"535acd7a";

$["sHeading"] = function(_,_index){
return {justifyContent:context.isMobile.get()?'center':'flex-start',
paddingLeft:context.isMobile.get()?0:20};};


"4afdb400";
"489147ba";
"6f80434c";
"4ba1a8d4";
"9f423c9a";
"9f424a68";

$["textingTipsLogo"] = function(_,_index){
return {height:250 / 4.17};};



$["girlsGameLogo"] = function(_,_index){
return {
width:context.isMobile.get()?200:250,
height:120 / 642 * (context.isMobile.get()?200:250)};};



"9f424a68";});});})();



//# sourceMappingURL=homePage.js.map

(function(){
Flint.file('views/pages/mensResiPage.js',function(require){
Flint.staticStyles('MensResiPage',{
'$resiPage':'#_flintapp resiPage.MensResiPage, #_flintapp .MensResiPage.resiPage, #_flintapp .ViewMensResiPage.resiPage, #_flintapp .MensResiPage > .resiPage',
'$resiForm':'#_flintapp resiForm.MensResiPage, #_flintapp .MensResiPage.resiForm, #_flintapp .ViewMensResiPage.resiForm, #_flintapp .MensResiPage > .resiForm',
'$submittedSec':'#_flintapp submittedSec.MensResiPage, #_flintapp .MensResiPage.submittedSec, #_flintapp .ViewMensResiPage.submittedSec, #_flintapp .MensResiPage > .submittedSec',
'$header':'#_flintapp header.MensResiPage, #_flintapp .MensResiPage.header, #_flintapp .ViewMensResiPage.header, #_flintapp .MensResiPage > .header',
'$ff':'#_flintapp ff.MensResiPage, #_flintapp .MensResiPage.ff, #_flintapp .ViewMensResiPage.ff, #_flintapp .MensResiPage > .ff',
'$label':'#_flintapp label.MensResiPage, #_flintapp .MensResiPage.label, #_flintapp .ViewMensResiPage.label, #_flintapp .MensResiPage > .label',
'$row':'#_flintapp row.MensResiPage, #_flintapp .MensResiPage.row, #_flintapp .ViewMensResiPage.row, #_flintapp .MensResiPage > .row',
'$goButton':'#_flintapp goButton.MensResiPage, #_flintapp .MensResiPage.goButton, #_flintapp .ViewMensResiPage.goButton, #_flintapp .MensResiPage > .goButton',
'$pleaseFix':'#_flintapp pleaseFix.MensResiPage, #_flintapp .MensResiPage.pleaseFix, #_flintapp .ViewMensResiPage.pleaseFix, #_flintapp .MensResiPage > .pleaseFix'},
{
'$resiPage':{
padding:[0,24],
marginTop:30,
marginBottom:100},

'$resiForm':{
alignItems:'stretch'},

'$submittedSec':{
color:'green',
fontWeight:'bold'},

'$header':{
color:'rgb(154, 103, 113)',

fontWeight:'bold',
marginBottom:30},

'$ff':{
marginBottom:20,
marginRight:14},

'$label':{
fontSize:14},

'$row':{
flexGrow:1,
flexDirection:'row',
alignItems:'stretch'},

'$goButton':{
marginTop:20,

height:80,

border:'8px outset rgb(0, 154, 70)',
borderRadius:16,
fontSize:24,
fontWeight:'bold',
display:'inline-flex',
alignItems:'center',
justifyContent:'center',
verticalAlign:'middle',
cursor:'pointer',
color:'black'},

'$pleaseFix':{
marginTop:4,
color:'red',
fontWeight:'bold'}});


Flint.view('MensResiPage',function(view,on,$){
var context=initContext(view,{
width:atom()});


var fields=atom(M.records.ResiApp({
gender:'male'}));

var highlightingMissingFields=atom(false);
var submitting=atom(false);
var submitted=atom(false);

var ff=function ff(fieldName,label,placeholder,inpStyle){
var highlight=highlightingMissingFields.get() && fields.get().get(fieldName) == null;

return view.el(
['label',1],
{className:'ff',key:fieldName},
label,
view.el(['TextBox',1],{
placeholder:placeholder,
value:fields.derive(fieldName),
onChange:function(e){
return fields.set(fields.get().set(fieldName,e.value || null));},

inpStyle:IMap({
marginTop:4,
fontSize:context.isMobile.get()?14:18,
alignSelf:'stretch',
border:highlight?'1px solid red':'1px solid #ccc'}).
merge(inpStyle)}));};




var submit=function submit(){
if(submitting.get())return;

highlightingMissingFields.set(false);

var hasMissingField=false;
fields.get().forEach(function(value,fieldName){
if(value == null){
hasMissingField = true;
return false;}});


if(hasMissingField){
highlightingMissingFields.set(true);
return;}


submitting.set(true);
M.apiPost('submitResiApp',{
params:fields.get().toJS()}).
then(function(){
submitting.set(false);
submitted.set(true);},
function(err){
submitting.set(false);
M.util.alertError(err);});};



on.mount(function(){
M.mixpanel.track("PageView",{page:'mensResi'});});
view.render(function(){
return view.el(['NavBar',1],null);});
view.render(function(){
return view.el(
['resiPage',1],
null,
view.el(
['header',1],
null,
'Men\'s Residential Weekend Application'),

Flint.iff(submitted.get()) && view.el(
['submittedSec',1],
{if:submitted.get()},
view.el(
['span',1],
null,
'Thanks for applying, ',
fields.get().firstName,
'! We\'ll get back to you within 2 business days.')),


Flint.iff(!submitted.get()) && view.el(
['resiForm',1],
{if:!submitted.get()},
view.el(
['row',1],
null,
ff('firstName',null,"First name"),
ff('lastName',null,"Last name")),

view.el(
['row',2],
null,
ff('city',null,"City"),
ff('state',null,"State",{width:100})),

ff('phone',"Phone","(###) ###-####"),
ff('email',"Email","john@example.com"),
ff('freeTime',"How much free time do you have to make this happen?","Time to devote..."),
ff('anxiety',"How anxious do you feel meeting women?","Anxiety..."),
ff('whyInterested',"Why are you interested in getting this area of your life handled?","Reason for interest..."),
ff('formalTraining',"Have you ever had a dating coach or training in pickup?","Prior formal training..."),
view.el(
['ff',1],
null,
view.el(
['label',2],
{style:highlightingMissingFields.get() && fields.get().wouldTravel == null?{color:'red',fontWeight:'bold'}:null},
'Would you travel to LA to get the best training in the world?'),

view.el(['OptionsPicker',1],{
options:[{
label:"Yes",
value:true},
{
label:"No",
value:false}],

limit:1,
onChange:function(e){
fields.set(fields.get().set('wouldTravel',e.selectedValues.get(0)));}})),



ff('howMuchWorth',"How much do you think (dollar amount) mastering this skillset is worth?" + " (Please put a realistic amount):","Reasonable estimate of program value..."),
view.el(
['goButton',1],
{onClick:submit},
Flint.iff(!submitting.get()) && view.el(
['submitText',1],
{if:!submitting.get()},
'Submit Application'),

Flint.iff(submitting.get()) && view.el(['Loader',1],{if:submitting.get()})),

Flint.iff(highlightingMissingFields.get()) && view.el(
['pleaseFix',1],
{if:highlightingMissingFields.get()},
'Please fix the missing fields.')));});



view.render(function(){
return view.el(['Footer',1],null);});


$["resiForm"] = function(_,_index){
return {
width:Math.min(500,context.width.get() - 48)};};


$["header"] = function(_,_index){
return {fontSize:Math.max(14,0.035 * context.width.get())};};


$["goButton"] = function(_,_index){
return {width:Math.min(300,context.width.get() - 48),background:'linear-gradient(to bottom, ' + 'rgb(0, 227, 61) 0%, rgb(0, 182, 46) 100%)'};};});});})();




//# sourceMappingURL=mensResiPage.js.map

(function(){
Flint.file('views/pages/notFoundPage.js',function(require){
Flint.staticStyles('NotFoundPage',{
'$page':'#_flintapp page.NotFoundPage, #_flintapp .NotFoundPage.page, #_flintapp .ViewNotFoundPage.page, #_flintapp .NotFoundPage > .page',
'$notFound':'#_flintapp notFound.NotFoundPage, #_flintapp .NotFoundPage.notFound, #_flintapp .ViewNotFoundPage.notFound, #_flintapp .NotFoundPage > .notFound'},
{
'$page':{
alignSelf:'stretch'},

'$notFound':{
alignSelf:'stretch',
padding:[20,0],

borderBottom:'1px solid #ddd',
fontSize:24}});


Flint.view('NotFoundPage',function(view,on,$){
var context=initContext(view,{
isMobile:atom()});


var pro=initPro(view,{});view.render(function(){
return view.el(['NavBar',1],null);});
view.render(function(){
return view.el(
['page',1],
null,
view.el(
['notFound',1],
null,
'Page not found.'));});


view.render(function(){
return view.el(['Footer',1],null);});


$["page"] = function(_,_index){
return {padding:[20,20,context.isMobile.get()?0:60]};};



$["notFound"] = function(_,_index){
return {borderTop:context.isMobile.get()?'none':'1px solid #ddd'};};});});})();




//# sourceMappingURL=notFoundPage.js.map

(function(){
Flint.file("views/pages/sandboxPage.js",function(require){
Flint.view("SandboxPage",function(view,on,$){
var context=initContext(view,{
isAdmin:atom()})


// context.isAdmin.react(isAdmin => {
//   if (isAdmin === false) {
//     Flint.router.go('/')
//   }
// })
;
view.render(function(){
return Flint.iff(true || context.isAdmin.get()) && view.el(
["sandboxPage",1],
{if:true || context.isAdmin.get()},
view.el(
["Loader",1],
null,
view.el(
["c1",1],
null,
"child 1"),

view.el(
["c2",1],
null,
"child 2")));});});});})();







//# sourceMappingURL=sandboxPage.js.map

(function(){
Flint.file("views/pages/termsPage.js",function(require){
Flint.staticStyles("TermsPage",{
"$page":"#_flintapp page.TermsPage, #_flintapp .TermsPage.page, #_flintapp .ViewTermsPage.page, #_flintapp .TermsPage > .page",
"$header":"#_flintapp header.TermsPage, #_flintapp .TermsPage.header, #_flintapp .ViewTermsPage.header, #_flintapp .TermsPage > .header",
"$termsHeader":"#_flintapp termsHeader.TermsPage, #_flintapp .TermsPage.termsHeader, #_flintapp .ViewTermsPage.termsHeader, #_flintapp .TermsPage > .termsHeader",
"$legalese":"#_flintapp legalese.TermsPage, #_flintapp .TermsPage.legalese, #_flintapp .ViewTermsPage.legalese, #_flintapp .TermsPage > .legalese",
"$p":"#_flintapp p.TermsPage, #_flintapp .TermsPage.p, #_flintapp .ViewTermsPage.p, #_flintapp .TermsPage > .p",
"$div":"#_flintapp div.TermsPage, #_flintapp .TermsPage.div, #_flintapp .ViewTermsPage.div, #_flintapp .TermsPage > .div",
"$br":"#_flintapp br.TermsPage, #_flintapp .TermsPage.br, #_flintapp .ViewTermsPage.br, #_flintapp .TermsPage > .br",
"$boldSpan":"#_flintapp boldSpan.TermsPage, #_flintapp .TermsPage.boldSpan, #_flintapp .ViewTermsPage.boldSpan, #_flintapp .TermsPage > .boldSpan"},
{
"$page":{
padding:[30,20]},

"$header":{
fontSize:36,
fontWeight:'bold'},

"$termsHeader":{
marginTop:100},

"$legalese":{
fontFamily:'courier new',
margin:[0,0,40],
display:'block'},

"$p":{
margin:[20,0,0]},

"$div":{
margin:[0,0]},

"$br":{
margin:0,
padding:0,
height:0},

"$boldSpan":{
fontWeight:'bold'}});


Flint.view("TermsPage",function(view,on,$){
on.mount(function(){
M.mixpanel.track("PageView",{page:'terms'});});
view.render(function(){
return view.el(["NavBar",1],null);});
view.render(function(){
return view.el(
["page",1],
null,
view.el(
["header",1],
{className:"privacyHeader"},
"Privacy Policy"),

view.el(
["legalese",1],
null,
view.el(
["p",1],
null,
"The website at positiverelating.tv as well as the websites at mrright.net and threesecondattraction.com shall hereafter be referred to collectively the “Web Site”."),

view.el(["br",1],null),
view.el(
["div",1],
null,
view.el(
["span",1],
{className:"boldSpan"},
"Notice to California Residents: "),

"California law grants you certain rights to receive information about the third parties, if any, with whom this Web Site shares personally identifiable information for those third parties’ direct marketing purposes. As set forth below in this Web Site’s Privacy Policy, we comply with this law by not sharing your personally identifiable information with third parties for their direct marketing purposes unless you first affirmatively agree to the disclosure. For those California residents who want more information regarding our compliance with this law or your choices, please contact us at ",
view.el(
["a",1],
{href:"mailto:support@positiverelating.tv"},
"support@positiverelating.tv"),

". You must include this Web Site as the subject line, and your full name, e-mail address, and postal address in your message. We will only respond to messages specifically requesting information regarding our compliance with this law or your choices, and those that include the above information. We will also only respond to a request from you one time per calendar year. "),

view.el(["br",2],null),
view.el(["br",3],null),
view.el(
["div",2],
null,
view.el(
["span",2],
{className:"boldSpan"},
"Privacy Policy")),


view.el(["br",4],null),
view.el(
["div",3],
null,
view.el(["br",5],null),
"This Privacy Policy explains what information Mehow, Inc. (“Mehow” or “we”) collects on the Web Site, how Mehow uses that information, your choices and this Web Site’s other privacy practices. This Privacy Policy only covers information collected at this Web Site, and does not cover any information collected at any other web site or offline by Mehow, any affiliated company or any other company (unless specifically stated). Please read this Privacy Policy carefully. In addition, please review this Web Site’s “Terms and Conditions” (linked at the bottom of this page), which governs your use of this Web Site. "),

view.el(["br",6],null),
view.el(
["p",2],
null,
view.el(["br",7],null),
view.el(
["span",3],
{className:"boldSpan"},
"INFORMATION COMPANY COLLECTS AND HOW COMPANY USES IT")),


view.el(
["p",3],
null,
view.el(
["span",4],
{className:"boldSpan"},
"Personally Identifiable Information:"),

" We may ask you to provide us with certain personally identifiable information, which is information that could reasonably be used to identify you personally (such as your name, address, e-mail address and telephone number) when you register with us or at other times, such as when you buy products or services, if you choose to subscribe to a web forum or blog, or if you choose to participate in a contest, sweepstakes or other promotion. In addition, we may ask that you provide us with demographic information, information regarding your interests, or similar information when you submit a registration form on the Web Site. Providing us with information about yourself is voluntary, and you can always choose not to provide certain information, but then you may not be able to take advantage of some of the Web Site’s features and services. "),

view.el(["br",8],null),
view.el(
["p",4],
null,
"The Web Site may also receive information about you from other sources, such as in connection with a promotion the Web Site is participating in that is offered on a third-party web site, and we may combine the information we receive from those other sources with information that we collect through this Web Site. In those cases, we will apply this Privacy Policy to any personally identifiable information received. "),

view.el(["br",9],null),
view.el(
["p",5],
null,
"Mehow may use your personally identifiable information to provide you with requested information or services, to contact you in connection with a promotion, or for other purposes disclosed when you provide your information. We may use your information for internal business purposes, such as to improve the Web Site and our business strategies, or to serve specific content or advertisements to you. If you choose to receive information from the Web Site, we may contact you with information regarding one of our products or that of an affiliate or business partner. We may also contact you regarding any problems or questions we have relating to your use of the Web Site, or, in our discretion, notify you of changes to our Privacy Policy, Terms of Use or other policy or terms that affect you or your use of the Web Site "),

view.el(["br",10],null),
view.el(
["p",6],
null,
"If you submit to the Web Site a comment, photograph or other content to be published, online or offline (including on-air, in a DVD, or any other format), we may publish your name or other personally identifiable information in connection with publishing the content. "),

view.el(["br",11],null),
view.el(
["p",7],
null,
"If you provide us with personally identifiable information of a friend, or your friend provides personally identifiable information about you, to e-mail a feature from the Web Site, the e-mail addresses you or your friend supply us for those activities will not be used to send you or your friend other e-mail communications unless disclosed at the time you provide the information. "),

view.el(["br",12],null),
view.el(
["p",8],
null,
"Please note that information submitted to the Web Site via a “contact us,” “help” or other similar e-mail address or form will not necessarily receive a response. We will not use the information provided to these e-mail addresses or forms for marketing purposes unrelated to your request. "),

view.el(["br",13],null),
view.el(
["p",9],
null,
view.el(
["span",5],
{className:"boldSpan"},
"Note To Parents About Children: "),

"This Web Site is not directed to persons younger than 18, and does not knowingly collect any personally identifiable information from persons younger than 18. If you are younger than 18, do not send any information about yourself to the Web Site. If Mehow discovers that a person younger than 18 has provided the Web Site with personally identifiable information, Mehow will delete that person’s personally identifiable information. "),

view.el(
["p",10],
null,
view.el(
["span",6],
{className:"boldSpan"},
"Non-Personally Identifiable Information:"),

" When you visit or download information from this Web Site, our web servers may automatically collect web site usage information. Web site usage information is non-personally identifying information that describes how our visitors use the Web Site. It can include the number and frequency of visitors to each web page and the length of their stays, browser type, referrer data that identifies the web page visited prior and subsequent to visiting the Web Site, and IP addresses (see below for more information on IP addresses). We also may determine your screen resolution and the technology available in order to serve you the most appropriate version of a web page, e-mail or similar service. "),

view.el(["br",14],null),
view.el(
["p",11],
null,
view.el(
["span",7],
{className:"boldSpan"},
"Use Of IP Addresses:"),

" An internet protocol or IP address is a number that is assigned to your computer or network when you are on the internet. When you request pages from this Web Site, our servers may log your IP address. Mehow may use IP addresses for a number of purposes, such as system administration, to generally determine your computer’s server location, to report aggregate information to our business partners or to audit use of the Web Site. "),

view.el(["br",15],null),
view.el(
["p",12],
null,
view.el(
["span",8],
{className:"boldSpan"},
"Use of Cookies, Web Beacons and Similar Technologies:"),

" This Web Site’s pages or e-mail messages may contain cookies, web beacons (also known as clear gifs), or similar technologies as they become available. Cookies are information files that this Web Site may place on your computer to provide extended functionality. We may use cookies for a number of purposes, such as tracking usage patterns on the Web Site, measuring the effectiveness of advertising, limiting multiple responses and registrations, facilitating your ability to navigate the Web Site and as part of a verification or screening process. Most browsers are initially set up to accept cookies. You can reset your browser to refuse all cookies or to indicate when a cookie is being sent by indicating this in the preferences or options menu in your browser. However, it is possible that some parts of this Web Site will not operate correctly if you disable cookies and you may not be able to take advantage of some of this Web Site’s features. You should consult with your browser’s provider/manufacturer if you have any questions regarding disabling cookies. "),

view.el(["br",16],null),
view.el(
["p",13],
null,
"A web beacon is a small graphic image that allows the party that set the web beacon to monitor and collect certain information about the viewer of the web page, web-based document or e-mail message, such as the type of browser requesting the web beacon, the IP address of the computer that the web beacon is sent to and the time the web beacon was viewed. Web beacons can be very small and invisible to the user, but, in general, any electronic image viewed as part of a web page or e-mail, including HTML based content, can act as a web beacon. Mehow may use web beacons to count visitors to the web pages on the Web Site or to monitor how our users navigate the Web Site, and we may include web beacons in e-mail messages in order to count how many messages sent were actually opened, acted upon or forwarded. "),

view.el(["br",17],null),
view.el(
["p",14],
null,
"Our web pages may include advertisements for third parties and their products, and those third-party advertisements may include a cookie or web beacon served by the third party. Mehow does not have control over the cookies or web beacons used by third parties and does not have access to whatever information they may collect. "),

view.el(["br",18],null),
view.el(
["div",4],
null,
view.el(
["span",9],
{className:"boldSpan"},
"DISCLOSURE OF COLLECTED INFORMATION & THIRD PARTIES")),


view.el(
["p",15],
null,
view.el(["br",19],null),
"Mehow may disclose non-personally identifying, aggregated user statistics to third parties. Mehow does not share your personally identifiable information with third parties for their direct marketing purposes unless you first affirmatively agree to the disclosure. If you agree to receive communications from a third party, your information will be subject to the third party’s privacy policy. Therefore, if you later decide that you do not want that third party to use your information, you will need to contact the third party directly. "),

view.el(["br",20],null),
view.el(
["p",16],
null,
"In addition, unless otherwise disclosed in this Privacy Policy or at the time you provide your information, Mehow will only share your personally identifiable information with third parties under the following limited circumstances: "),

view.el(["br",21],null),
view.el(
["p",17],
null,
view.el(
["span",10],
{className:"boldSpan"},
"Third parties providing services on our behalf:"),

" Mehow may employ other companies and individuals to perform functions on our behalf. Examples include, without limitation, hosting and administering this Web Site, fulfilling orders, sending communications on our behalf, analyzing data, and administering promotions. These third parties may have access to this Web Site’s user information, including personally identifiable information, in order to perform these functions on our behalf. "),

view.el(["br",22],null),
view.el(
["p",18],
null,
view.el(
["span",11],
{className:"boldSpan"},
"Legal Protection:"),

" Mehow may transfer and disclose information about our users, including personally identifiable information, and may use IP addresses to identify users in cooperation with internet service providers or law enforcement agencies, to comply with a legal obligation, at the request of governmental authorities conducting an investigation, to verify or enforce compliance with the policies governing the Web Site and applicable laws, or to protect the legal rights, interests, or safety of the Web Site, our users or others. "),

view.el(["br",23],null),
view.el(
["p",19],
null,
view.el(
["span",12],
{className:"boldSpan"},
"Corporate change:"),

" Mehow reserves the right to disclose and transfer user information, including personally identifiable information, in connection with a corporate merger, consolidation, restructuring, a sale of assets, or other fundamental corporate change. "),

view.el(["br",24],null),
view.el(
["p",20],
null,
view.el(
["span",13],
{className:"boldSpan"},
"Sweepstakes, Contests and Promotions:"),

" If you choose to enter a sweepstakes, contest or other promotion, your personally identifiable information may be disclosed to third parties in connection with the administration of such promotion, including, without limitation, in connection with winner selection, prize fulfillment and as required by law, such as on a winners list. Also, by entering a promotion, you are agreeing to the official rules that govern that promotion, which may contain specific requirements of you, including, except where prohibited by law, allowing the sponsor(s) of the promotion to use your name, voice or likeness in advertising or marketing associated with the promotion. "),

view.el(
["p",21],
null,
view.el(
["span",14],
{className:"boldSpan"},
"USER FORUMS"),

" "),

view.el(["br",25],null),
view.el(
["div",5],
null,
view.el(["br",26],null),
"Please review our restrictions on use and guidelines for user forums in the Terms and Conditions (linked at the bottom of this page) for the Web Site. In addition, please note that this Privacy Policy does not apply to any information you may disclose publicly in user forums (such as message boards, online diaries, or similar web pages). Your user name will be used to identify you on the Web Site, including within user forums, so we recommend not using your real name or other information that can be used to identify you when selecting a user name. In addition, do not use the real name of another person as your user name. When you register, you will have the opportunity to create a public profile that will be available to others through the message boards, online diaries and other public web pages. ",
view.el(
["span",15],
{className:"boldSpan"},
"You are solely responsible for your public profile’s content."),

" Mehow bears no responsibility for any action or policies of any third parties who collect any information that users may disclose in user forums or other public areas of this Web Site."),

view.el(["br",27],null),
view.el(["br",28],null),
view.el(
["div",6],
null,
view.el(
["span",16],
{className:"boldSpan"},
"YOUR CHOICES"),

" "),

view.el(
["div",7],
null,
view.el(["span",17],{className:"boldSpan"})),

view.el(["br",29],null),
view.el(
["div",8],
null,
view.el(["span",18],{className:"boldSpan"}),
" "),

view.el(["br",30],null),
view.el(
["div",9],
null,
view.el(
["span",19],
{className:"boldSpan"},
"SECURITY"),

" "),

view.el(["br",31],null),
view.el(
["div",10],
null,
view.el(["br",32],null),
"No data transmission over the internet or electronic storage of information can be guaranteed to be 100% secure. Please note that Mehow cannot ensure or warrant the security of any information you transmit to Mehow, and you do so at your own risk. "),

view.el(["br",33],null),
view.el(
["div",11],
null,
view.el(["span",20],{className:"boldSpan"})),

view.el(["br",34],null),
view.el(
["div",12],
null,
view.el(["span",21],{className:"boldSpan"}),
" "),

view.el(["br",35],null),
view.el(
["div",13],
null,
view.el(
["span",22],
{className:"boldSpan"},
"LINKS ")),


view.el(["span",23],{className:"boldSpan"}),
view.el(
["p",22],
null,
view.el(["br",36],null),
"The Web Site and communications sent by the Web Site may contain links that take you outside our services and are beyond our control. For example, you may encounter links from sponsors or partners, which may or may not include the Mehow logo as part of a co-branding agreement. If you “click” on the link to a third party, the “click” takes you to a third party’s web site or online content. These other web sites may set their own cookies, collect data, solicit personally identifiable information and/or have their own privacy policies. "),

view.el(["br",37],null),
view.el(
["div",14],
null,
view.el(["span",24],{className:"boldSpan"})),

view.el(["br",38],null),
view.el(
["div",15],
null,
view.el(["span",25],{className:"boldSpan"}),
" "),

view.el(["br",39],null),
view.el(
["div",16],
null,
view.el(
["span",26],
{className:"boldSpan"},
"CONSENT TO TRANSFER ")),


view.el(["br",40],null),
view.el(
["div",17],
null,
view.el(
["span",27],
{className:"boldSpan"},
view.el(["br",41],null)),

"This Web Site is operated in the United States. If you are located in the European Union, Canada or elsewhere outside of the United States, please be aware that any information you provide to us will be transferred to the United States. By using the Web Site or providing us with your information, you consent to this transfer. "),

view.el(["br",42],null),
view.el(
["div",18],
null,
view.el(["span",28],{className:"boldSpan"})),

view.el(["br",43],null),
view.el(
["div",19],
null,
view.el(["span",29],{className:"boldSpan"}),
" "),

view.el(["br",44],null),
view.el(
["div",20],
null,
view.el(
["span",30],
{className:"boldSpan"},
"ACCEPTANCE & PRIVACY POLICY CHANGES"),

" "),

view.el(["br",45],null),
view.el(
["div",21],
null,
view.el(["br",46],null),
"By using this Web Site, you accept our privacy practices, as outlined in this Privacy Policy. Mehow reserves the right to modify, alter or otherwise update this Privacy Policy at any time. We will post any new or revised policies on the Web Site. However, Mehow will use your personally identifiable information in a manner consistent with the Privacy Policy in effect at the time you submitted the information, unless you consent to the new or revised policy. "),

view.el(
["p",23],
null,
"The EFFECTIVE DATE of this Privacy Policy is: May 31, 2015.")),


view.el(
["header",2],
{className:"termsHeader"},
"Terms of Service"),

view.el(
["legalese",2],
null,
view.el(
["p",24],
{align:"center"},
view.el(
["b",1],
null,
"Terms and Conditions")),


view.el(
["p",25],
{align:"center"},
view.el(
["b",2],
null,
"(V5.2 – Effective March 25",
view.el(
["sup",1],
null,
"th"),

", 2010)")),


view.el(
["p",26],
null,
"PLEASE READ THE FOLLOWING TERMS AND CONDITIONS RELATING TO YOUR USE OF THIS SITE AND THE PRODUCTS AND SERVICES PROVIDED HEREUNDER CAREFULLY. By i) using this site ii) purchasing any products or services from Mehow Publishing, Inc. and Medalport Holdings Limited, Cypress (collectively known as “Mehow”), iii) or utilizing any of the products or services from Mehow through this site, you are deemed to have agreed to these terms and conditions. We reserve the right to modify them at any time. You should check these terms and conditions periodically for changes. By using this site after we post any changes to these terms and conditions, you agree to accept those changes, whether or not you have reviewed them. With regard to products and services purchased or utilized from Mehow, the version of these terms and conditions that were posted at the time of purchase or utilization apply. If at any time you choose not to accept these terms and conditions of use, please do not use this site. "),

view.el(
["p",27],
{align:"center"},
view.el(
["b",3],
null,
"Index")),


view.el(
["p",28],
null,
view.el(
["b",4],
null,
"Part I. ",
view.el(
["a",2],
{href:"#part-I"},
"General Terms & Conditions"))),



view.el(
["p",29],
null,
view.el(
["b",5],
null,
"Part II. ",
view.el(
["a",3],
{href:"#part-II"},
"User Public Forum Submission/Participation Policy And Terms"))),



view.el(
["p",30],
null,
view.el(
["b",6],
null,
"Part III. ",
view.el(
["a",4],
{href:"#part-III"},
"Special Notes With Regard To Product Purchases"))),



view.el(
["p",31],
null,
view.el(
["b",7],
null,
"Part IV. ",
view.el(
["a",5],
{href:"#part-IV"},
"Product Purchase Agreement"))),



view.el(
["p",32],
null,
view.el(
["b",8],
null,
"Part V. ",
view.el(
["a",6],
{href:"#part-V"},
"Terms Applicable To Students"))),



view.el(
["p",33],
null,
view.el(
["b",9],
null,
"****************************************************************************** ")),


view.el(
["p",34],
null,
view.el(
["b",10],
null,
view.el(
["a",7],
{name:"part-I"},
"Part I. GENERAL TERMS & CONDITIONS"))),



view.el(
["p",35],
null,
view.el(
["b",11],
null,
"a) Scope of Terms and Conditions")),


view.el(
["p",36],
null,
"These terms and conditions apply to your use of all of the website at positiverelating.tv, all websites owned by Mehow.Inc. including but not limited to: mrright.net, threesecondattraction.com (collectively the \"Site\"), as well as to products and services purchased or utilized from the Site. Unless stated otherwise, all references to the Site in these terms and conditions include this site. These terms and conditions do not apply to your use of unaffiliated sites to which the Site only links. "),

view.el(
["p",37],
null,
view.el(
["b",12],
null,
"b) Restrictions on Use")),


view.el(
["p",38],
null,
"The contents of this site are protected by copyright and trademark laws, and are the property of their owners. Unless we say otherwise, you may access the materials located within the Site only for your personal use. This means you may download one copy of posted materials on a single computer for personal, noncommercial home use only, so long as you neither change nor delete any author attribution, trademark, legend or copyright notice. When you download copyrighted material you do not obtain any ownership rights in that material. "),

view.el(
["p",39],
null,
"You may not modify, copy, publish, display, transmit, adapt or in any way exploit the content of the Site. Only if you obtain prior written consent from us and from all other entities with an interest in the relevant intellectual property may you publish, display or commercially exploit any material from the Site. "),

view.el(
["p",40],
null,
"You must abide by all additional copyright notices or other restrictions contained in any of the Site. "),

view.el(
["p",41],
null,
"You agree not to do any of the following while using the Site: "),

view.el(
["p",42],
null,
"1) harass, stalk or otherwise abuse another user; "),

view.el(
["p",43],
null,
"2) transmit or otherwise make available any content that is false, harmful, threatening, abusive, tortious, defamatory, libelous, disparaging (including disparaging of the Site), vulgar, obscene, pornographic or that promotes violence, racial hatred, terrorism or illegal acts, or is otherwise objectionable (as determined by us in our sole discretion); "),

view.el(
["p",44],
null,
"3) transmit or otherwise make available any content that is unlawful or infringes, violates or misappropriates any patent, trademark, trade identity right, trade secret, publicity right, privacy right, copyright or any other intellectual property or any other rights of any third party; "),

view.el(
["p",45],
null,
"4) upload or transmit viruses, Trojan horses or other harmful, disruptive or destructive files or post material that interferes with any third party’s uninterrupted use and enjoyment of the Site. "),

view.el(
["p",46],
null,
"5) impersonate any person or entity, or otherwise disguise the origin of any content transmitted through the Site or to us, including forging any TCP/IP packet header or any part of the header information in any transmission to the Site for any reason;"),

view.el(
["p",47],
null,
"6) transmit or otherwise make available through the Site any personal advertising, junk mail, spam, chain letters, pyramid schemes or offer for sale of any products or services, except in areas specifically designated for such purposes; or "),

view.el(
["p",48],
null,
"7) violate any applicable local, state, federal or international law, rule or regulation. "),

view.el(
["p",49],
null,
view.el(
["b",13],
null,
"c) Links")),


view.el(
["p",50],
null,
"These terms and conditions apply only to this Site, and not to the sites of any other companies or organizations, including those to which this Site may link. We are not responsible for the availability of any other site to which this Site links. We do not endorse or take responsibility for the contents, advertising, products or other materials made available through any other site. Under no circumstances will we be held responsible or liable, directly or indirectly, for any loss or damage that is caused or alleged to have been caused to you in connection with your use of, or reliance on, any content, goods or services available on any other site. You should direct any concerns to that site administrator or webmaster. "),

view.el(
["p",51],
null,
"Other sites may link to this Site only through a plain-text link or provided graphics link. Permission must be granted by us for any other type of link to the Site. To seek our permission, you may send E – mail to support@positiverelating.tv. We reserve the right, however, to rescind any permission granted by us to link through a plain-text link or any other type of link, and to require termination of any such link this Site, at our discretion at any time."),

view.el(
["p",52],
null,
view.el(
["b",14],
null,
"THE SERVICES, PRODUCTS AND MATERIALS ON OR FROM THIS SITE ARE PROVIDED \"AS IS\" AND WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES TO THE MAXIMUM EXTENT OF THE LAW, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. ")),


view.el(
["p",53],
null,
view.el(
["b",15],
null,
"NEITHER WE NOR ANY OF OUR RESPECTIVE LICENSORS OR SUPPLIERS WARRANT THAT ANY FUNCTIONS CONTAINED IN THE SITE WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SITE OR THE SERVER THAT MAKES THEM AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.")),


view.el(
["p",54],
null,
view.el(
["b",16],
null,
"NEITHER WE NOR ANY OF OUR RESPECTIVE LICENSORS OR SUPPLIERS WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OR THE RESULTS OF THE USE OF THE SERVICES, PRODUCTS OR MATERIALS IN THIS SITE IN TERMS OF THEIR CORRECTNESS, ACCURACY, RELIABILITY, OR OTHERWISE. YOU (AND NOT WE OR ANY OF OUR RESPECTIVE LICENSORS OR SUPPLIERS) ASSUME THE ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION TO YOUR SYSTEM.")),


view.el(
["p",55],
null,
view.el(
["b",17],
null,
"APPLICABLE LAW MAY NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO YOU. TO THE EXTENT ANY WARRANTY CANNOT BE DISCLAIMED, A LIMITED EXPLICT WARRANTY IS GIVEN BY US TO THE EXCLUSION OF ANY OTHER REMEDY TO, IN OUR DISCRETION, EITHER A) REPLACE THE SERVICES, PRODUCTS AND MATERIALS WITH SUCH SERVICES, PRODUCTS AND MATERIALS THAT DO NOT BREACH A WARRANTY IF SUCH BREACH IS IDENTIFIED TO US WITHIN 30 DAYS OF PURCHASE OR B) REFUND OF THE MONIES PAID FOR THE PARTICULAR SERVICES, PRODUCTS AND MATERIALS.")),


view.el(
["p",56],
null,
view.el(
["b",18],
null,
"BY ACCESSING THIS SITE, YOU UNDERSTAND THAT YOU MAY BE WAIVING RIGHTS WITH RESPECT TO CLAIMS THAT ARE AT THIS TIME UNKNOWN OR UNSUSPECTED, AND IN ACCORDANCE WITH SUCH WAIVER, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND, AND HEREBY EXPRESSLY WAIVE, THE BENEFITS OF SECTION 1542 OF THE CIVIL CODE OF CALIFORNIA, AND ANY SIMILAR LAW OF ANY STATE OR TERRITORY, WHICH PROVIDES AS FOLLOWS: \"A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR.\"")),


view.el(
["p",57],
null,
"We do not endorse, warrant or guarantee any products or services offered on the Site. We are not a party to, and do not monitor, any traOne(der)ction between users and third party providers of products or services. "),

view.el(
["p",58],
null,
view.el(
["b",19],
null,
"d) Limitation of Liability")),


view.el(
["p",59],
null,
view.el(
["b",20],
null,
"UNDER NO CIRCUMSTANCES, INCLUDING BUT NOT LIMITED TO NEGLIGENCE, WILL WE OR ANY OF OUR LICENSORS OR SUPPLIERS BE LIABLE FOR ANY SPECIAL OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE MATERIALS ON THE SITE, OR ANY PRODUCTS OR SERVICES PROVIDED PURSUANT TO THE SITE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. APPLICABLE LAW MAY NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL, CONSEQUENTIAL OR OTHER DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. IN NO EVENT SHALL THE TOTAL LIABILITY TO YOU BY US OR ANY OF OUR LICENSORS OR SUPPLIERS FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER IN CONTRACT, TORT, OR OTHERWISE) EXCEED THE AMOUNT PAID BY YOU TO US, IF ANY, FOR ACCESSING THE SITE.")),


view.el(
["p",60],
null,
view.el(
["b",21],
null,
"e) No Personal Advice")),


view.el(
["p",61],
null,
"The information contained in or made available through this Site (including but not limited to information contained on message boards, in text files, in products, from services, or in chats) cannot replace or substitute for the services of trained professionals in any field, including, but not limited to, psychological, financial, medical, or legal matters. In particular, you should regularly consult a doctor in all matters relating to physical or mental health, particularly concerning any symptoms that may require diagnosis or medical attention. Further, you should regularly consult a lawyer in all matters relating to interacting with other people to assure yourself you are behaving in compliance with law, including but not limited to laws related to harassment, assault or other similar laws. We and our licensors or suppliers make no representations or warranties concerning any treatment, action, or application of medication or preparation by any person following the information offered or provided within or through the Site (including but not limited to any product or service purchased, utilized or otherwise obtained from this Site). Neither we nor our partners, or any of their affiliates, will be liable for any direct, indirect, consequential, special, exemplary or other damages that may result, including but not limited to economic loss, injury, illness or death. "),

view.el(
["p",62],
null,
view.el(
["b",22],
null,
"f) Parental Permission; Minimum Age 18 Requirement")),


view.el(
["p",63],
null,
"Some of the information available on the Site (including but not limited to any product or service purchased, utilized or otherwise obtained from this Site) concerns the topic of sex and may not be appropriate for minors. Further, the Site (as well as any product or service purchased, utilized or otherwise obtained from this Site) is not directed to persons under the age of 18 and we will not knowingly collect personally identifiable information from persons under 18. ",
view.el(
["b",23],
null,
"WE STRONGLY RECOMMEND THAT PARENTS PARTICIPATE IN THEIR CHILDREN EXPLORATION OF THE INTERNET AND ANY ONLINE SERVICES AND USE THEIR BROWSERS PARENTAL CONTROLS TO LIMIT THE AREAS OF THE INTERNET TO WHICH THEIR CHILDREN HAVE ACCESS. ")),


view.el(
["p",64],
null,
"We hereby require all users of the Site or purchasers of Mehow’s products and services to be over 18. You agree to abide by any such restrictions, and not to help anyone avoid these restrictions. If you are under 18, you agree to immediately stop accessing the Site or using any of the products or services of Mehow. If you are accessing the Site or using or purchasing any of the products or services of Mehow, you represent that you are at least 18 years of age."),

view.el(
["p",65],
null,
view.el(
["b",24],
null,
"g) MEMBERSHIP FEES")),


view.el(
["p",66],
null,
"We reserve the right to charge fees, surcharges and/or membership fees for all or any of its services currently provided for free at any time upon thirty (30) days’ prior written notice to you. "),

view.el(
["p",67],
null,
view.el(
["b",25],
null,
"h) COPYRIGHT")),


view.el(
["p",68],
null,
"All content included on this Site, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, is the property of Mehow, Inc or its content suppliers and protected by United States and international copyright laws. The compilation of all content on this site is the exclusive property of Mehow, Inc and protected by U.S. and international copyright laws. All software used on this site is the property of Mehow, Inc or its software suppliers and protected by United States and international copyright laws. "),

view.el(
["p",69],
null,
view.el(
["b",26],
null,
"i) TRADEMARKS ")),


view.el(
["p",70],
null,
"Positive Relating, the stylized logo, and other Mehow, Inc logos, page headers, button icons, scripts, and service names are trademarks, registered trademarks or trade dress of Mehow Publishing, Inc. or its affiliates in the U.S. and/or other countries. Mehow, Inc’s trademarks and trade dress may not be used in connection with any product or service that is not Mehow, Inc’s, in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits Mehow Publishing, Inc. All other trademarks not owned by Mehow, Inc or its affiliates that appear on this site are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Mehow, Inc or its affiliates. Hypnotica is a trademark of Hypnotica LLC."),

view.el(
["p",71],
null,
"j) NON-DISPARAGEMENT"),

view.el(
["p",72],
null,
"You agree that you will not make any disparaging statements concerning Mehow, Inc, any of its affiliates or subsidiaries, officers, directors, employees or agents, except as may be required by law. "),

view.el(
["p",73],
null,
view.el(
["b",27],
null,
view.el(
["a",8],
{name:"part-II"},
"Part II. User Public Forum Submission/Participation Policy and Terms"))),



view.el(
["p",74],
null,
"a) General: As a service to our users, this Site may feature message boards, chat rooms/areas, discussion forums, ratings, comments, bulletin board services, news groups (including, without limitation, Usenet and other third party news groups), communities and/or other message or communication facilities and other public/semi-public/private forums (collectively, \"Forums\") where users with similar interests or similar experiences can share information and support one another or where users can post questions for others to answer. We may also offer online discussions moderated by various experts or other persons. "),

view.el(
["p",75],
null,
"Much of the content of the Forums, including without limitation the descriptions for many Forums and the content within a specific message, comment or posting, is provided by and is the responsibility of the third party creator of the Forum or the person posting in that Forum. Mehow Publishing, Inc. (\"Mehow\") has no responsibility for such content and is merely providing access to such content as a service to you."),

view.el(
["p",76],
null,
view.el(
["b",28],
null,
"BY THEIR VERY NATURE, FORUMS MAY CARRY OFFENSIVE, HARMFUL, INACCURATE OR OTHERWISE INAPPROPRIATE MATERIAL, OR IN SOME CASES, POSTINGS THAT HAVE BEEN MISLABELED OR ARE OTHERWISE DECEPTIVE. WE EXPECT THAT YOU WILL USE CAUTION AND COMMON SENSE AND EXERCISE PROPER JUDGMENT WHEN USING DISCUSSION FORUMS.")),


view.el(
["p",77],
null,
view.el(
["b",29],
null,
"b) Your Participation/Contribution Requires Consideration: ")),


view.el(
["p",78],
null,
"Any information shared (including personally identifiable information or other personal information) that you reveal in a Forum is by design open to the public (or to a private group within a special Forum) and is not a private, secure service. You should think carefully before disclosing any information in any Forum. What you have written may be seen, disclosed to or collected by third parties and may potentially be used by others in ways we are unable to control or predict, including to contact you for unauthorized purposes. By submitting communications or content to Forums, you agree that such submission is non-confidential for all purposes."),

view.el(
["p",79],
null,
view.el(
["b",30],
null,
"c) Confidential Obligations: ")),


view.el(
["p",80],
null,
"You agree that you will not upload or transmit any communications or content of any type to a Forum that infringe or violate any rights of any party. Further, you may have entered into an agreement with Mehow that requires you to maintain the confidentiality of certain material or information of Mehow. It is your obligation to confirm that any post to a Forum you make does not breach any confidentiality obligation you have. Unless a Forum specifically notes that all members of the Forum who are able to view posts are bound by confidentiality obligations, and further notes what types of information may be discussed, you may not post information which Mehow has required you to preserve as confidential. "),

view.el(
["p",81],
null,
view.el(
["b",31],
null,
"d) Grant of Rights: ")),


view.el(
["p",82],
null,
"To the extent you are the original copyright holder of any post or submission by you to a Forum and such post or submission does not contain any of the information or material of Mehow or other information you are required to preserve as confidential by Mehow, then; i) you remain owner of such post or submission to the extent you were the owner; ii) you automatically grant on behalf of yourself or otherwise warrant that the owner of such content or intellectual property has expressly granted Mehow, a royalty-free, perpetual, irrevocable, world-wide nonexclusive license to use, reproduce, create derivative works from, modify, publish, edit, translate, distribute, perform, display, and/or otherwise exploit, the post, submission, communication or content in any media or medium, or any form, format, or forum now known or hereafter developed; and iii) you agree and warrant that Mehow may sublicense or assign its rights through multiple tiers of sublicenses or assigns. "),

view.el(
["p",83],
null,
view.el(
["b",32],
null,
"e) No Obligation to Monitor: ")),


view.el(
["p",84],
null,
"Mehow does not control the information delivered to the Forums, and has no obligation to monitor the Forums. However, Mehow reserves the right at all times to disclose any information as necessary to satisfy any applicable law, regulation, legal process or legal governmental request, or to edit, refuse to post or to remove any information or materials, in whole or in part, for any reason whatsoever, in Mehow’s sole discretion."),

view.el(
["p",85],
null,
view.el(
["b",33],
null,
"f) No Obligation to Remove: ")),


view.el(
["p",86],
null,
"Mehow is not obligated to remove any content from the site which does not violate any civil or criminal laws and any contributions intended for display on this web site via any means, whether submitted via HTTP (web), SMTP (mail), NNTP (newsreader), or otherwise, are presumed to be contributed by the author/contributor with the intent that Mehow shall have an ongoing non-exclusive right to publish the contributed content for an indefinite amount of time, unless the content submitted was made under an agreement with Mehow, Inc with differing term agreements or Mehow has clearly only been provided limited non-exclusive publishing rights (for example, in the case of some exclusively copyrighted newsletter content). If you do not wish to have something which you submit to be published, do not submit it in the first place."),

view.el(
["p",87],
null,
view.el(
["b",34],
null,
"g) No Endorsement: ")),


view.el(
["p",88],
null,
"Mehow does not endorse, support, represent or guaranty the truthfulness, accuracy, or reliability of any communications posted in the Forums or endorse any opinions expressed in the Forums. You acknowledge that any reliance on material posted in the Forums will be at your own risk."),

view.el(
["p",89],
null,
view.el(
["b",35],
null,
"h) Company’s Right to Act: ")),


view.el(
["p",90],
null,
"If Mehow discovers communications which allegedly do not conform to any terms and conditions of this Site, Mehow may investigate the allegation and determine in good faith and in its sole discretion whether to remove or request the removal of the communication. Mehow will have no liability or responsibility for performance or non-performance of such activities. Mehow reserves the right to terminate or restrict your access to any or all of the Forums at any time without notice for any reason whatsoever. You acknowledge that some Forums available through the Site are available only through the Site and others are available both through the Site and other sources, such as Usenet, over which Mehow has absolutely no control."),

view.el(
["p",91],
null,
view.el(
["b",36],
null,
view.el(
["a",9],
{name:"part-III"},
"Part III. Special Notes with regard to Product Purchases"))),



view.el(
["p",92],
null,
view.el(
["b",37],
null,
"a) Shipping Methods")),


view.el(
["p",93],
null,
"Products shipped by Mehow Publishing, Inc. (\"Mehow\") may be shipped by UPS Standard or by any other method in the discretion of Mehow. A shipping charge will be imposed. "),

view.el(
["p",94],
null,
"1) Orders shipped to PR will have a 6.6% duty tax."),

view.el(
["p",95],
null,
"2) All orders require at least 24-48 hours processing time before shipping."),

view.el(
["p",96],
null,
"3) Mehow does not process orders during weekends."),

view.el(
["p",97],
null,
"4) No deliveries will be made on Saturday or Sunday."),

view.el(
["p",98],
null,
"5) Mehow does not guarantee same day shipping."),

view.el(
["p",99],
null,
"6) All orders shipped within CA will be charged sales tax."),

view.el(
["p",100],
null,
"7) Exact delivery times to any location cannot be guaranteed. "),

view.el(
["p",101],
null,
view.el(
["b",38],
null,
"b) Sales Tax")),


view.el(
["p",102],
null,
"Sales tax is only required for orders shipping within our resident states of business. Therefore all orders shipping within California will be charged applicable sales tax according to your area’s tax rate. "),

view.el(
["p",103],
null,
view.el(
["b",39],
null,
"c) Duty Tax")),


view.el(
["p",104],
null,
"Orders shipped to PR will have a 6.6% duty tax applied. Exact delivery times to PR cannot be guaranteed. "),

view.el(
["p",105],
null,
view.el(
["b",40],
null,
"d) Product listings")),


view.el(
["p",106],
null,
"Mehow strives for accuracy in all item descriptions, photographs, compatibility references, detailed specifications, pricing, links and any other product-related information contained herein or referenced on our website. Due to human error and other determinates we cannot guarantee that all item descriptions, photographs, compatibility references, detailed specifications, pricing, links and any other product-related information listed is entirely accurate, complete or current, nor can we assume responsibility for these errors. In the event a product listed on our website is labeled with an incorrect price due to some typographical, informational, technical or other error, Mehow shall at its sole discretion have the right to refuse and/or cancel any order for said product and immediately amend, correct and/or remove the inaccurate information. Additionally, all hyperlinks to other websites from Mehow are provided as resources to customers looking for additional information and/or professional opinion. Mehow does not assume responsibility for the claims and/or representations made on these or any other websites. "),

view.el(
["p",107],
null,
view.el(
["b",41],
null,
"e) Product Revisions")),


view.el(
["p",108],
null,
"Mehow is not responsible for changes or variations in product specifications and/or physical appearance, since in some cases Mehow acts as a distributor for others. In the interest of our customers, Mehow puts forth its best efforts to ensure that all product information is up-to-date and factual. Unfortunately there are varying determinates which, although infrequent, could cause the information on our website to become outdated without our immediate knowledge. This includes but is not limited to new versions or revisions, color deviations, retail package alterations and other variations that may be considered inconsequential by the manufacturer. In some cases, Mehow relies on the manufacturer of a product to communicate these differences. Presently we have no way of alerting customers prior to purchase in the event the manufacturer fails to do so. Consequently, Mehow will not be held responsible for product revision changes. "),

view.el(
["p",109],
null,
view.el(
["b",42],
null,
view.el(
["a",10],
{name:"part-IV"},
"Part IV. Product Purchase Agreement")),


" "),

view.el(
["p",110],
null,
"By accepting delivery of any product delivered from Mehow Publishing, Inc. (\"Mehow\"), viewing such products, or otherwise using such products, you (\"Customer\") agree to be bound by the terms and conditions listed below. You and Mehow agree that the following terms and conditions are the exclusive terms governing the sales traOne(der)ction between Customer and Mehow. Any attempt to alter, supplement, modify or amend these terms and conditions by the Customer will be considered a material alteration of this agreement and, therefore, are null and void. In addition, these terms and conditions are subject to change at any time, without prior written notice. Therefore, please check these terms and conditions carefully each time you place an order with or accept delivery of any goods from Mehow. "),

view.el(
["p",111],
null,
view.el(
["b",43],
null,
"a) Mehow SATISFACTION GUARANTEE; Other Refund Policies")),


view.el(
["p",112],
null,
"Mehow offers our customers a 45-day (from the date of purchase) satisfaction replacement or refund guarantee on all product purchases where the \"100% Mehow Money Back Guarantee\" is advertised. It does not otherwise offer refunds or replacements pursuant to this Section. "),

view.el(
["p",113],
null,
"To take advantage of Mehow’s satisfaction guarantee, the Customer must comply with the Product Return Procedure detailed below. Any breach of Mehow’s Return Policy Procedure will result in the loss of Mehow’s refund/replacement guarantee. Furthermore, all return shipments not in compliance with these instructions will be rejected."),

view.el(
["p",114],
null,
"Notwithstanding the foregoing, there are no refunds for any product subscriptions that are less than $100 per month, but the subscription can be canceled at anytime. For product subscriptions that are $100 or more per month, refunds are limited to the most recent single payment."),

view.el(
["p",115],
null,
"Notwithstanding the foregoing, there are no refunds for any products that were provided for shipping and handling cost only (such as the \"How to Talk 2 Hot Women\" product)."),

view.el(
["p",116],
null,
"For products, please be aware that authorized refunds may take 4 to 6 weeks to process from i) in the case of the return of physical products, the date that Mehow receive the product or ii) in the case of products delivered by non-physical means, from the date of RMA approval."),

view.el(
["p",117],
null,
view.el(
["b",44],
null,
"b) Return Abuse Policy")),


view.el(
["p",118],
null,
"In the event that you, the Customer, has previously returned 1 or more prior product purchases, notwithstanding anything to the contrary, Mehow will only provide a replacement, not a refund, pursuant to its 45 day satisfaction guarantee, but only in the event the product media is defective. "),

view.el(
["p",119],
null,
view.el(
["b",45],
null,
"c) Product Return Procedure"),

" "),

view.el(
["p",120],
null,
"To return a product in compliance with Mehow’s 45 day satisfaction guarantee, you must first email to ",
view.el(
["a",11],
{href:"mailto:support@positiverelating.tv"},
"support@positiverelating.tv"),

" and request an RMA number. You must also include the name of the original purchaser, where the refund should be sent to, and a copy of your purchase receipt that you originally received from Mehow. Provided that you are eligible for a refund, Mehow shall provide you, by email, shipping instructions for returns with the RMA number. If return of a product is requested by Mehow, return of that product is a condition for a refund and will only be valid if they are mailed in according with the RMA directions (mailing to any other address except as set forth in the RMA instructions will not be honored as a return). Customer is solely responsible for shipping any returned product to Mehow. Customer agrees to use only reputable carriers capable of providing proof of delivery and insurance for the entire value of the shipment. Customer agrees to bear all shipping and insurance charges and all risk of loss for the return product during shipment. Customer agrees that all returned products will be 100% complete, in re-saleable condition, and will include the original packaging material, manuals, blank warranty cards, and other accessories provided by Mehow. If any component of the returned product is missing, Mehow’s Return Procedure will be breached and Mehow may in its sole and absolute discretion reject the entire return or choose to impose additional charges against the customer for replacement of the missing component(s). "),

view.el(
["p",121],
null,
"A return will not be processed until either i) it is received by you or ii) it has not be received by you and more than 30 days have passed since you made your purchase."),

view.el(
["p",122],
null,
"Mehow will not refund to Customer the original shipping charges. "),

view.el(
["p",123],
null,
view.el(
["b",46],
null,
"d) Service/Event Refunds"),

" The aforementioned 45-day satisfaction replacement or refund guarantee only applies to purchases of products and does not apply to the purchase of live event services provided by Mehow (“Mehow Live Event Services”). Mehow Live Event Services include but are not limited to bootcamps, seminars, personal instruction, and other live/in-person events. "),

view.el(
["p",124],
null,
"Deposits for Mehow Live Event Services are only refundable if such refund is requested 30 days or more before the date the particular Mehow Live Event Service is scheduled to be provided. A request for a refund for Mehow Live Event Services must be made in writing by email to ",
view.el(
["a",12],
{href:"mailto:support@positiverelating.tv"},
"support@positiverelating.tv"),

". If such request is made less than 30 days before the date the particular Mehow Live Event Service is scheduled to be provided, the refund will be provided as a “credit” held by Mehow which may be used towards the purchase of any of the products offered by Mehow. Such credit will be valid for 180 days from the request of refund, and thereafter shall expire. "),

view.el(
["p",125],
null,
view.el(
["b",47],
null,
"e) WARRANTIES; ALL PRODUCTS SOLD \"AS-IS\" OR \"WITH ALL FAULTS\"")),


view.el(
["p",126],
null,
view.el(
["b",48],
null,
"MEHOW MAKES NO REPRESENTATION OR EXPRESS WARRANTY WITH RESPECT TO THE PRODUCT EXCEPT THOSE STATED IN THIS DOCUMENT. MEHOW DISCLAIMS ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, AS TO ANY SUCH PRODUCT, INCLUDING AND WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, AND ANY IMPLIED WARRANTIES ARISING FROM STATUTE, TRADE USAGE, COURSE OF DEALING, OR COURSE OF PERFORMANCE. ")),


view.el(
["p",127],
null,
view.el(
["b",49],
null,
"ALL ITEMS SOLD THROUGH OR BY MEHOW ARE SOLD \"AS-IS\" OR \"WITH ALL FAULTS.\" THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THESE ITEMS IS WITH THE BUYER. SHOULD ANY OF THESE ITEMS PROVE DEFECTIVE, DO NOT FUNCTION, OR FUNCTION IMPROPERLY IN ANY WAY FOLLOWING THEIR PURCHASE, THE BUYER, AND NOT MEHOW, ASSUMES THE ENTIRE COST OF ALL NECESSARY SERVICING OR REPAIR. ")),


view.el(
["p",128],
null,
view.el(
["b",50],
null,
"f) LIMITATION OF LIABILITY")),


view.el(
["p",129],
null,
view.el(
["b",51],
null,
"IN ALL CIRCUMSTANCES MEHOW’S MAXIMUM LIABILITY IS LIMITED TO THE PURCHASE PRICE OF THE PRODUCTS SOLD. MEHOW SHALL NOT, UNDER ANY CIRCUMSTANCES, BE LIABLE UPON A CLAIM OR ACTION IN CONTRACT, TORT, INDEMNITY OR CONTRIBUTION, OR OTHER CLAIMS RELATING TO THE PRODUCTS IT SELLS WHICH EXCEEDS THIS LIABILITY LIMIT. MEHOW SHALL NOT BE LIABLE FOR THIRD PARTY CLAIMS FOR DAMAGES AGAINST THE CUSTOMER, OR FOR MALFUNCTION, DELAYS, INTERRUPTION OF SERVICE, LOSS OF BUSINESS, LOSS OR DAMAGE TO EXEMPLARY DAMAGES, WHETHER OR NOT MEHOW HAS BEEN MADE AWARE OF THE POSSIBILITY OF SUCH CLAIMS OR DAMAGES. 4. CUSTOMER AGREED TO RESTRICTIONS, OBLIGATIONS AND LIMITATIONS"),

" ",
view.el(
["b",52],
null,
"Confidentiality and Limited Use:"),

" "),

view.el(
["p",130],
null,
"Customer acknowledges that the products sold by Mehow are the confidential and proprietary information and property of Mehow. Customer hereby agrees to protect such products as confidential. As a further condition to the purchase and/or receipt of such products of Mehow by Customer, Customer agrees it will not, nor allow others, to directly or indirectly copy, distribute, resell, lend, lease, display, teach to others or show this product to others. A \"Customer\" includes anyone who receives the products of Mehow, even if for free. Customer agrees that no one may use this product in any manner without the written approval of Mehow, except for the Customer who has agreed that his/her use is limited to his/her own personal viewing. In the event Customer disagrees with these terms, Customer must immediately discontinue viewing the products purchased from Mehow and promptly return it to Mehow for refund according to (and limited by) the terms of this agreement. Anyone viewing or otherwise utilizing the products of Mehow by such conduct is agreeing to be bound by the terms of set forth herein, and as such must immediately comply with the terms of this agreement. In the event that Mehow discloses any portion of its information to the public, it should be understood that anything not publicly disclosed by Mehow remains information that you have an obligation to protect and maintain as confidential. Customer represents and warrants that he or she is at least 18 years old. In the event that Customer is under 18 years old, Customer will immediately discontinue viewing the products purchased from Mehow and promptly return it to Mehow for refund according to (and limited by) the terms of this agreement. "),

view.el(
["p",131],
null,
view.el(
["b",53],
null,
"g) GENERAL TERMS AND CONDITIONS ")),


view.el(
["p",132],
null,
"1) ",
view.el(
["b",54],
null,
"Payment Terms; Orders"),

": "),

view.el(
["p",133],
null,
"An order is not binding upon MEHOW until it is accepted; MEHOW must receive payment before it will accept an order. Payment for product(s) ordered is due prior to shipment. Customer can make payment by credit card, or some other method prearranged with MEHOW. You agree to pay the amount(s) due as specified on the invoice, and you agree to pay interest on all past-due sums at a rate of 1.5% per month or the highest rate allowed by law, whichever is greater. "),

view.el(
["p",134],
null,
"2) ",
view.el(
["b",55],
null,
"Shipping Charges"),

": Your total cost for purchase of any product will include shipping and handling charges shown on the MEHOW invoice. "),

view.el(
["p",135],
null,
"3) ",
view.el(
["b",56],
null,
"Title; Risk of Loss"),

": MEHOW will arrange for shipment of ordered product(s) to the Customer, Free On Board (F.O.B.) shipping point, meaning title to the product(s) — excepting software– and risk of loss passes to the Customer upon delivery to the carrier. MEHOW reserves a purchase money security interest in the product(s) until its receipt of the full amount due. Customer agrees to allow MEHOW to sign appropriate documents on Customer’s behalf to permit MEHOW to protect its purchase money security interest. Title to software will remain with the licensor(s). All software is provided subject to the license agreement of the software maker. Customer agrees to be bound by any software license agreement once the seal on the package is broken. MEHOW will advise Customer of estimated shipping dates, but MEHOW will, under no circumstances, be responsible for delays in delivery, and associated damages, due to events beyond its reasonable control, including without limitation, acts of God or public enemy, acts of federal, state or local government, fire, floods, civil disobedience, strikes, lockouts, and freight embargoes. "),

view.el(
["p",136],
null,
"4) ",
view.el(
["b",57],
null,
"Governing Law and Jurisdiction"),

": Any dispute arising out of or related to these Terms and Conditions or the sales traOne(der)ction between MEHOW and Customer shall be governed by the laws of the State of California, without regard to its conflicts of law rules. Specifically, the validity, interpretation, and performance of this agreement shall not be governed by the United Nations Convention on the International Sale of Goods. Mehow and Customer consent to the exclusive jurisdiction and the exclusive venue of the State Courts of the State of California, San Diego County, to resolve any dispute between them related hereto, and the parities waive all rights to contest this exclusive jurisdiction and venue of such Courts. Finally, the Customer also agree not to bring any legal action, based upon any legal theory including contract, tort, equity or otherwise, against MEHOW that is more than one year after the date of the applicable invoice. "),

view.el(
["p",137],
null,
"5) ",
view.el(
["b",58],
null,
"Severability"),

": If any provision contained in this agreement is or becomes invalid, illegal, or unenforceable in whole or in part, such invalidity, illegality, or unenforceability shall not affect the remaining provisions and portions of this agreement, and the invalid, illegal, or unenforceable provision shall be deemed modified so as to have the most similar result that is valid and enforceable under applicable California law. "),

view.el(
["p",138],
null,
"6) ",
view.el(
["b",59],
null,
"Waiver"),

": The failure of either party to require performance by the other party of any provision of this agreement shall not affect in any way the first party’s right to require such performance at any time thereafter. Any waiver by either party of a breach of any provision in this agreement shall not be taken or held by the other party to be a continuing waiver of that provision unless such waiver is made in writing. "),

view.el(
["p",139],
null,
"7) ",
view.el(
["b",60],
null,
"Entire Agreement"),

": These terms and conditions, together with MEHOW’s invoice regarding the products ordered by Customer, are the complete and exclusive agreement between MEHOW and Customer, and they supersede all prior or contemporaneous proposals, oral or written, understandings, representations, conditions, warranties, and all other communications between MEHOW and Customer relating to the subject products. This agreement may not be explained or supplemented by any prior course of dealings or trade by custom or usage."),

view.el(
["p",140],
null,
view.el(
["b",61],
null,
view.el(
["a",13],
{name:"part-V"},
"Part V. Terms Applicable To Students "))),



view.el(
["p",141],
null,
"If you are a participant in any of the classes, seminars, phone coaching, forum coaching events and/or workshops or training via instructor via any medium(such collectively referred to as the “Event” or “Events”) of Mehow, this Part V. applies to you. You herby acknowledge and agree with the following:"),

view.el(
["p",142],
null,
"a) All information and materials presented by, made in preparation of, provided in conjunction with or in relation to the Event(s), or the products of Mehow, or the materials and information provided pursuant to or in relation to the services provided by Mehow are collectively “Mehow Materials”. You agree that all Mehow Materials are for your personal use and personal entertainment purposes only. Any contribution, feedback or other material you provide for or during the Event(s), or based on or otherwise utilizing the Mehow Materials (“New Material”) shall be the property of Mehow and shall be treated as a work made for hire for Mehow. You agree to waive any rights or claims you may have to such New Materials and to convey ownership of such to Mehow as Mehow may request. You agree not to assert any “droit moral”, moral rights or other similar rights in the New Materials as requested by Mehow. New Material shall be considered Mehow Materials."),

view.el(
["p",143],
null,
"b) You agree that you will not, nor assist directly or indirectly others (whether by overt action or by failure to inform Mehow) in any manner record, to copy or make derivative works of any portion of the Mehow Materials or any portion of the Event(s)."),

view.el(
["p",144],
null,
"1) In the event that you are discovered in violation of Section b). immediately above, you agree to immediately surrender any and all recording equipment to representatives of Mehow and you hereby waive any and all rights to recover such equipment, or any compeOne(der)tion for it. You understand and agree that your participation in any Event(s) or right to receive any Mehow Materials will be terminated without refund or compeOne(der)tion, but that you are still liable for the full applicable price of any such Event(s) or other rights terminated. "),

view.el(
["p",145],
null,
"c) You agree that any and all Mehow Materials, methodologies, concepts, or any related information, whether mailed, conversed, emailed, otherwise delivered and/or given in-hand, whether before, during and/or after the Event(s), are confidential and you agree you shall treat such as the confidential information and the property of Mehow and will not duplicate, email, forward, distribute, exploit, and/or otherwise used such without the express, prior written consent of Mehow. In preserving the confidentiality of the confidential information, such preservation shall include but is not limited to preventing disclosure to others and not allowing yourself to be filmed using the confidential information (for example demonstrating any methodology without written permission)."),

view.el(
["p",146],
null,
"d) You agree that the information contained in the Mehow Materials delivered and conveyed to you or given to you, whether before, during or after the Event(s) is proprietary and constitutes trade secrets which may not be provided to, divulged, disclosed or otherwise revealed to third parties, directly or indirectly, without the express prior written consent of Mehow ."),

view.el(
["p",147],
null,
"e) You agree that you will not directly or indirectly acquire any interest in, or design, create, manufacture, sell or otherwise deal with any item or product containing, based upon or derived in any way from the Mehow Materials and/or anything you learn, observe, or do while a participant in or in conjunction with the Event(s), including but not limited to any post Event consultation or communication/observation with Mehow or in your interactions with those representing Mehow and those identified as being representatives of Mehow."),

view.el(
["p",148],
null,
"f) Sections c), d), and e) of this Part V. shall be interpreted as covering the whole of the interactions at Mehow programs, and such are part of the Mehow Materials and/or Event(s). The “Events” also includes, but is not limited to:"),

view.el(
["p",149],
null,
"1) Formal instructions by Mehow and its representatives "),

view.el(
["p",150],
null,
"2) All interactions, whether observed or participated in, involving Mehow and its representatives."),

view.el(
["p",151],
null,
"3) All interactions between any participants (students, instructors, observers) whether formal or otherwise, whether directly observed or otherwise, during an Event."),

view.el(
["p",152],
null,
"g) You agree you will not reveal the names of the other attendees of the Event (such as attendees at Events of Mehow), or any identifying information regarding any such attendees to any third persons or parties."),

view.el(
["p",153],
null,
"h) You represent that you are not a member of, an employee of, or an independent contractor to any news media, newspaper or magazine or other print publication or any other news organization, and/or news program, print or otherwise, or any radio station or other media related entity. You represent that you are not an employee of or an independent contractor to any television program or television production company. You agree that if you fall into any or all of these aforementioned categories, you will immediately identify yourself as such to Mehow, in writing, prior to the start of the Event."),

view.el(
["p",154],
null,
"i) You agree that any dispute concerning the foregoing, if requested by Mehow, shall be submitted to binding arbitration before the Judicial Arbitration Mediation Service, in the State of California, applying California law, with the costs thereof to be equally paid by the parties to any such lawsuit during the pendency of the same, however the prevailing party shall be entitled to all costs and attorney fees. However, for the purposes of seeking an injunction, you, in addition, agree that Mehow may seek equitable relief (e.g. temporary restraining order or injunction) without the necessity of posting a bond, prior to, during, or after the conclusion of any arbitration and may seek a court order to enforce an arbitration award."),

view.el(
["p",155],
null,
"j) You acknowledge that your involvement in any Event(s) is granted at the sole discretion of Mehow and your agreement to the terms specified in this agreement as well as any other terms which may be communicated, orally or in writing, by Mehow are required for and a condition of any such involvement by you."),

view.el(
["p",156],
null,
"k) You agree that the spirit of participation in the Event(s) must be open-minded, positive, respectful, and constructive at all times, and you further agree that Mehow may, in its discretion, set rules and regulations that you agree to follow to further such purposes. "),

view.el(
["p",157],
null,
"l) You are to give your full and undivided attention and cooperation to Mehow throughout the Event(s). You further agree to perform all of the exercises given to you by Mehow throughout the duration of the Event(s)."),

view.el(
["p",158],
null,
"m) Mindful of the Event(s) curriculum and content and having had sufficient opportunity to ask any questions about the same, you represent and warrant that you are mentally fit and physically able to participate in the Event. You represent and warrant that you are at least 18 years old. You represent and warrant represent that any inaccurate statement or information provided by you in order to participate in the Event(s) has been corrected by you in writing and provided to Mehow prior to the receipt of the Mehow Materials or the start of any Event(s). As such, you further represent that you have made no material misrepresentations to Mehow."),

view.el(
["p",159],
null,
"n) You further understand that Mehow does not provide any warranty or guarantee with respect to the degree or nature of any improvements achieved by me as a result of the Event. You certify unequivocally that it is your understanding and agreement that it is your responsibility, commitment and true investment of time and personal resources that will be the critical determinants of the degree and nature of the results you achieve. "),

view.el(
["p",160],
null,
"o) You agree that you are solely responsible for your actions and the consequences of your actions. You acknowledge and agree that Mehow and its representatives, assignees, etc., are not responsible for your potential misuse or inappropriate use of the Mehow Materials by you or by other participants in the Event(s). You agree to indemnify Mehow and its representatives, assignees, from any claims made against them due to any breach or alleged breach of this agreement or of any representation or warranty provided by me pursuant to this Agreement. You acknowledge and agree that Mehow does not teach or endorse any illegal activities or any action that could give rise to civil or criminal liability. In the case of any apparent conflict between the preceding sentence and Mehow Materials and Event(s), you will promptly inform Mehow of such with specificity and agree not to use such. You specifically agree not to violate law or infringe on the rights of any party using the Mehow Materials or other any aspect of the Event(s), including, but is not limited to, sexual assault and similar crimes. You agree that you waive any claim against Mehow, its representatives or assignees resulting from the actions or inactions of third parties."),

view.el(
["p",161],
null,
"p) You AGREE THAT UNDER NO CIRCUMSTANCES WILL Mehow, his representatives or assignees BE LIABLE FOR ANY SPECIAL OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE MEHOW MATERIALS or any aspect of the Event(s), EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. APPLICABLE LAW MAY NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY. IN NO EVENT SHALL THE TOTAL LIABILITY to you of Mehow, its representatives or assignees, FOR Any DAMAGES, LOSSES, AND/or CAUSES OF ACTION (WHETHER IN CONTRACT, TORT, OR OTHERWISE) EXCEED THE AMOUNT PAID BY you for the Event(s)."),

view.el(
["p",162],
null,
"q) You agree to waive the provisions of Section 1542 of the Civil Code of the State of California, which provides as follows: "),

view.el(
["p",163],
null,
"A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR. "),

view.el(
["p",164],
null,
"You understand that section 1542 gives you the right not to release existing claims of which you are not now aware, unless you voluntarily chose to waive this right. Having been so apprised, you nevertheless hereby voluntarily elect to, and do waive the rights described in section 1542, and elect to assume all risks for claims that now exist in your favor, known or unknown, from the subject of this Agreement. You acknowledge that you have had the opportunity to consult with legal counsel of my own choosing and to have the terms of this Agreement fully explained to you; that you are not executing this Agreement in reliance on any promises, representations or inducements other than those contained herein; and that you are still participating in the Events knowing that doing so binds you to the terms of this Part V. You agree that you do so voluntarily, free of any duress or coercion."),

view.el(
["p",165],
null,
"r) Phone Coaching Only: We reserve the right to waive refunds and cease service if a failure to attend up to two or more scheduled appointments occurs without notification up to 12 hours before the scheduled call time.")));});



view.render(function(){
return view.el(["Footer",1],null);});});});})();




//# sourceMappingURL=termsPage.js.map

(function(){
Flint.file("views/pages/tsaPage.js",function(require){
Flint.staticStyles("TsaPage",{
"$tsa":"#_flintapp tsa.TsaPage, #_flintapp .TsaPage.tsa, #_flintapp .ViewTsaPage.tsa, #_flintapp .TsaPage > .tsa",
"$topSection":"#_flintapp topSection.TsaPage, #_flintapp .TsaPage.topSection, #_flintapp .ViewTsaPage.topSection, #_flintapp .TsaPage > .topSection",
"$tsaBookLink":"#_flintapp tsaBookLink.TsaPage, #_flintapp .TsaPage.tsaBookLink, #_flintapp .ViewTsaPage.tsaBookLink, #_flintapp .TsaPage > .tsaBookLink",
"$tsaBookImg":"#_flintapp tsaBookImg.TsaPage, #_flintapp .TsaPage.tsaBookImg, #_flintapp .ViewTsaPage.tsaBookImg, #_flintapp .TsaPage > .tsaBookImg",
"$mainPitch":"#_flintapp mainPitch.TsaPage, #_flintapp .TsaPage.mainPitch, #_flintapp .ViewTsaPage.mainPitch, #_flintapp .TsaPage > .mainPitch",
"$headline":"#_flintapp headline.TsaPage, #_flintapp .TsaPage.headline, #_flintapp .ViewTsaPage.headline, #_flintapp .TsaPage > .headline",
"$bullets":"#_flintapp bullets.TsaPage, #_flintapp .TsaPage.bullets, #_flintapp .ViewTsaPage.bullets, #_flintapp .TsaPage > .bullets",
"$bullet":"#_flintapp bullet.TsaPage, #_flintapp .TsaPage.bullet, #_flintapp .ViewTsaPage.bullet, #_flintapp .TsaPage > .bullet",
"$goButton":"#_flintapp goButton.TsaPage, #_flintapp .TsaPage.goButton, #_flintapp .ViewTsaPage.goButton, #_flintapp .TsaPage > .goButton",
"$bonusSection":"#_flintapp bonusSection.TsaPage, #_flintapp .TsaPage.bonusSection, #_flintapp .ViewTsaPage.bonusSection, #_flintapp .TsaPage > .bonusSection",
"$bonusHeadline":"#_flintapp bonusHeadline.TsaPage, #_flintapp .TsaPage.bonusHeadline, #_flintapp .ViewTsaPage.bonusHeadline, #_flintapp .TsaPage > .bonusHeadline",
"$bonusModules":"#_flintapp bonusModules.TsaPage, #_flintapp .TsaPage.bonusModules, #_flintapp .ViewTsaPage.bonusModules, #_flintapp .TsaPage > .bonusModules",
"$testimonials":"#_flintapp testimonials.TsaPage, #_flintapp .TsaPage.testimonials, #_flintapp .ViewTsaPage.testimonials, #_flintapp .TsaPage > .testimonials",
"$Testimonial":"#_flintapp .ViewTsaPage .ViewTestimonial"},
{
"$tsa":{
padding:[60,60,0]},

"$topSection":{},
"$tsaBookLink":{
flexShrink:0,
position:'relative',
top:-7},

"$tsaBookImg":{},
"$mainPitch":{
alignItems:'center',
textAlign:'center'},

"$headline":{
marginTop:8,

fontWeight:'bold',
color:'white'},

"$bullets":{
marginTop:10},

"$bullet":{
color:'white',
display:'inline',

fontWeight:'bold',
marginBottom:20},

"$goButton":{
border:'outset rgb(215, 154, 70)',

fontWeight:'bold',
display:'inline-flex',
alignItems:'center',
justifyContent:'center',
verticalAlign:'middle',
cursor:'pointer',
color:'black'},

"$bonusSection":{
alignSelf:'stretch',
alignItems:'center'},

"$bonusHeadline":{
marginTop:0,

fontWeight:'bold',
color:'white'},

"$bonusModules":{
width:300,

marginTop:20},

"$testimonials":{
alignSelf:'stretch',
alignItems:'flex-end',
justifyContent:'space-between',
marginTop:64,
marginBottom:16},

"$Testimonial":{
marginBottom:24}});


Flint.view("TsaPage",function(view,on,$){
var context=initContext(view,{
width:atom(),
isMobile:atom()});


on.mount(function(){
M.mixpanel.track("PageView",{page:'3sa'});});
view.render(function(){
return view.el(["NavBar",1],null);});
view.render(function(){
return view.el(
["tsa",1],
null,
view.el(
["topSection",1],
null,
view.el(
["Link",1],
{className:"tsaBookLink",
to:"http://threesecondattraction.com",
target:"_blank"},

view.el(["img",1],{className:"tsaBookImg",src:"/images/3sa-book.png"})),

view.el(
["mainPitch",1],
null,
view.el(
["headline",1],
null,
"The proven system for being naturally charming with women"),

view.el(
["bullets",1],
null,
view.el(
["bullet",1],
null,
"Step-by-step guide to being an amazing conversationalist"),

view.el(
["bullet",2],
null,
"The one trick for ",
view.el(
["b",1],
null,
"fun"),

" and ",
view.el(
["b",2],
null,
"natural "),

"interactions with women"),

view.el(
["bullet",3],
null,
"Increase romantic interactions everywhere in your life")),


view.el(
["Link",2],
{className:"goButton",
to:"http://threesecondattraction.com",
target:"_blank"},

"Get started"))),



view.el(
["bonusSection",1],
null,
view.el(
["bonusHeadline",1],
null,
"Includes 12 bonus modules!"),

view.el(["img",2],{className:"bonusModules",src:"/images/3sa-bonus-modules.png"})),

view.el(
["testimonials",1],
null,
view.el(
["Testimonial",1],
{
name:"Gordy P",
location:"Tempe, AZ",
picUrl:"/images/testimonials/gordy-p.png"},

"I thought I was too old to flirt with girls younger than 40... yesterday I got a date with a 27 year old model. This is fishing with dynamite!"),

view.el(
["Testimonial",2],
{
name:"Andrew L",
location:"Dayton, OH",
picUrl:"/images/testimonials/andrew-l.png"},

"I thought this approach was BS until I tried it. It lands like an atom bomb! I’m nothing to look at, but with the 3 second secret, it’s ON."),

view.el(
["Testimonial",3],
{
name:"Cuvel T",
location:"Toronto, Canada",
picUrl:"/images/testimonials/cuvel-t.png"},

"Why you didn’t call this method your Stealth P***y Getting System, I’ll never know. But that’s exactly what it is.")));});



view.render(function(){
return view.el(["Footer",1],null);});


"732f13c1";

$["tsa"] = function(_,_index){
return {
width:context.width.get(),
background:'linear-gradient(to bottom, ' + 'rgb(157, 25, 38) 0%, rgb(254, 61, 80) 100%)',marginBottom:context.isMobile.get()?20:50,
borderRadius:context.isMobile.get()?0:12};};



$["topSection"] = function(_,_index){
return {
flexDirection:context.isMobile.get()?'column':'row'};};



"2c8a1e71";

$["tsaBookLink"] = function(_,_index){
return {alignSelf:context.isMobile.get()?'center':null};};



$["tsaBookImg"] = function(_,_index){
return {
width:Math.max(200,.28 * context.width.get()),
height:1086 / 610 * Math.max(200,.28 * context.width.get())};};



"671200a6";

$["mainPitch"] = function(_,_index){
return {
marginLeft:context.isMobile.get()?0:30};};


"e4410de4";

$["headline"] = function(_,_index){
return {fontSize:Math.max(18,.037 * context.width.get()),marginBottom:.028 * context.width.get()};};



"650ac038";
"0ee4a846";

$["bullet"] = function(_,_index){
return {fontSize:Math.max(13,.02 * context.width.get())};};


"1e756083";

$["goButton"] = function(_,_index){
return {
marginTop:.03 * context.width.get(),
marginBottom:.08 * context.width.get(),
width:.4 * context.width.get(),
height:.1 * context.width.get(),
background:'linear-gradient(to bottom, ' + 'rgb(255, 227, 61) 0%, rgb(255, 182, 46) 100%)',borderWidth:.012 * context.width.get(),
borderRadius:.15 * context.width.get(),
fontSize:Math.max(12,.023 * context.width.get())};};


"79d11dcc";
"2f474bce";

$["bonusHeadline"] = function(_,_index){
return {fontSize:Math.max(16,.025 * context.width.get())};};


"e75221d6";

$["bonusModules"] = function(_,_index){
return {height:324 / 684 * 300};};


"8c8ab2b4";

$["testimonials"] = function(_,_index){
return {
flexDirection:context.isMobile.get()?'column':'row'};};


"1d621998";

$["Testimonial"] = function(_,_index){
return {
width:context.isMobile.get()?null:(context.width.get() - 160) / 3};};});});})();




//# sourceMappingURL=tsaPage.js.map

(function(){
Flint.file('views/pages/womensResiPage.js',function(require){
Flint.staticStyles('WomensResiPage',{
'$resiPage':'#_flintapp resiPage.WomensResiPage, #_flintapp .WomensResiPage.resiPage, #_flintapp .ViewWomensResiPage.resiPage, #_flintapp .WomensResiPage > .resiPage',
'$resiFormHeader':'#_flintapp resiFormHeader.WomensResiPage, #_flintapp .WomensResiPage.resiFormHeader, #_flintapp .ViewWomensResiPage.resiFormHeader, #_flintapp .WomensResiPage > .resiFormHeader',
'$resiForm':'#_flintapp resiForm.WomensResiPage, #_flintapp .WomensResiPage.resiForm, #_flintapp .ViewWomensResiPage.resiForm, #_flintapp .WomensResiPage > .resiForm',
'$submittedSec':'#_flintapp submittedSec.WomensResiPage, #_flintapp .WomensResiPage.submittedSec, #_flintapp .ViewWomensResiPage.submittedSec, #_flintapp .WomensResiPage > .submittedSec',
'$header':'#_flintapp header.WomensResiPage, #_flintapp .WomensResiPage.header, #_flintapp .ViewWomensResiPage.header, #_flintapp .WomensResiPage > .header',
'$ff':'#_flintapp ff.WomensResiPage, #_flintapp .WomensResiPage.ff, #_flintapp .ViewWomensResiPage.ff, #_flintapp .WomensResiPage > .ff',
'$label':'#_flintapp label.WomensResiPage, #_flintapp .WomensResiPage.label, #_flintapp .ViewWomensResiPage.label, #_flintapp .WomensResiPage > .label',
'$row':'#_flintapp row.WomensResiPage, #_flintapp .WomensResiPage.row, #_flintapp .ViewWomensResiPage.row, #_flintapp .WomensResiPage > .row',
'$goButton':'#_flintapp goButton.WomensResiPage, #_flintapp .WomensResiPage.goButton, #_flintapp .ViewWomensResiPage.goButton, #_flintapp .WomensResiPage > .goButton',
'$pleaseFix':'#_flintapp pleaseFix.WomensResiPage, #_flintapp .WomensResiPage.pleaseFix, #_flintapp .ViewWomensResiPage.pleaseFix, #_flintapp .WomensResiPage > .pleaseFix'},
{
'$resiPage':{
padding:[0,24],
marginTop:30,
marginBottom:100},

'$resiFormHeader':{
marginTop:30,
color:'rgb(154, 103, 113)',

fontWeight:'bold',
marginBottom:20},

'$resiForm':{
alignItems:'stretch'},

'$submittedSec':{
color:'green',
fontWeight:'bold'},

'$header':{
color:'rgb(154, 103, 113)',

fontWeight:'bold',
marginBottom:20},

'$ff':{
marginBottom:20,
marginRight:14},

'$label':{
fontSize:14},

'$row':{
flexGrow:1,
flexDirection:'row',
alignItems:'stretch'},

'$goButton':{
marginTop:20,

height:80,

border:'8px outset rgb(0, 154, 70)',
borderRadius:16,
fontSize:24,
fontWeight:'bold',
display:'inline-flex',
alignItems:'center',
justifyContent:'center',
verticalAlign:'middle',
cursor:'pointer',
color:'black'},

'$pleaseFix':{
marginTop:4,
color:'red',
fontWeight:'bold'}});


Flint.view('WomensResiPage',function(view,on,$){
var context=initContext(view,{
width:atom()});


var fields=atom(M.records.ResiApp({
gender:'female'}));

var highlightingMissingFields=atom(false);
var submitting=atom(false);
var submitted=atom(false);

var ff=function ff(fieldName,label,placeholder,inpStyle){
var highlight=highlightingMissingFields.get() && fields.get().get(fieldName) == null;

return view.el(
['label',1],
{className:'ff',key:fieldName},
label,
view.el(['TextBox',1],{
placeholder:placeholder,
value:fields.derive(fieldName),
onChange:function(e){
return fields.set(fields.get().set(fieldName,e.value || null));},

inpStyle:IMap({
marginTop:4,
fontSize:context.isMobile.get()?14:18,
alignSelf:'stretch',
border:highlight?'1px solid red':'1px solid #ccc'}).
merge(inpStyle)}));};




var submit=function submit(){
if(submitting.get())return;

highlightingMissingFields.set(false);

var hasMissingField=false;
fields.get().forEach(function(value,fieldName){
if(value == null){
hasMissingField = true;
return false;}});


if(hasMissingField){
highlightingMissingFields.set(true);
return;}


submitting.set(true);
M.apiPost('submitResiApp',{
params:fields.get().toJS()}).
then(function(){
submitting.set(false);
submitted.set(true);},
function(err){
submitting.set(false);
M.util.alertError(err);});};



on.mount(function(){
M.mixpanel.track("PageView",{page:'womensResi'});});
view.render(function(){
return view.el(['NavBar',1],null);});
view.render(function(){
return view.el(
['resiPage',1],
null,
view.el(
['header',1],
null,
'Women\'s Residential Weekend Application'),

view.el(['WomensResiCopy',1],{
style:{
width:context.width.get() - 48}}),


view.el(
['resiFormHeader',1],
null,
'Application for residential training'),

Flint.iff(submitted.get()) && view.el(
['submittedSec',1],
{if:submitted.get()},
view.el(
['span',1],
null,
'Thanks for applying, ',
fields.get().firstName,
'! We\'ll get back to you within 2 business days.')),


Flint.iff(!submitted.get()) && view.el(
['resiForm',1],
{if:!submitted.get()},
view.el(
['row',1],
null,
ff('firstName',null,"First name"),
ff('lastName',null,"Last name")),

view.el(
['row',2],
null,
ff('city',null,"City"),
ff('state',null,"State",{width:100})),

ff('phone',"Phone","(###) ###-####"),
ff('email',"Email","john@example.com"),
ff('freeTime',"How much free time do you have to make this happen?","Time to devote..."),
ff('anxiety',"How anxious do you feel meeting women?","Anxiety..."),
ff('whyInterested',"Why are you interested in getting this area of your life handled?","Reason for interest..."),
ff('formalTraining',"Have you ever had a dating coach or training in pickup?","Prior formal training..."),
view.el(
['ff',1],
null,
view.el(
['label',2],
{style:highlightingMissingFields.get() && fields.get().wouldTravel == null?{color:'red',fontWeight:'bold'}:null},
'Would you travel to LA to get the best training in the world?'),

view.el(['OptionsPicker',1],{
options:[{
label:"Yes",
value:true},
{
label:"No",
value:false}],

limit:1,
onChange:function(e){
fields.set(fields.get().set('wouldTravel',e.selectedValues.get(0)));}})),



ff('howMuchWorth',"How much do you think (dollar amount) mastering this skillset is worth?" + " (Please put a realistic amount):","Reasonable estimate of program value..."),
view.el(
['goButton',1],
{onClick:submit},
Flint.iff(!submitting.get()) && view.el(
['submitText',1],
{if:!submitting.get()},
'Submit Application'),

Flint.iff(submitting.get()) && view.el(['Loader',1],{if:submitting.get()})),

Flint.iff(highlightingMissingFields.get()) && view.el(
['pleaseFix',1],
{if:highlightingMissingFields.get()},
'Please fix the missing fields.')));});



view.render(function(){
return view.el(['Footer',1],null);});


$["resiFormHeader"] = function(_,_index){
return {fontSize:Math.max(14,0.035 * context.width.get())};};


$["resiForm"] = function(_,_index){
return {
width:Math.min(500,context.width.get() - 48)};};


$["header"] = function(_,_index){
return {fontSize:Math.max(20,0.035 * context.width.get())};};


$["goButton"] = function(_,_index){
return {width:Math.min(300,context.width.get() - 48),background:'linear-gradient(to bottom, ' + 'rgb(0, 227, 61) 0%, rgb(0, 182, 46) 100%)'};};});});})();




//# sourceMappingURL=womensResiPage.js.map

(function(){
Flint.file("views/prmenu.js",function(require){
Flint.staticStyles("PRMenu",{
"$hoverTarget":"#_flintapp hoverTarget.PRMenu, #_flintapp .PRMenu.hoverTarget, #_flintapp .ViewPRMenu.hoverTarget, #_flintapp .PRMenu > .hoverTarget",
"$titleRow":"#_flintapp titleRow.PRMenu, #_flintapp .PRMenu.titleRow, #_flintapp .ViewPRMenu.titleRow, #_flintapp .PRMenu > .titleRow",
"$expander":"#_flintapp expander.PRMenu, #_flintapp .PRMenu.expander, #_flintapp .ViewPRMenu.expander, #_flintapp .PRMenu > .expander",
"$hoverBridge":"#_flintapp hoverBridge.PRMenu, #_flintapp .PRMenu.hoverBridge, #_flintapp .ViewPRMenu.hoverBridge, #_flintapp .PRMenu > .hoverBridge",
"$menuOptions":"#_flintapp menuOptions.PRMenu, #_flintapp .PRMenu.menuOptions, #_flintapp .ViewPRMenu.menuOptions, #_flintapp .PRMenu > .menuOptions",
"$menuOption":"#_flintapp menuOption.PRMenu, #_flintapp .PRMenu.menuOption, #_flintapp .ViewPRMenu.menuOption, #_flintapp .PRMenu > .menuOption"},
{
"$hoverTarget":{
position:'relative'},

"$titleRow":{
flexDirection:'row',
alignItems:'center',
cursor:'pointer'},

"$expander":{
width:24,
height:24},

"$hoverBridge":{
position:'absolute',
paddingTop:4,
zIndex:10},

"$menuOptions":{
flexGrow:1,
alignItems:'stretch',
background:'white',
border:'1px solid #ddd',
paddingTop:6,
paddingBottom:6},

"$menuOption":{
alignSelf:'stretch',
padding:[6,12],

whiteSpace:'nowrap'}});


Flint.view("PRMenu",function(view,on,$){
var pro=initPro(view,{
title:atom(),
options:M.listAtom(),
style:M.mergeAtom({
menuWrapper:{}})});



var showingMenu=atom(false);
var hoveringIndex=atom(null);

showingMenu.react(function(showingMenu){
if(showingMenu){
M.mixpanel.track('NavMenuHover',{title:pro.title.get()});}});

view.render(function(){
return view.el(
["hoverTarget",1],
{
onMouseEnter:function(){
return showingMenu.set(true);},

onMouseLeave:function(){
return showingMenu.set(false);}},


view.el(
["titleRow",1],
null,
view.el(
["titleSection",1],
null,
pro.title.get()),

view.el(["img",1],{className:"expander",src:"/images/triangleDown.png"})),

Flint.iff(showingMenu.get()) && view.el(
["hoverBridge",1],
{if:showingMenu.get(),
style:pro.style.get().get('menuWrapper').toJS()},

view.el(
["menuOptions",1],
null,
Flint.range(pro.options.get()).map(function(_,_index){
return view.el(
["NavLink",1,_,_index],
{repeat:pro.options.get(),
to:_.url,
target:_.target,
style:{
alignSelf:'stretch',
alignItems:'stretch'}},


view.el(
["menuOption",1,_,_index],
{
onMouseEnter:function(){
return hoveringIndex.set(_index);},

onMouseLeave:function(){
return hoveringIndex.set(null);}},


_.label));}))));});








$["menuOption"] = function(_,_index){
return {background:hoveringIndex.get() == _index?'#f6f6f6':null};};});});})();




//# sourceMappingURL=prmenu.js.map

(function(){
Flint.file("views/testimonial.js",function(require){
Flint.staticStyles("Testimonial",{
"$quoteBody":"#_flintapp quoteBody.Testimonial, #_flintapp .Testimonial.quoteBody, #_flintapp .ViewTestimonial.quoteBody, #_flintapp .Testimonial > .quoteBody",
"$quoteSec":"#_flintapp quoteSec.Testimonial, #_flintapp .Testimonial.quoteSec, #_flintapp .ViewTestimonial.quoteSec, #_flintapp .Testimonial > .quoteSec",
"$personSec":"#_flintapp personSec.Testimonial, #_flintapp .Testimonial.personSec, #_flintapp .ViewTestimonial.personSec, #_flintapp .Testimonial > .personSec",
"$personPic":"#_flintapp personPic.Testimonial, #_flintapp .Testimonial.personPic, #_flintapp .ViewTestimonial.personPic, #_flintapp .Testimonial > .personPic",
"$personDetails":"#_flintapp personDetails.Testimonial, #_flintapp .Testimonial.personDetails, #_flintapp .ViewTestimonial.personDetails, #_flintapp .Testimonial > .personDetails"},
{
"$quoteBody":{
background:'white',
borderRadius:8,
padding:20,
fontWeight:'bold'},

"$quoteSec":{
zIndex:1},

"$personSec":{
flexDirection:'row',
alignItems:'center',
position:'relative',
top:-10},

"$personPic":{
width:70,
height:70,
borderRadius:'50%',
marginRight:16},

"$personDetails":{
color:'white',
fontWeight:'bold'}});


Flint.view("Testimonial",function(view,on,$){
var pro=initPro(view,{
children:atom(),
name:atom(),
location:atom(),
picUrl:atom()});
view.render(function(){
return view.el(
["quoteSec",1],
null,
view.el(
["quoteBody",1],
null,
pro.children.get()),

view.el(["Triangle",1],{className:"quoteTriangle",pointAngle:"down",style:{
width:14,
height:20,
marginLeft:22,
color:'white'}}));});


view.render(function(){
return view.el(
["personSec",1],
null,
view.el(["img",1],{className:"personPic",src:pro.picUrl.get()}),
view.el(
["personDetails",1],
null,
view.el(
["personName",1],
null,
pro.name.get()),

view.el(
["personLoc",1],
null,
pro.location.get())));});





"1ed666d9";
"83926c3a";
"166e03c4";
"f45c108a";
"42ba485b";});});})();



//# sourceMappingURL=testimonial.js.map

var _interopRequireDefault=require('babel-runtime/helpers/interop-require-default').default;

(function(){
Flint.file('views/textingTipsEmbeds.js',function(require){
var _data=require('../data');

var _data2=_interopRequireDefault(_data);

Flint.staticStyles('TextingTipsEmbeds',{
'$':'#_flintapp .ViewTextingTipsEmbeds',
'$ttEmbed':'#_flintapp ttEmbed.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.ttEmbed, #_flintapp .ViewTextingTipsEmbeds.ttEmbed, #_flintapp .TextingTipsEmbeds > .ttEmbed',
'$previewSec':'#_flintapp previewSec.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.previewSec, #_flintapp .ViewTextingTipsEmbeds.previewSec, #_flintapp .TextingTipsEmbeds > .previewSec',
'$postTitle':'#_flintapp postTitle.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.postTitle, #_flintapp .ViewTextingTipsEmbeds.postTitle, #_flintapp .TextingTipsEmbeds > .postTitle',
'$timestamp':'#_flintapp timestamp.TextingTipsEmbeds, #_flintapp .TextingTipsEmbeds.timestamp, #_flintapp .ViewTextingTipsEmbeds.timestamp, #_flintapp .TextingTipsEmbeds > .timestamp'},
{
'$':{
flexDirection:'row',
flexGrow:1,
flexWrap:'wrap',
justifyContent:'space-between'},

'$ttEmbed':{},
'$previewSec':{
backgroundRepeat:'no-repeat',
backgroundSize:'cover',
backgroundPosition:'50% 50%',
borderRadius:4},

'$postTitle':{
textAlign:'center',
color:'white',

marginTop:4,
fontWeight:'bold'},

'$timestamp':{
fontSize:10,
color:'#ccc',
alignSelf:'flex-end',
marginRight:4,
marginBottom:2}});


Flint.view('TextingTipsEmbeds',function(view,on,$){
var context=initContext(view,{
isMobile:atom()});


var pro=initPro(view,{
numPosts:M.defaultAtom(4),
style:M.mergeAtom({
width:400})});



var getThumbUrl=function getThumbUrl(post){
if(post.thumbUrl.indexOf('/') == 0){
return 'https://texting.tips' + post.thumbUrl;}else 
{
return post.thumbUrl;}};



var getExternalUrl=function getExternalUrl(post){
if(post.url.indexOf('/') == 0){
return 'https://texting.tips' + post.url;}else 
{
return post.url;}};



var spacing=atom(22);

var embedWidth=derivation(function(){
if(context.isMobile.get()){
return (pro.style.get().get('width') - 3 * spacing.get()) / 2;}else 
{
return (pro.style.get().get('width') - (pro.numPosts.get() + 1) * spacing.get()) / pro.numPosts.get();}});


var embedHeight=embedWidth.derive(function(w){
return w * 9 / 16;});


var posts=_data2.default.textingTipsPosts.toJS();view.render(function(){
return Flint.range(posts.slice(0,pro.numPosts.get())).map(function(_,_index){
return view.el(
['ttEmbed',1,_,_index],
{repeat:posts.slice(0,pro.numPosts.get())},
view.el(
['timestamp',1,_,_index],
null,
M.util.formatMessengerDate(_.timestamp)),

view.el(
['Link',1,_,_index],
{to:getExternalUrl(_),target:'_blank'},
view.el(['previewSec',1,_,_index],null)),

view.el(
['captionSec',1,_,_index],
null,
view.el(
['Link',2,_,_index],
{className:'postTitle',to:getExternalUrl(_),target:'_blank'},
_.title)));});});






$["$"] = function(_,_index){
return {padding:[spacing.get(),spacing.get(),0]};};



$["ttEmbed"] = function(_,_index){
return {
width:embedWidth.get(),
marginBottom:spacing.get()};};



'84a94a6a';

$["previewSec"] = function(_,_index){
return {
width:embedWidth.get(),
height:embedHeight.get(),
backgroundImage:'url(' + getThumbUrl(_) + ')'};};


'01e262f7';

$["postTitle"] = function(_,_index){
return {fontSize:context.isMobile.get()?11:12};};


'7e69ff88';});});})();



//# sourceMappingURL=textingTipsEmbeds.js.map

(function(){
Flint.file('views/womensResiCopy.js',function(require){
Flint.staticStyles('WomensResiCopy',{
'$':'#_flintapp .ViewWomensResiCopy',
'$img':'#_flintapp img.WomensResiCopy, #_flintapp .WomensResiCopy.img, #_flintapp .ViewWomensResiCopy.img, #_flintapp .WomensResiCopy > .img',
'$bigRed':'#_flintapp bigRed.WomensResiCopy, #_flintapp .WomensResiCopy.bigRed, #_flintapp .ViewWomensResiCopy.bigRed, #_flintapp .WomensResiCopy > .bigRed',
'$resiTitle':'#_flintapp resiTitle.WomensResiCopy, #_flintapp .WomensResiCopy.resiTitle, #_flintapp .ViewWomensResiCopy.resiTitle, #_flintapp .WomensResiCopy > .resiTitle',
'$p':'#_flintapp p.WomensResiCopy, #_flintapp .WomensResiCopy.p, #_flintapp .ViewWomensResiCopy.p, #_flintapp .WomensResiCopy > .p',
'$li':'#_flintapp li.WomensResiCopy, #_flintapp .WomensResiCopy.li, #_flintapp .ViewWomensResiCopy.li, #_flintapp .WomensResiCopy > .li'},
{
'$':{
fontFamily:'helvetica neue'},

'$img':{
minHeight:0},

'$bigRed':{
marginTop:20,
marginBottom:20,

fontSize:32},

'$resiTitle':{
display:'inline',
fontStyle:'italic',
fontWeight:'bold'},

'$p':{
lineHeight:1.7,
margin:[0,0,20]},

'$li':{
lineHeight:1.7,
marginBottom:20}});


Flint.view('WomensResiCopy',function(view,on,$){
var context=initContext(view,{
colors:atom(),
width:atom()});

var pro=initPro(view,{});

var copyWidth=derivation(function(){
console.log('width',pro.style.get().get('width'));
return Math.min(500,pro.style.get().get('width'));});
view.render(function(){
return view.el(
['wrapper',1],
null,
view.el(
['p',1],
null,
'First things first, I want to congratulate you on making the smartest decision you could make in your dating life, and giving Enchant Mr. Right™ the chance it deserves. This is going to transform you into the kind of woman that gets (and keeps) the man of her choice.'),

view.el(
['p',2],
null,
'Now here’s a question for you. How would you like to suddenly possess the almost-magical ability to “cast your spell” on any man you talk to… within seconds of meeting him?'),

view.el(
['p',3],
null,
'The reason I ask you this is because many of my best female students are a lot like me. They’re a tad impatient, and they want to get results quickly and easily… without spending months studying a course and then going out and looking for opportunities to practice.'),

view.el(
['bigRed',1],
null,
'And That\'s Why I Know You\'re Going To Love This'),

view.el(
['p',4],
null,
'You see, when it comes to finding and keeping love, you don’t want to waste years trying to get things right. And sure, Enchant Mr. Right™ is going to get you there much more quickly than you would if you were just doing trial-and-error.'),

view.el(
['p',5],
null,
'But what if you didn’t have to do it alone? What if you could actually achieve a year’s worth of results using Enchant Mr. Right™…'),

view.el(
['p',6],
null,
'…in just 2 days?'),

view.el(
['p',7],
null,
'Imagine what it would be like to possess all the skills you need to:'),

view.el(
['ul',1],
null,
view.el(
['li',1],
null,
'Approach any man you want and easily start a conversation with him (instead of waiting around to be approached like all the other girls).'),

view.el(
['li',2],
null,
'Easily keep the conversation going, and enjoy the fact that he’s becoming more and more fascinated by you with each and every minute that goes by.'),

view.el(
['li',3],
null,
'Enjoy the attention of all the highest quality bachelors at any social gathering and leave all the other women wondering what your secret was. You’ll be that one special girl that the men just can’t stop thinking about and wanting to know more about.'),

view.el(
['li',4],
null,
'Never again have to worry about men only wanting you for sex. No more getting friend-zoned or any of those “friends with benefits” relationships unless YOU want them. The men you date are going to be serious about being with you, and ONLY you.'),

view.el(
['li',5],
null,
'Bask in the glow of his intense love for you, and secretly giggle when he tries to convince you to be in a monogamous relationship. You’ll look back and wonder why getting a man to commit was ever a struggle now that you’ve got these tools.')),


view.el(
['bigRed',2],
null,
'Let Me Personally Help You Achieve All Of This In Just 2 Amazing Days'),

view.el(['img',1],{src:'/images/womensresi/1.jpg'}),
view.el(
['p',8],
null,
'I’ve spent more than 10 years studying attraction and relationships… and coaching people how to interact with the opposite sex in every type of environment. The men and women who have come and trained with me here in Hollywood have completely transformed their lives, and the results they’re getting back in their hometowns is astounding to everyone else around them.'),

view.el(
['p',9],
null,
'Why does live training work so well? It’s pretty simple. The reason I’m so good at what I do is because I’ve literally interacted with tens of thousands of women. I’ve made every possible mistake, learned from it, refined my theories, and now I’ve literally got this thing down to a science.'),

view.el(
['p',10],
null,
'Here’s what that means for you: It means that when you and I go out and socialize together, I’ll be able to instantly pick out what you’re doing right and what needs adjusting. This is the kind of real world, instant feedback that NOBODY can ever give you.'),

view.el(
['p',11],
null,
'Why? Because they simply aren’t qualified to give that feedback because they lack the experience and don’t have the “trained eye” that me and my coaches do. Also, they simply don’t know how to give that kind of feedback in a way that feels good and encourages you to try something new.'),

view.el(
['p',12],
null,
'The men you’ve been dating would rather just leave and disappear without ever telling you the REAL reason why they left. That sucks! I always hated it when that happened to me, and so I committed myself to making sure that doesn’t happen to anyone ever again.'),

view.el(
['p',13],
null,
'Here’s how I’m going to help you with all of this:'),

view.el(
['bigRed',3],
null,
'Introducing...'),

view.el(
['p',14],
null,
view.el(
['resiTitle',1],
null,
'The Enchant Mr. Right™ Weekend'),

' – A 2-Day Immersion Experience That Completely Transforms The Way You Interact With Men, And Empowers You To Finally Get The Result You Want In Relationships!'),

view.el(
['p',15],
null,
'This isn’t some watered-down, motivational weekend seminar. In fact, there is nothing like this for women on the face of the earth. Here’s how it works:'),

view.el(
['p',16],
null,
'You’ll arrive Saturday morning and meet the instructors. First, we’ll take the time to get to know you better and discuss where you feel stuck with men and what kind of results you want. This is important, because my instructors want to get you the best possible results during this weekend, so we like to get to know you before we begin.'),

view.el(
['p',17],
null,
'Then we jump straight into a semi-private seminar for you and the other Enchant Mr. Right™ students. This is where we pull back the curtains and reveal our top-secret methods for talking to men in a way that stimulates them emotionally. This is THE most crucial skill to have, and we make sure you really get it.'),

view.el(
['p',18],
null,
'Then we dive into a series of fun drills, exercises, and games to help “install” the skills into your brain so they become automatic. It’s important to drill these skills first so that you can just relax and enjoy yourself when you practice out in the real world.'),

view.el(['img',2],{src:'/images/womensresi/2.jpg'}),
view.el(
['p',19],
null,
'For example, you\'ll learn things like:'),

view.el(
['ul',2],
null,
view.el(
['li',6],
null,
'Word-for-word - EXACTLY what to say to a man when you want to start a conversation. And the best part? He’ll think he’s the one who started talking to you!'),

view.el(
['li',7],
null,
'Simple exercises to train your brain to keep the conversation going without strain, struggle, or effort. After day 1, you’ll wonder why this ever felt hard for you in the past.'),

view.el(
['li',8],
null,
'How to flirt with him without coming across as too aggressive or “try hard”. In fact, the more you use our flirting techniques, the more intrigued he’ll become with you and the harder he’ll work to get you.'),

view.el(
['li',9],
null,
'How to instantly “delete” the fear of rejection so you can just go out and have a blast without any fear or anxiety getting in your way.'),

view.el(
['li',10],
null,
'What to say when you want to deflect his sexual advances (for now), but also keep him interested in you. This one technique will give you the confidence to know that he’ll still be into you even if sex doesn’t happen quickly (this has been a welcome relief for so many women).'),

view.el(
['li',11],
null,
'And so much more! The bottom line is that you’ll learn how to handle just about every situation that comes up with the grace and ease of a desirable, confident woman that any man would kill to be with.')),


view.el(
['p',20],
null,
'And that’s actually the next part of Saturday. We go out to one of the hottest and most fun social venues in the Hollywood area and practice talking to guys in this new way. You are going to LOVE this part. The place we take our students is overflowing with friendly, interesting, and attractive people, and I promise you’ll have the time of your life.'),

view.el(
['p',21],
null,
'This is where those drills we did earlier that day will come into play. You’ll be shocked as you hear yourself saying and doing the right things all night long. You’ll be flirting, smiling, and having a great time as you surprise yourself with how witty and charming you’ve become.'),

view.el(
['bigRed',4],
null,
'And That’s Just The First Day!'),

view.el(
['p',22],
null,
'Once we begin on Sunday, we’ll debrief what happened the day before. We’ll share stories and high five each other for a job well done (and also learn from our mistakes, of course). But the learning isn’t over yet. We dive straight into the second seminar where you’ll learn all about having relationships using the Enchant Mr. Right™  techniques.'),

view.el(['img',3],{src:'/images/womensresi/3.jpg'}),
view.el(
['p',23],
null,
'There are 5 main components to Sunday’s seminar, and they are:'),

view.el(
['p',24],
null,
view.el(
['b',1],
null,
'Part 1 - Communication'),

' - You’ll discover our 2 biggest secrets to compassionate communication. This is the foundation for having a fulfilling relationship that meets both your needs and gives you the love you really want.'),

view.el(
['p',25],
null,
view.el(
['b',2],
null,
'Part 2 - Personality Type'),

' - There are 3 main personality typing systems we endorse, and you’ll learn how to see yourself through each one. This is by far the fastest method of self-discovery there is. Prepare to have your eyes open and to be surprised at just how amazing you are. You’ll discover how to play to your strengths and overcome any old weaknesses that are inherent to your type. This part of the seminar is a LOT of fun!'),

view.el(
['p',26],
null,
view.el(
['b',3],
null,
'Part 3 - World View'),

' - Even the best communication techniques cannot overcome fundamental differences in worldview. We’ll show you how to quickly discover your own world view according to our system, and then also discover his so you can test for true compatibility. This is where the rubber meets the road. You’ll learn how to find out if you’re actually compatible with him, rather than just hoping you are.'),

view.el(
['p',27],
null,
view.el(
['b',4],
null,
'Part 4 - Stages Of Relationship Growth'),

' - We’ll provide you with an complete and easy-to-follow map of what every couple goes through while getting closer. What’s great about this is that once you understand the predictable process of bonding, you’ll be ready for any challenges that come up and work through them easily.'),

view.el(
['p',28],
null,
view.el(
['b',5],
null,
'Part 5 - Sex'),

' - This is the cherry on top of your amazing weekend experience with us. We’ll reveal some of the most powerful techniques for connecting sexually with a man. We draw from many disciplines including tantra to teach you to trigger deep, sexual polarity in your man. Once you start using our techniques, he won’t be able to resist you… now or ever. He will be yours and you will be his… deeply connected and enjoying a lifetime of pleasure.'),

view.el(
['p',29],
null,
'So now you know why...'),

view.el(
['bigRed',5],
null,
'This Is The Fastest Possible Way To Get Good Mind-Blowing Results With Men!'),

view.el(
['p',30],
null,
'Listen, I want to emphasize something. You made a wise decision by investing in Enchant Mr. Right™. This is the best self-study program for women on how to captivate and keep the kind of man you really want and deserve.'),

view.el(
['p',31],
null,
'But I want to emphasize something else as well. It’s a SELF-study program, which means you’re on your own, and it’s up to you to get the results you want. If you want faster results (MUCH faster), than the absolute best way to get them is to come to one of our intensive weekends.'),

view.el(
['p',32],
null,
'There’s no other way on earth to make progress happen this quickly. Our coaches are specially trained to quickly catch the most common mistakes women make when talking to men and gently correct them on the spot!  What if there was one tiny bad habit that you never realized you were doing… and that bad habit was what kept causing men to not give you the level of love and commitment you deserve?'),

view.el(['img',4],{src:'/images/womensresi/4.jpg'}),
view.el(
['p',33],
null,
'And what if we could knock any and all bad habits out during your time with us? How would that change your life and your luck with the opposite sex? Listen, I’ve been doing this for over 10 years, and I’ve seen people’s lives completely shift in the area of love and relationships all because I fixed one or two simple things in how they were communicating.'),

view.el(
['p',34],
null,
'In other words… the instant, personal feedback you get is priceless!'),

view.el(
['bigRed',6],
null,
'So How Much Does The Spellbound Weekend Cost?'),

view.el(
['p',35],
null,
'To be completely honest with you… in the end it really doesn’t cost anything, and here’s why. Think of all those nights you’ve gone out, paid cover charges, bought drinks and dinners, and still never got the results you were hoping for. Or all the money you’ve spent on nice outfits, dresses, makeup, etc… and yet still haven’t landed that one special man you’ve always wanted.'),

view.el(
['p',36],
null,
'So if you added up the cost of all that, it’s way more than I would ever charge for this life-changing weekend with me.'),

view.el(
['p',37],
null,
'Okay, so how much then? A lot less than you’d think. Remember when I told you that I’ve been studying relationships and attraction and coaching men for 10 years, and they come and stay with me for an entire week? Well depending on the package they choose, they end up paying between $5,000 and $10,000 for a week with me and my instructors.'),

view.el(
['p',38],
null,
'But you don’t have to pay that much. In fact, if I was only charging half of the lowest possible price of $5,000… you’d only be looking at $2,500, but guess what? You won’t even pay that much. In fact, you won’t even pay half of THAT. Listen, I promise this is totally affordable. In fact, it’s honestly a bargain for the quality of private training you’ll be getting.'),

view.el(['img',5],{src:'/images/womensresi/5.jpg'}),
view.el(
['p',39],
null,
'The bottom line is this. When you go to social gatherings, you don’t want to get caught up in that game where all the women are competing with their looks.'),

view.el(
['p',40],
null,
'Yuck! Who wants that?'),

view.el(
['p',41],
null,
'In order to stand out from the other women out there and land an amazing man who wants you for MORE than just your looks, you have to learn how to stimulate him emotionally when you talk to him.'),

view.el(
['bigRed',7],
null,
'That’s What This Weekend Is All About!'),

view.el(
['bigRed',8],
null,
'Gaining Skills With Men That You Can Use For A Lifetime!'),

view.el(
['p',42],
null,
'So are you ready to finally do something for yourself and say “yes” to getting this part of your life handled, once and for all? Would you like to know that you can walk into any room and easily attract the attention of the best men available? Would you like to enjoy interacting with men in a whole new way that gets you far better results… and even the man of your dreams?'),

view.el(
['p',43],
null,
'Then I invite you to join us at Enchant Mr. Right™ Weekend. In order to be considered for the weekend, we need to actually speak with you on the phone to make sure it’s a good fit for the both of us.'),

view.el(
['p',44],
null,
'So go ahead and fill out the form below, and one of my senior coaches will contact you within 24 hours to go over the details with you and help you get ready for your weekend experience. I have to say… I can’t wait to meet you and help you attract that special someone into your life.'),

view.el(
['p',45],
null,
'All that’s left to do is fill out the form now to get the process started. As you probably know, my show on Yahoo! is taking off and more and more women are learning about this. We can only take on a handful of women at each weekend, so be sure to fill out the application now so we can get you in as soon as possible.'),

view.el(
['p',46],
null,
'Go ahead and do that now, and I look forward to meeting you soon.'),

view.el(
['p',47],
null,
view.el(
['i',1],
null,
'–Mehow')));});





$["$"] = function(_,_index){
return {maxWidth:copyWidth.get()};};



$["img"] = function(_,_index){
return {
maxWidth:copyWidth.get()};};


$["bigRed"] = function(_,_index){
return {color:context.colors.get().accent};};


$["resiTitle"] = function(_,_index){
return {color:context.colors.get().accent};};});});})();





//# sourceMappingURL=womensResiCopy.js.map
Flint.start();})(Flint)};